import {useMemo, useCallback} from "react";
import {Config} from "../../config/dist/config.esm.js";
import {Logger} from "../../logger/dist/logger.esm.js";
import {JsonConvert, ValueCheckingMode, JsonProperty, JsonObject, JsonConverter} from "../../../../pkg/json2typescript.js";
import axios from "../../../../pkg/axios.js";
import jstz from "../../../../pkg/jstz.js";
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray$g(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray$g(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$g(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$g(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$g(arr, i) || _nonIterableRest();
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var check = function(it) {
  return it && it.Math == Math && it;
};
var global$17 = check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || function() {
  return this;
}() || Function("return this")();
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var isCallable$o = function(argument) {
  return typeof argument == "function";
};
var isCallable$n = isCallable$o;
var isObject$n = function(it) {
  return typeof it == "object" ? it !== null : isCallable$n(it);
};
var global$16 = global$17;
var isObject$m = isObject$n;
var document$3 = global$16.document;
var EXISTS$1 = isObject$m(document$3) && isObject$m(document$3.createElement);
var documentCreateElement$2 = function(it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};
var documentCreateElement$1 = documentCreateElement$2;
var classList = documentCreateElement$1("span").classList;
var DOMTokenListPrototype$2 = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype$2 === Object.prototype ? void 0 : DOMTokenListPrototype$2;
var fails$D = function(exec2) {
  try {
    return !!exec2();
  } catch (error) {
    return true;
  }
};
var fails$C = fails$D;
var functionBindNative = !fails$C(function() {
  var test2 = function() {
  }.bind();
  return typeof test2 != "function" || test2.hasOwnProperty("prototype");
});
var NATIVE_BIND$4 = functionBindNative;
var FunctionPrototype$3 = Function.prototype;
var bind$a = FunctionPrototype$3.bind;
var call$l = FunctionPrototype$3.call;
var uncurryThis$G = NATIVE_BIND$4 && bind$a.bind(call$l, call$l);
var functionUncurryThis = NATIVE_BIND$4 ? function(fn) {
  return fn && uncurryThis$G(fn);
} : function(fn) {
  return fn && function() {
    return call$l.apply(fn, arguments);
  };
};
var global$15 = global$17;
var String$5 = global$15.String;
var tryToString$5 = function(argument) {
  try {
    return String$5(argument);
  } catch (error) {
    return "Object";
  }
};
var global$14 = global$17;
var isCallable$m = isCallable$o;
var tryToString$4 = tryToString$5;
var TypeError$l = global$14.TypeError;
var aCallable$8 = function(argument) {
  if (isCallable$m(argument))
    return argument;
  throw TypeError$l(tryToString$4(argument) + " is not a function");
};
var uncurryThis$F = functionUncurryThis;
var aCallable$7 = aCallable$8;
var NATIVE_BIND$3 = functionBindNative;
var bind$9 = uncurryThis$F(uncurryThis$F.bind);
var functionBindContext = function(fn, that) {
  aCallable$7(fn);
  return that === void 0 ? fn : NATIVE_BIND$3 ? bind$9(fn, that) : function() {
    return fn.apply(that, arguments);
  };
};
var uncurryThis$E = functionUncurryThis;
var toString$d = uncurryThis$E({}.toString);
var stringSlice$8 = uncurryThis$E("".slice);
var classofRaw$1 = function(it) {
  return stringSlice$8(toString$d(it), 8, -1);
};
var global$13 = global$17;
var uncurryThis$D = functionUncurryThis;
var fails$B = fails$D;
var classof$d = classofRaw$1;
var Object$5 = global$13.Object;
var split = uncurryThis$D("".split);
var indexedObject = fails$B(function() {
  return !Object$5("z").propertyIsEnumerable(0);
}) ? function(it) {
  return classof$d(it) == "String" ? split(it, "") : Object$5(it);
} : Object$5;
var global$12 = global$17;
var TypeError$k = global$12.TypeError;
var requireObjectCoercible$8 = function(it) {
  if (it == void 0)
    throw TypeError$k("Can't call method on " + it);
  return it;
};
var global$11 = global$17;
var requireObjectCoercible$7 = requireObjectCoercible$8;
var Object$4 = global$11.Object;
var toObject$c = function(argument) {
  return Object$4(requireObjectCoercible$7(argument));
};
var ceil = Math.ceil;
var floor$5 = Math.floor;
var toIntegerOrInfinity$8 = function(argument) {
  var number = +argument;
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$5 : ceil)(number);
};
var toIntegerOrInfinity$7 = toIntegerOrInfinity$8;
var min$6 = Math.min;
var toLength$8 = function(argument) {
  return argument > 0 ? min$6(toIntegerOrInfinity$7(argument), 9007199254740991) : 0;
};
var toLength$7 = toLength$8;
var lengthOfArrayLike$e = function(obj) {
  return toLength$7(obj.length);
};
var classof$c = classofRaw$1;
var isArray$4 = Array.isArray || function isArray(argument) {
  return classof$c(argument) == "Array";
};
var shared$5 = {
  exports: {}
};
var global$10 = global$17;
var defineProperty$b = Object.defineProperty;
var setGlobal$3 = function(key, value) {
  try {
    defineProperty$b(global$10, key, {
      value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global$10[key] = value;
  }
  return value;
};
var global$$ = global$17;
var setGlobal$2 = setGlobal$3;
var SHARED = "__core-js_shared__";
var store$3 = global$$[SHARED] || setGlobal$2(SHARED, {});
var sharedStore = store$3;
var store$2 = sharedStore;
(shared$5.exports = function(key, value) {
  return store$2[key] || (store$2[key] = value !== void 0 ? value : {});
})("versions", []).push({
  version: "3.21.0",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.21.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var uncurryThis$C = functionUncurryThis;
var toObject$b = toObject$c;
var hasOwnProperty = uncurryThis$C({}.hasOwnProperty);
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$b(it), key);
};
var uncurryThis$B = functionUncurryThis;
var id$2 = 0;
var postfix = Math.random();
var toString$c = uncurryThis$B(1 .toString);
var uid$5 = function(key) {
  return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString$c(++id$2 + postfix, 36);
};
var global$_ = global$17;
var isCallable$l = isCallable$o;
var aFunction = function(argument) {
  return isCallable$l(argument) ? argument : void 0;
};
var getBuiltIn$9 = function(namespace, method) {
  return arguments.length < 2 ? aFunction(global$_[namespace]) : global$_[namespace] && global$_[namespace][method];
};
var getBuiltIn$8 = getBuiltIn$9;
var engineUserAgent = getBuiltIn$8("navigator", "userAgent") || "";
var global$Z = global$17;
var userAgent$5 = engineUserAgent;
var process$3 = global$Z.process;
var Deno = global$Z.Deno;
var versions = process$3 && process$3.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split(".");
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
if (!version && userAgent$5) {
  match = userAgent$5.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$5.match(/Chrome\/(\d+)/);
    if (match)
      version = +match[1];
  }
}
var engineV8Version = version;
var V8_VERSION$3 = engineV8Version;
var fails$A = fails$D;
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$A(function() {
  var symbol = Symbol();
  return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});
var NATIVE_SYMBOL$3 = nativeSymbol;
var useSymbolAsUid = NATIVE_SYMBOL$3 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var global$Y = global$17;
var shared$4 = shared$5.exports;
var hasOwn$j = hasOwnProperty_1;
var uid$4 = uid$5;
var NATIVE_SYMBOL$2 = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var WellKnownSymbolsStore$1 = shared$4("wks");
var Symbol$1 = global$Y.Symbol;
var symbolFor = Symbol$1 && Symbol$1["for"];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$4;
var wellKnownSymbol$r = function(name) {
  if (!hasOwn$j(WellKnownSymbolsStore$1, name) || !(NATIVE_SYMBOL$2 || typeof WellKnownSymbolsStore$1[name] == "string")) {
    var description = "Symbol." + name;
    if (NATIVE_SYMBOL$2 && hasOwn$j(Symbol$1, name)) {
      WellKnownSymbolsStore$1[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore$1[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore$1[name] = createWellKnownSymbol(description);
    }
  }
  return WellKnownSymbolsStore$1[name];
};
var wellKnownSymbol$q = wellKnownSymbol$r;
var TO_STRING_TAG$4 = wellKnownSymbol$q("toStringTag");
var test = {};
test[TO_STRING_TAG$4] = "z";
var toStringTagSupport = String(test) === "[object z]";
var global$X = global$17;
var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$k = isCallable$o;
var classofRaw = classofRaw$1;
var wellKnownSymbol$p = wellKnownSymbol$r;
var TO_STRING_TAG$3 = wellKnownSymbol$p("toStringTag");
var Object$3 = global$X.Object;
var CORRECT_ARGUMENTS = classofRaw(function() {
  return arguments;
}()) == "Arguments";
var tryGet = function(it, key) {
  try {
    return it[key];
  } catch (error) {
  }
};
var classof$b = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function(it) {
  var O, tag, result;
  return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object$3(it), TO_STRING_TAG$3)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable$k(O.callee) ? "Arguments" : result;
};
var uncurryThis$A = functionUncurryThis;
var isCallable$j = isCallable$o;
var store$1 = sharedStore;
var functionToString$1 = uncurryThis$A(Function.toString);
if (!isCallable$j(store$1.inspectSource)) {
  store$1.inspectSource = function(it) {
    return functionToString$1(it);
  };
}
var inspectSource$4 = store$1.inspectSource;
var uncurryThis$z = functionUncurryThis;
var fails$z = fails$D;
var isCallable$i = isCallable$o;
var classof$a = classof$b;
var getBuiltIn$7 = getBuiltIn$9;
var inspectSource$3 = inspectSource$4;
var noop = function() {
};
var empty = [];
var construct$1 = getBuiltIn$7("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$3 = uncurryThis$z(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$i(argument))
    return false;
  try {
    construct$1(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};
var isConstructorLegacy = function isConstructor2(argument) {
  if (!isCallable$i(argument))
    return false;
  switch (classof$a(argument)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return false;
  }
  try {
    return INCORRECT_TO_STRING || !!exec$3(constructorRegExp, inspectSource$3(argument));
  } catch (error) {
    return true;
  }
};
isConstructorLegacy.sham = true;
var isConstructor$4 = !construct$1 || fails$z(function() {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var global$W = global$17;
var isArray$3 = isArray$4;
var isConstructor$3 = isConstructor$4;
var isObject$l = isObject$n;
var wellKnownSymbol$o = wellKnownSymbol$r;
var SPECIES$6 = wellKnownSymbol$o("species");
var Array$7 = global$W.Array;
var arraySpeciesConstructor$1 = function(originalArray) {
  var C;
  if (isArray$3(originalArray)) {
    C = originalArray.constructor;
    if (isConstructor$3(C) && (C === Array$7 || isArray$3(C.prototype)))
      C = void 0;
    else if (isObject$l(C)) {
      C = C[SPECIES$6];
      if (C === null)
        C = void 0;
    }
  }
  return C === void 0 ? Array$7 : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
var arraySpeciesCreate$2 = function(originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var bind$8 = functionBindContext;
var uncurryThis$y = functionUncurryThis;
var IndexedObject$3 = indexedObject;
var toObject$a = toObject$c;
var lengthOfArrayLike$d = lengthOfArrayLike$e;
var arraySpeciesCreate$1 = arraySpeciesCreate$2;
var push$6 = uncurryThis$y([].push);
var createMethod$5 = function(TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function($this, callbackfn, that, specificCreate) {
    var O = toObject$a($this);
    var self2 = IndexedObject$3(O);
    var boundFunction = bind$8(callbackfn, that);
    var length = lengthOfArrayLike$d(self2);
    var index = 0;
    var create4 = specificCreate || arraySpeciesCreate$1;
    var target = IS_MAP ? create4($this, length) : IS_FILTER || IS_FILTER_REJECT ? create4($this, 0) : void 0;
    var value, result;
    for (; length > index; index++)
      if (NO_HOLES || index in self2) {
        value = self2[index];
        result = boundFunction(value, index, O);
        if (TYPE) {
          if (IS_MAP)
            target[index] = result;
          else if (result)
            switch (TYPE) {
              case 3:
                return true;
              case 5:
                return value;
              case 6:
                return index;
              case 2:
                push$6(target, value);
            }
          else
            switch (TYPE) {
              case 4:
                return false;
              case 7:
                push$6(target, value);
            }
        }
      }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};
var arrayIteration = {
  forEach: createMethod$5(0),
  map: createMethod$5(1),
  filter: createMethod$5(2),
  some: createMethod$5(3),
  every: createMethod$5(4),
  find: createMethod$5(5),
  findIndex: createMethod$5(6),
  filterReject: createMethod$5(7)
};
var fails$y = fails$D;
var arrayMethodIsStrict$3 = function(METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$y(function() {
    method.call(null, argument || function() {
      throw 1;
    }, 1);
  });
};
var $forEach$2 = arrayIteration.forEach;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$3;
var STRICT_METHOD$2 = arrayMethodIsStrict$2("forEach");
var arrayForEach = !STRICT_METHOD$2 ? function forEach(callbackfn) {
  return $forEach$2(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
} : [].forEach;
var fails$x = fails$D;
var descriptors = !fails$x(function() {
  return Object.defineProperty({}, 1, {
    get: function() {
      return 7;
    }
  })[1] != 7;
});
var objectDefineProperty = {};
var DESCRIPTORS$k = descriptors;
var fails$w = fails$D;
var createElement$1 = documentCreateElement$2;
var ie8DomDefine = !DESCRIPTORS$k && !fails$w(function() {
  return Object.defineProperty(createElement$1("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
});
var DESCRIPTORS$j = descriptors;
var fails$v = fails$D;
var v8PrototypeDefineBug = DESCRIPTORS$j && fails$v(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: false
  }).prototype != 42;
});
var global$V = global$17;
var isObject$k = isObject$n;
var String$4 = global$V.String;
var TypeError$j = global$V.TypeError;
var anObject$k = function(argument) {
  if (isObject$k(argument))
    return argument;
  throw TypeError$j(String$4(argument) + " is not an object");
};
var NATIVE_BIND$2 = functionBindNative;
var call$k = Function.prototype.call;
var functionCall = NATIVE_BIND$2 ? call$k.bind(call$k) : function() {
  return call$k.apply(call$k, arguments);
};
var uncurryThis$x = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$x({}.isPrototypeOf);
var global$U = global$17;
var getBuiltIn$6 = getBuiltIn$9;
var isCallable$h = isCallable$o;
var isPrototypeOf$9 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var Object$2 = global$U.Object;
var isSymbol$5 = USE_SYMBOL_AS_UID ? function(it) {
  return typeof it == "symbol";
} : function(it) {
  var $Symbol2 = getBuiltIn$6("Symbol");
  return isCallable$h($Symbol2) && isPrototypeOf$9($Symbol2.prototype, Object$2(it));
};
var aCallable$6 = aCallable$8;
var getMethod$6 = function(V, P) {
  var func = V[P];
  return func == null ? void 0 : aCallable$6(func);
};
var global$T = global$17;
var call$j = functionCall;
var isCallable$g = isCallable$o;
var isObject$j = isObject$n;
var TypeError$i = global$T.TypeError;
var ordinaryToPrimitive$1 = function(input, pref) {
  var fn, val;
  if (pref === "string" && isCallable$g(fn = input.toString) && !isObject$j(val = call$j(fn, input)))
    return val;
  if (isCallable$g(fn = input.valueOf) && !isObject$j(val = call$j(fn, input)))
    return val;
  if (pref !== "string" && isCallable$g(fn = input.toString) && !isObject$j(val = call$j(fn, input)))
    return val;
  throw TypeError$i("Can't convert object to primitive value");
};
var global$S = global$17;
var call$i = functionCall;
var isObject$i = isObject$n;
var isSymbol$4 = isSymbol$5;
var getMethod$5 = getMethod$6;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$n = wellKnownSymbol$r;
var TypeError$h = global$S.TypeError;
var TO_PRIMITIVE$1 = wellKnownSymbol$n("toPrimitive");
var toPrimitive$2 = function(input, pref) {
  if (!isObject$i(input) || isSymbol$4(input))
    return input;
  var exoticToPrim = getMethod$5(input, TO_PRIMITIVE$1);
  var result;
  if (exoticToPrim) {
    if (pref === void 0)
      pref = "default";
    result = call$i(exoticToPrim, input, pref);
    if (!isObject$i(result) || isSymbol$4(result))
      return result;
    throw TypeError$h("Can't convert object to primitive value");
  }
  if (pref === void 0)
    pref = "number";
  return ordinaryToPrimitive(input, pref);
};
var toPrimitive$1 = toPrimitive$2;
var isSymbol$3 = isSymbol$5;
var toPropertyKey$5 = function(argument) {
  var key = toPrimitive$1(argument, "string");
  return isSymbol$3(key) ? key : key + "";
};
var global$R = global$17;
var DESCRIPTORS$i = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$j = anObject$k;
var toPropertyKey$4 = toPropertyKey$5;
var TypeError$g = global$R.TypeError;
var $defineProperty$1 = Object.defineProperty;
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE$1 = "configurable";
var WRITABLE = "writable";
objectDefineProperty.f = DESCRIPTORS$i ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$j(O);
  P = toPropertyKey$4(P);
  anObject$j(Attributes);
  if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$2(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty2(O, P, Attributes) {
  anObject$j(O);
  P = toPropertyKey$4(P);
  anObject$j(Attributes);
  if (IE8_DOM_DEFINE$1)
    try {
      return $defineProperty$1(O, P, Attributes);
    } catch (error) {
    }
  if ("get" in Attributes || "set" in Attributes)
    throw TypeError$g("Accessors not supported");
  if ("value" in Attributes)
    O[P] = Attributes.value;
  return O;
};
var createPropertyDescriptor$6 = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value
  };
};
var DESCRIPTORS$h = descriptors;
var definePropertyModule$7 = objectDefineProperty;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;
var createNonEnumerableProperty$b = DESCRIPTORS$h ? function(object, key, value) {
  return definePropertyModule$7.f(object, key, createPropertyDescriptor$5(1, value));
} : function(object, key, value) {
  object[key] = value;
  return object;
};
var global$Q = global$17;
var DOMIterables$1 = domIterables;
var DOMTokenListPrototype$1 = domTokenListPrototype;
var forEach$1 = arrayForEach;
var createNonEnumerableProperty$a = createNonEnumerableProperty$b;
var handlePrototype$1 = function(CollectionPrototype) {
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach$1)
    try {
      createNonEnumerableProperty$a(CollectionPrototype, "forEach", forEach$1);
    } catch (error) {
      CollectionPrototype.forEach = forEach$1;
    }
};
for (var COLLECTION_NAME$1 in DOMIterables$1) {
  if (DOMIterables$1[COLLECTION_NAME$1]) {
    handlePrototype$1(global$Q[COLLECTION_NAME$1] && global$Q[COLLECTION_NAME$1].prototype);
  }
}
handlePrototype$1(DOMTokenListPrototype$1);
var objectGetOwnPropertyDescriptor = {};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable$2 = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable$2.call({
  1: 2
}, 1);
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$6 = requireObjectCoercible$8;
var toIndexedObject$e = function(it) {
  return IndexedObject$2(requireObjectCoercible$6(it));
};
var DESCRIPTORS$g = descriptors;
var call$h = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;
var toIndexedObject$d = toIndexedObject$e;
var toPropertyKey$3 = toPropertyKey$5;
var hasOwn$i = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$g ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$d(O);
  P = toPropertyKey$3(P);
  if (IE8_DOM_DEFINE)
    try {
      return $getOwnPropertyDescriptor$1(O, P);
    } catch (error) {
    }
  if (hasOwn$i(O, P))
    return createPropertyDescriptor$4(!call$h(propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var redefine$d = {
  exports: {}
};
var global$P = global$17;
var isCallable$f = isCallable$o;
var inspectSource$2 = inspectSource$4;
var WeakMap$2 = global$P.WeakMap;
var nativeWeakMap = isCallable$f(WeakMap$2) && /native code/.test(inspectSource$2(WeakMap$2));
var shared$3 = shared$5.exports;
var uid$3 = uid$5;
var keys$3 = shared$3("keys");
var sharedKey$4 = function(key) {
  return keys$3[key] || (keys$3[key] = uid$3(key));
};
var hiddenKeys$6 = {};
var NATIVE_WEAK_MAP$1 = nativeWeakMap;
var global$O = global$17;
var uncurryThis$w = functionUncurryThis;
var isObject$h = isObject$n;
var createNonEnumerableProperty$9 = createNonEnumerableProperty$b;
var hasOwn$h = hasOwnProperty_1;
var shared$2 = sharedStore;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$5 = hiddenKeys$6;
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$f = global$O.TypeError;
var WeakMap$1 = global$O.WeakMap;
var set$2, get$1, has;
var enforce = function(it) {
  return has(it) ? get$1(it) : set$2(it, {});
};
var getterFor = function(TYPE) {
  return function(it) {
    var state;
    if (!isObject$h(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError$f("Incompatible receiver, " + TYPE + " required");
    }
    return state;
  };
};
if (NATIVE_WEAK_MAP$1 || shared$2.state) {
  var store = shared$2.state || (shared$2.state = new WeakMap$1());
  var wmget = uncurryThis$w(store.get);
  var wmhas = uncurryThis$w(store.has);
  var wmset = uncurryThis$w(store.set);
  set$2 = function(it, metadata) {
    if (wmhas(store, it))
      throw new TypeError$f(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get$1 = function(it) {
    return wmget(store, it) || {};
  };
  has = function(it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$3("state");
  hiddenKeys$5[STATE] = true;
  set$2 = function(it, metadata) {
    if (hasOwn$h(it, STATE))
      throw new TypeError$f(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$9(it, STATE, metadata);
    return metadata;
  };
  get$1 = function(it) {
    return hasOwn$h(it, STATE) ? it[STATE] : {};
  };
  has = function(it) {
    return hasOwn$h(it, STATE);
  };
}
var internalState = {
  set: set$2,
  get: get$1,
  has,
  enforce,
  getterFor
};
var DESCRIPTORS$f = descriptors;
var hasOwn$g = hasOwnProperty_1;
var FunctionPrototype$2 = Function.prototype;
var getDescriptor = DESCRIPTORS$f && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$g(FunctionPrototype$2, "name");
var PROPER = EXISTS && function something() {
}.name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$f || DESCRIPTORS$f && getDescriptor(FunctionPrototype$2, "name").configurable);
var functionName = {
  EXISTS,
  PROPER,
  CONFIGURABLE
};
var global$N = global$17;
var isCallable$e = isCallable$o;
var hasOwn$f = hasOwnProperty_1;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$b;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$4;
var InternalStateModule$8 = internalState;
var CONFIGURABLE_FUNCTION_NAME$2 = functionName.CONFIGURABLE;
var getInternalState$7 = InternalStateModule$8.get;
var enforceInternalState$2 = InternalStateModule$8.enforce;
var TEMPLATE = String(String).split("String");
(redefine$d.exports = function(O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== void 0 ? options.name : key;
  var state;
  if (isCallable$e(value)) {
    if (String(name).slice(0, 7) === "Symbol(") {
      name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    }
    if (!hasOwn$f(value, "name") || CONFIGURABLE_FUNCTION_NAME$2 && value.name !== name) {
      createNonEnumerableProperty$8(value, "name", name);
    }
    state = enforceInternalState$2(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == "string" ? name : "");
    }
  }
  if (O === global$N) {
    if (simple)
      O[key] = value;
    else
      setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple)
    O[key] = value;
  else
    createNonEnumerableProperty$8(O, key, value);
})(Function.prototype, "toString", function toString() {
  return isCallable$e(this) && getInternalState$7(this).source || inspectSource$1(this);
});
var objectGetOwnPropertyNames = {};
var toIntegerOrInfinity$6 = toIntegerOrInfinity$8;
var max$3 = Math.max;
var min$5 = Math.min;
var toAbsoluteIndex$6 = function(index, length) {
  var integer = toIntegerOrInfinity$6(index);
  return integer < 0 ? max$3(integer + length, 0) : min$5(integer, length);
};
var toIndexedObject$c = toIndexedObject$e;
var toAbsoluteIndex$5 = toAbsoluteIndex$6;
var lengthOfArrayLike$c = lengthOfArrayLike$e;
var createMethod$4 = function(IS_INCLUDES) {
  return function($this, el, fromIndex) {
    var O = toIndexedObject$c($this);
    var length = lengthOfArrayLike$c(O);
    var index = toAbsoluteIndex$5(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el)
      while (length > index) {
        value = O[index++];
        if (value != value)
          return true;
      }
    else
      for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el)
          return IS_INCLUDES || index || 0;
      }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  includes: createMethod$4(true),
  indexOf: createMethod$4(false)
};
var uncurryThis$v = functionUncurryThis;
var hasOwn$e = hasOwnProperty_1;
var toIndexedObject$b = toIndexedObject$e;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$4 = hiddenKeys$6;
var push$5 = uncurryThis$v([].push);
var objectKeysInternal = function(object, names) {
  var O = toIndexedObject$b(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O)
    !hasOwn$e(hiddenKeys$4, key) && hasOwn$e(O, key) && push$5(result, key);
  while (names.length > i)
    if (hasOwn$e(O, key = names[i++])) {
      ~indexOf$1(result, key) || push$5(result, key);
    }
  return result;
};
var enumBugKeys$3 = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$3 = enumBugKeys$2.concat("length", "prototype");
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$3);
};
var objectGetOwnPropertySymbols = {};
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$5 = getBuiltIn$9;
var uncurryThis$u = functionUncurryThis;
var getOwnPropertyNamesModule$2 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$i = anObject$k;
var concat$2 = uncurryThis$u([].concat);
var ownKeys$2 = getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
  var keys4 = getOwnPropertyNamesModule$2.f(anObject$i(it));
  var getOwnPropertySymbols3 = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols3 ? concat$2(keys4, getOwnPropertySymbols3(it)) : keys4;
};
var hasOwn$d = hasOwnProperty_1;
var ownKeys$1 = ownKeys$2;
var getOwnPropertyDescriptorModule$3 = objectGetOwnPropertyDescriptor;
var definePropertyModule$6 = objectDefineProperty;
var copyConstructorProperties$2 = function(target, source, exceptions) {
  var keys4 = ownKeys$1(source);
  var defineProperty6 = definePropertyModule$6.f;
  var getOwnPropertyDescriptor6 = getOwnPropertyDescriptorModule$3.f;
  for (var i = 0; i < keys4.length; i++) {
    var key = keys4[i];
    if (!hasOwn$d(target, key) && !(exceptions && hasOwn$d(exceptions, key))) {
      defineProperty6(target, key, getOwnPropertyDescriptor6(source, key));
    }
  }
};
var fails$u = fails$D;
var isCallable$d = isCallable$o;
var replacement = /#|\.prototype\./;
var isForced$5 = function(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : isCallable$d(detection) ? fails$u(detection) : !!detection;
};
var normalize = isForced$5.normalize = function(string) {
  return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced$5.data = {};
var NATIVE = isForced$5.NATIVE = "N";
var POLYFILL = isForced$5.POLYFILL = "P";
var isForced_1 = isForced$5;
var global$M = global$17;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$b;
var redefine$c = redefine$d.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$4 = isForced_1;
var _export = function(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED2, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$M;
  } else if (STATIC) {
    target = global$M[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$M[TARGET] || {}).prototype;
  }
  if (target)
    for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor$3(target, key);
        targetProperty = descriptor && descriptor.value;
      } else
        targetProperty = target[key];
      FORCED2 = isForced$4(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
      if (!FORCED2 && targetProperty !== void 0) {
        if (typeof sourceProperty == typeof targetProperty)
          continue;
        copyConstructorProperties$1(sourceProperty, targetProperty);
      }
      if (options.sham || targetProperty && targetProperty.sham) {
        createNonEnumerableProperty$7(sourceProperty, "sham", true);
      }
      redefine$c(target, key, sourceProperty, options);
    }
};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;
var objectKeys$3 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS$e = descriptors;
var uncurryThis$t = functionUncurryThis;
var objectKeys$2 = objectKeys$3;
var toIndexedObject$a = toIndexedObject$e;
var $propertyIsEnumerable$1 = objectPropertyIsEnumerable.f;
var propertyIsEnumerable2 = uncurryThis$t($propertyIsEnumerable$1);
var push$4 = uncurryThis$t([].push);
var createMethod$3 = function(TO_ENTRIES) {
  return function(it) {
    var O = toIndexedObject$a(it);
    var keys4 = objectKeys$2(O);
    var length = keys4.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys4[i++];
      if (!DESCRIPTORS$e || propertyIsEnumerable2(O, key)) {
        push$4(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};
var objectToArray = {
  entries: createMethod$3(true),
  values: createMethod$3(false)
};
var $$m = _export;
var $entries = objectToArray.entries;
$$m({
  target: "Object",
  stat: true
}, {
  entries: function entries(O) {
    return $entries(O);
  }
});
var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$9 = classof$b;
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString2() {
  return "[object " + classof$9(this) + "]";
};
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$b = redefine$d.exports;
var toString$b = objectToString;
if (!TO_STRING_TAG_SUPPORT) {
  redefine$b(Object.prototype, "toString", toString$b, {
    unsafe: true
  });
}
var global$L = global$17;
var classof$8 = classof$b;
var String$3 = global$L.String;
var toString$a = function(argument) {
  if (classof$8(argument) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return String$3(argument);
};
var anObject$h = anObject$k;
var regexpFlags$1 = function() {
  var that = anObject$h(this);
  var result = "";
  if (that.global)
    result += "g";
  if (that.ignoreCase)
    result += "i";
  if (that.multiline)
    result += "m";
  if (that.dotAll)
    result += "s";
  if (that.unicode)
    result += "u";
  if (that.sticky)
    result += "y";
  return result;
};
var uncurryThis$s = functionUncurryThis;
var PROPER_FUNCTION_NAME$2 = functionName.PROPER;
var redefine$a = redefine$d.exports;
var anObject$g = anObject$k;
var isPrototypeOf$8 = objectIsPrototypeOf;
var $toString$1 = toString$a;
var fails$t = fails$D;
var regExpFlags$1 = regexpFlags$1;
var TO_STRING = "toString";
var RegExpPrototype$2 = RegExp.prototype;
var n$ToString = RegExpPrototype$2[TO_STRING];
var getFlags$1 = uncurryThis$s(regExpFlags$1);
var NOT_GENERIC = fails$t(function() {
  return n$ToString.call({
    source: "a",
    flags: "b"
  }) != "/a/b";
});
var INCORRECT_NAME = PROPER_FUNCTION_NAME$2 && n$ToString.name != TO_STRING;
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$a(RegExp.prototype, TO_STRING, function toString4() {
    var R = anObject$g(this);
    var p = $toString$1(R.source);
    var rf = R.flags;
    var f = $toString$1(rf === void 0 && isPrototypeOf$8(RegExpPrototype$2, R) && !("flags" in RegExpPrototype$2) ? getFlags$1(R) : rf);
    return "/" + p + "/" + f;
  }, {
    unsafe: true
  });
}
var fails$s = fails$D;
var global$K = global$17;
var $RegExp$2 = global$K.RegExp;
var UNSUPPORTED_Y$3 = fails$s(function() {
  var re = $RegExp$2("a", "y");
  re.lastIndex = 2;
  return re.exec("abcd") != null;
});
var MISSED_STICKY$1 = UNSUPPORTED_Y$3 || fails$s(function() {
  return !$RegExp$2("a", "y").sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y$3 || fails$s(function() {
  var re = $RegExp$2("^r", "gy");
  re.lastIndex = 2;
  return re.exec("str") != null;
});
var regexpStickyHelpers = {
  BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY$1,
  UNSUPPORTED_Y: UNSUPPORTED_Y$3
};
var objectDefineProperties = {};
var DESCRIPTORS$d = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$5 = objectDefineProperty;
var anObject$f = anObject$k;
var toIndexedObject$9 = toIndexedObject$e;
var objectKeys$1 = objectKeys$3;
objectDefineProperties.f = DESCRIPTORS$d && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$f(O);
  var props = toIndexedObject$9(Properties);
  var keys4 = objectKeys$1(Properties);
  var length = keys4.length;
  var index = 0;
  var key;
  while (length > index)
    definePropertyModule$5.f(O, key = keys4[index++], props[key]);
  return O;
};
var getBuiltIn$4 = getBuiltIn$9;
var html$2 = getBuiltIn$4("document", "documentElement");
var anObject$e = anObject$k;
var definePropertiesModule$1 = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$6;
var html$1 = html$2;
var documentCreateElement = documentCreateElement$2;
var sharedKey$2 = sharedKey$4;
var GT = ">";
var LT = "<";
var PROTOTYPE$2 = "prototype";
var SCRIPT = "script";
var IE_PROTO$1 = sharedKey$2("IE_PROTO");
var EmptyConstructor = function() {
};
var scriptTag = function(content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function(activeXDocument2) {
  activeXDocument2.write(scriptTag(""));
  activeXDocument2.close();
  var temp = activeXDocument2.parentWindow.Object;
  activeXDocument2 = null;
  return temp;
};
var NullProtoObjectViaIFrame = function() {
  var iframe = documentCreateElement("iframe");
  var JS = "java" + SCRIPT + ":";
  var iframeDocument;
  iframe.style.display = "none";
  html$1.appendChild(iframe);
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag("document.F=Object"));
  iframeDocument.close();
  return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function() {
  try {
    activeXDocument = new ActiveXObject("htmlfile");
  } catch (error) {
  }
  NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
  var length = enumBugKeys.length;
  while (length--)
    delete NullProtoObject[PROTOTYPE$2][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys$2[IE_PROTO$1] = true;
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$2] = anObject$e(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$2] = null;
    result[IE_PROTO$1] = O;
  } else
    result = NullProtoObject();
  return Properties === void 0 ? result : definePropertiesModule$1.f(result, Properties);
};
var fails$r = fails$D;
var global$J = global$17;
var $RegExp$1 = global$J.RegExp;
var regexpUnsupportedDotAll = fails$r(function() {
  var re = $RegExp$1(".", "s");
  return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var fails$q = fails$D;
var global$I = global$17;
var $RegExp = global$I.RegExp;
var regexpUnsupportedNcg = fails$q(function() {
  var re = $RegExp("(?<a>b)", "g");
  return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
var call$g = functionCall;
var uncurryThis$r = functionUncurryThis;
var toString$9 = toString$a;
var regexpFlags = regexpFlags$1;
var stickyHelpers$2 = regexpStickyHelpers;
var shared$1 = shared$5.exports;
var create$5 = objectCreate;
var getInternalState$6 = internalState.get;
var UNSUPPORTED_DOT_ALL$1 = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG$1 = regexpUnsupportedNcg;
var nativeReplace = shared$1("native-string-replace", String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$5 = uncurryThis$r("".charAt);
var indexOf = uncurryThis$r("".indexOf);
var replace$4 = uncurryThis$r("".replace);
var stringSlice$7 = uncurryThis$r("".slice);
var UPDATES_LAST_INDEX_WRONG = function() {
  var re12 = /a/;
  var re22 = /b*/g;
  call$g(nativeExec, re12, "a");
  call$g(nativeExec, re22, "a");
  return re12.lastIndex !== 0 || re22.lastIndex !== 0;
}();
var UNSUPPORTED_Y$2 = stickyHelpers$2.BROKEN_CARET;
var NPCG_INCLUDED = /()??/.exec("")[1] !== void 0;
var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$2 || UNSUPPORTED_DOT_ALL$1 || UNSUPPORTED_NCG$1;
if (PATCH) {
  patchedExec = function exec2(string) {
    var re = this;
    var state = getInternalState$6(re);
    var str = toString$9(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match2, i, object, group;
    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$g(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }
    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$2 && re.sticky;
    var flags = call$g(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
      flags = replace$4(flags, "y", "");
      if (indexOf(flags, "g") === -1) {
        flags += "g";
      }
      strCopy = stringSlice$7(str, re.lastIndex);
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$5(str, re.lastIndex - 1) !== "\n")) {
        source = "(?: " + source + ")";
        strCopy = " " + strCopy;
        charsAdded++;
      }
      reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if (NPCG_INCLUDED) {
      reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    }
    if (UPDATES_LAST_INDEX_WRONG)
      lastIndex = re.lastIndex;
    match2 = call$g(nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
      if (match2) {
        match2.input = stringSlice$7(match2.input, charsAdded);
        match2[0] = stringSlice$7(match2[0], charsAdded);
        match2.index = re.lastIndex;
        re.lastIndex += match2[0].length;
      } else
        re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match2) {
      re.lastIndex = re.global ? match2.index + match2[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match2 && match2.length > 1) {
      call$g(nativeReplace, match2[0], reCopy, function() {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === void 0)
            match2[i] = void 0;
        }
      });
    }
    if (match2 && groups) {
      match2.groups = object = create$5(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match2[group[1]];
      }
    }
    return match2;
  };
}
var regexpExec$3 = patchedExec;
var $$l = _export;
var exec$2 = regexpExec$3;
$$l({
  target: "RegExp",
  proto: true,
  forced: /./.exec !== exec$2
}, {
  exec: exec$2
});
var NATIVE_BIND$1 = functionBindNative;
var FunctionPrototype$1 = Function.prototype;
var apply$8 = FunctionPrototype$1.apply;
var call$f = FunctionPrototype$1.call;
var functionApply = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND$1 ? call$f.bind(apply$8) : function() {
  return call$f.apply(apply$8, arguments);
});
var uncurryThis$q = functionUncurryThis;
var redefine$9 = redefine$d.exports;
var regexpExec$2 = regexpExec$3;
var fails$p = fails$D;
var wellKnownSymbol$m = wellKnownSymbol$r;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$b;
var SPECIES$5 = wellKnownSymbol$m("species");
var RegExpPrototype$1 = RegExp.prototype;
var fixRegexpWellKnownSymbolLogic = function(KEY, exec2, FORCED2, SHAM) {
  var SYMBOL2 = wellKnownSymbol$m(KEY);
  var DELEGATES_TO_SYMBOL = !fails$p(function() {
    var O = {};
    O[SYMBOL2] = function() {
      return 7;
    };
    return ""[KEY](O) != 7;
  });
  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$p(function() {
    var execCalled = false;
    var re = /a/;
    if (KEY === "split") {
      re = {};
      re.constructor = {};
      re.constructor[SPECIES$5] = function() {
        return re;
      };
      re.flags = "";
      re[SYMBOL2] = /./[SYMBOL2];
    }
    re.exec = function() {
      execCalled = true;
      return null;
    };
    re[SYMBOL2]("");
    return !execCalled;
  });
  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED2) {
    var uncurriedNativeRegExpMethod = uncurryThis$q(/./[SYMBOL2]);
    var methods = exec2(SYMBOL2, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$q(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype$1.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          return {
            done: true,
            value: uncurriedNativeRegExpMethod(regexp, str, arg2)
          };
        }
        return {
          done: true,
          value: uncurriedNativeMethod(str, regexp, arg2)
        };
      }
      return {
        done: false
      };
    });
    redefine$9(String.prototype, KEY, methods[0]);
    redefine$9(RegExpPrototype$1, SYMBOL2, methods[1]);
  }
  if (SHAM)
    createNonEnumerableProperty$6(RegExpPrototype$1[SYMBOL2], "sham", true);
};
var uncurryThis$p = functionUncurryThis;
var toIntegerOrInfinity$5 = toIntegerOrInfinity$8;
var toString$8 = toString$a;
var requireObjectCoercible$5 = requireObjectCoercible$8;
var charAt$4 = uncurryThis$p("".charAt);
var charCodeAt$1 = uncurryThis$p("".charCodeAt);
var stringSlice$6 = uncurryThis$p("".slice);
var createMethod$2 = function(CONVERT_TO_STRING) {
  return function($this, pos) {
    var S = toString$8(requireObjectCoercible$5($this));
    var position = toIntegerOrInfinity$5(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size)
      return CONVERT_TO_STRING ? "" : void 0;
    first = charCodeAt$1(S, position);
    return first < 55296 || first > 56319 || position + 1 === size || (second = charCodeAt$1(S, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt$4(S, position) : first : CONVERT_TO_STRING ? stringSlice$6(S, position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
  };
};
var stringMultibyte = {
  codeAt: createMethod$2(false),
  charAt: createMethod$2(true)
};
var charAt$3 = stringMultibyte.charAt;
var advanceStringIndex$2 = function(S, index, unicode) {
  return index + (unicode ? charAt$3(S, index).length : 1);
};
var uncurryThis$o = functionUncurryThis;
var toObject$9 = toObject$c;
var floor$4 = Math.floor;
var charAt$2 = uncurryThis$o("".charAt);
var replace$3 = uncurryThis$o("".replace);
var stringSlice$5 = uncurryThis$o("".slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
var getSubstitution$1 = function(matched, str, position, captures, namedCaptures, replacement2) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== void 0) {
    namedCaptures = toObject$9(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$3(replacement2, symbols, function(match2, ch) {
    var capture;
    switch (charAt$2(ch, 0)) {
      case "$":
        return "$";
      case "&":
        return matched;
      case "`":
        return stringSlice$5(str, 0, position);
      case "'":
        return stringSlice$5(str, tailPos);
      case "<":
        capture = namedCaptures[stringSlice$5(ch, 1, -1)];
        break;
      default:
        var n = +ch;
        if (n === 0)
          return match2;
        if (n > m) {
          var f = floor$4(n / 10);
          if (f === 0)
            return match2;
          if (f <= m)
            return captures[f - 1] === void 0 ? charAt$2(ch, 1) : captures[f - 1] + charAt$2(ch, 1);
          return match2;
        }
        capture = captures[n - 1];
    }
    return capture === void 0 ? "" : capture;
  });
};
var global$H = global$17;
var call$e = functionCall;
var anObject$d = anObject$k;
var isCallable$c = isCallable$o;
var classof$7 = classofRaw$1;
var regexpExec$1 = regexpExec$3;
var TypeError$e = global$H.TypeError;
var regexpExecAbstract = function(R, S) {
  var exec2 = R.exec;
  if (isCallable$c(exec2)) {
    var result = call$e(exec2, R, S);
    if (result !== null)
      anObject$d(result);
    return result;
  }
  if (classof$7(R) === "RegExp")
    return call$e(regexpExec$1, R, S);
  throw TypeError$e("RegExp#exec called on incompatible receiver");
};
var apply$7 = functionApply;
var call$d = functionCall;
var uncurryThis$n = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var fails$o = fails$D;
var anObject$c = anObject$k;
var isCallable$b = isCallable$o;
var toIntegerOrInfinity$4 = toIntegerOrInfinity$8;
var toLength$6 = toLength$8;
var toString$7 = toString$a;
var requireObjectCoercible$4 = requireObjectCoercible$8;
var advanceStringIndex$1 = advanceStringIndex$2;
var getMethod$4 = getMethod$6;
var getSubstitution = getSubstitution$1;
var regExpExec$2 = regexpExecAbstract;
var wellKnownSymbol$l = wellKnownSymbol$r;
var REPLACE = wellKnownSymbol$l("replace");
var max$2 = Math.max;
var min$4 = Math.min;
var concat$1 = uncurryThis$n([].concat);
var push$3 = uncurryThis$n([].push);
var stringIndexOf$1 = uncurryThis$n("".indexOf);
var stringSlice$4 = uncurryThis$n("".slice);
var maybeToString = function(it) {
  return it === void 0 ? it : String(it);
};
var REPLACE_KEEPS_$0 = function() {
  return "a".replace(/./, "$0") === "$0";
}();
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
  if (/./[REPLACE]) {
    return /./[REPLACE]("a", "$0") === "";
  }
  return false;
}();
var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$o(function() {
  var re = /./;
  re.exec = function() {
    var result = [];
    result.groups = {
      a: "7"
    };
    return result;
  };
  return "".replace(re, "$<a>") !== "7";
});
fixRegExpWellKnownSymbolLogic$2("replace", function(_, nativeReplace2, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
  return [
    function replace2(searchValue, replaceValue) {
      var O = requireObjectCoercible$4(this);
      var replacer = searchValue == void 0 ? void 0 : getMethod$4(searchValue, REPLACE);
      return replacer ? call$d(replacer, searchValue, O, replaceValue) : call$d(nativeReplace2, toString$7(O), searchValue, replaceValue);
    },
    function(string, replaceValue) {
      var rx = anObject$c(this);
      var S = toString$7(string);
      if (typeof replaceValue == "string" && stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 && stringIndexOf$1(replaceValue, "$<") === -1) {
        var res = maybeCallNative(nativeReplace2, rx, S, replaceValue);
        if (res.done)
          return res.value;
      }
      var functionalReplace = isCallable$b(replaceValue);
      if (!functionalReplace)
        replaceValue = toString$7(replaceValue);
      var global2 = rx.global;
      if (global2) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$2(rx, S);
        if (result === null)
          break;
        push$3(results, result);
        if (!global2)
          break;
        var matchStr = toString$7(result[0]);
        if (matchStr === "")
          rx.lastIndex = advanceStringIndex$1(S, toLength$6(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = "";
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = toString$7(result[0]);
        var position = max$2(min$4(toIntegerOrInfinity$4(result.index), S.length), 0);
        var captures = [];
        for (var j = 1; j < result.length; j++)
          push$3(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== void 0)
            push$3(replacerArgs, namedCaptures);
          var replacement2 = toString$7(apply$7(replaceValue, void 0, replacerArgs));
        } else {
          replacement2 = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$4(S, nextSourcePosition, position) + replacement2;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice$4(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
function generateAuthHeader(jwt) {
  return !jwt ? void 0 : {
    authorization: "jwt ".concat(jwt)
  };
}
function toFormData(content) {
  var formData = new FormData();
  Object.entries(content).forEach(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
    var v;
    if (typeof value === "number" || typeof value === "boolean") {
      v = value.toString();
    } else {
      v = value;
    }
    formData.append(key, v);
  });
  return formData;
}
function leoRedirect(path2) {
  var url = window.location.origin + window.location.pathname + "#/" + path2;
  if (window.location.href !== url) {
    window.location.replace(url);
  }
}
function httpInterceptorErrorMaintenance(error) {
  var _a;
  if (((_a = error == null ? void 0 : error.response) == null ? void 0 : _a.status) === 503) {
    leoRedirect("maintenance");
  }
}
var toPropertyKey$2 = toPropertyKey$5;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;
var createProperty$6 = function(object, key, value) {
  var propertyKey = toPropertyKey$2(key);
  if (propertyKey in object)
    definePropertyModule$4.f(object, propertyKey, createPropertyDescriptor$3(0, value));
  else
    object[propertyKey] = value;
};
var fails$n = fails$D;
var wellKnownSymbol$k = wellKnownSymbol$r;
var V8_VERSION$2 = engineV8Version;
var SPECIES$4 = wellKnownSymbol$k("species");
var arrayMethodHasSpeciesSupport$4 = function(METHOD_NAME) {
  return V8_VERSION$2 >= 51 || !fails$n(function() {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$4] = function() {
      return {
        foo: 1
      };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};
var uncurryThis$m = functionUncurryThis;
var arraySlice$a = uncurryThis$m([].slice);
var $$k = _export;
var global$G = global$17;
var isArray$2 = isArray$4;
var isConstructor$2 = isConstructor$4;
var isObject$g = isObject$n;
var toAbsoluteIndex$4 = toAbsoluteIndex$6;
var lengthOfArrayLike$b = lengthOfArrayLike$e;
var toIndexedObject$8 = toIndexedObject$e;
var createProperty$5 = createProperty$6;
var wellKnownSymbol$j = wellKnownSymbol$r;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$4;
var un$Slice = arraySlice$a;
var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$3("slice");
var SPECIES$3 = wellKnownSymbol$j("species");
var Array$6 = global$G.Array;
var max$1 = Math.max;
$$k({
  target: "Array",
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$2
}, {
  slice: function slice(start, end) {
    var O = toIndexedObject$8(this);
    var length = lengthOfArrayLike$b(O);
    var k = toAbsoluteIndex$4(start, length);
    var fin = toAbsoluteIndex$4(end === void 0 ? length : end, length);
    var Constructor2, result, n;
    if (isArray$2(O)) {
      Constructor2 = O.constructor;
      if (isConstructor$2(Constructor2) && (Constructor2 === Array$6 || isArray$2(Constructor2.prototype))) {
        Constructor2 = void 0;
      } else if (isObject$g(Constructor2)) {
        Constructor2 = Constructor2[SPECIES$3];
        if (Constructor2 === null)
          Constructor2 = void 0;
      }
      if (Constructor2 === Array$6 || Constructor2 === void 0) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor2 === void 0 ? Array$6 : Constructor2)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++)
      if (k in O)
        createProperty$5(result, n, O[k]);
    result.length = n;
    return result;
  }
});
var DESCRIPTORS$c = descriptors;
var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var uncurryThis$l = functionUncurryThis;
var defineProperty$a = objectDefineProperty.f;
var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis$l(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec$1 = uncurryThis$l(nameRE.exec);
var NAME$1 = "name";
if (DESCRIPTORS$c && !FUNCTION_NAME_EXISTS) {
  defineProperty$a(FunctionPrototype, NAME$1, {
    configurable: true,
    get: function() {
      try {
        return regExpExec$1(nameRE, functionToString(this))[1];
      } catch (error) {
        return "";
      }
    }
  });
}
var call$c = functionCall;
var anObject$b = anObject$k;
var getMethod$3 = getMethod$6;
var iteratorClose$2 = function(iterator, kind, value) {
  var innerResult, innerError;
  anObject$b(iterator);
  try {
    innerResult = getMethod$3(iterator, "return");
    if (!innerResult) {
      if (kind === "throw")
        throw value;
      return value;
    }
    innerResult = call$c(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === "throw")
    throw value;
  if (innerError)
    throw innerResult;
  anObject$b(innerResult);
  return value;
};
var anObject$a = anObject$k;
var iteratorClose$1 = iteratorClose$2;
var callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES2) {
  try {
    return ENTRIES2 ? fn(anObject$a(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, "throw", error);
  }
};
var iterators = {};
var wellKnownSymbol$i = wellKnownSymbol$r;
var Iterators$4 = iterators;
var ITERATOR$6 = wellKnownSymbol$i("iterator");
var ArrayPrototype$1 = Array.prototype;
var isArrayIteratorMethod$3 = function(it) {
  return it !== void 0 && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$6] === it);
};
var classof$6 = classof$b;
var getMethod$2 = getMethod$6;
var Iterators$3 = iterators;
var wellKnownSymbol$h = wellKnownSymbol$r;
var ITERATOR$5 = wellKnownSymbol$h("iterator");
var getIteratorMethod$4 = function(it) {
  if (it != void 0)
    return getMethod$2(it, ITERATOR$5) || getMethod$2(it, "@@iterator") || Iterators$3[classof$6(it)];
};
var global$F = global$17;
var call$b = functionCall;
var aCallable$5 = aCallable$8;
var anObject$9 = anObject$k;
var tryToString$3 = tryToString$5;
var getIteratorMethod$3 = getIteratorMethod$4;
var TypeError$d = global$F.TypeError;
var getIterator$3 = function(argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
  if (aCallable$5(iteratorMethod))
    return anObject$9(call$b(iteratorMethod, argument));
  throw TypeError$d(tryToString$3(argument) + " is not iterable");
};
var global$E = global$17;
var bind$7 = functionBindContext;
var call$a = functionCall;
var toObject$8 = toObject$c;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod$2 = isArrayIteratorMethod$3;
var isConstructor$1 = isConstructor$4;
var lengthOfArrayLike$a = lengthOfArrayLike$e;
var createProperty$4 = createProperty$6;
var getIterator$2 = getIterator$3;
var getIteratorMethod$2 = getIteratorMethod$4;
var Array$5 = global$E.Array;
var arrayFrom = function from(arrayLike) {
  var O = toObject$8(arrayLike);
  var IS_CONSTRUCTOR = isConstructor$1(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
  var mapping = mapfn !== void 0;
  if (mapping)
    mapfn = bind$7(mapfn, argumentsLength > 2 ? arguments[2] : void 0);
  var iteratorMethod = getIteratorMethod$2(O);
  var index = 0;
  var length, result, step, iterator, next2, value;
  if (iteratorMethod && !(this == Array$5 && isArrayIteratorMethod$2(iteratorMethod))) {
    iterator = getIterator$2(O, iteratorMethod);
    next2 = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (; !(step = call$a(next2, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$4(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$a(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array$5(length);
    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$4(result, index, value);
    }
  }
  result.length = index;
  return result;
};
var wellKnownSymbol$g = wellKnownSymbol$r;
var ITERATOR$4 = wellKnownSymbol$g("iterator");
var SAFE_CLOSING = false;
try {
  var called = 0;
  var iteratorWithReturn = {
    next: function() {
      return {
        done: !!called++
      };
    },
    return: function() {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$4] = function() {
    return this;
  };
  Array.from(iteratorWithReturn, function() {
    throw 2;
  });
} catch (error) {
}
var checkCorrectnessOfIteration$4 = function(exec2, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING)
    return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$4] = function() {
      return {
        next: function() {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };
    exec2(object);
  } catch (error) {
  }
  return ITERATION_SUPPORT;
};
var $$j = _export;
var from2 = arrayFrom;
var checkCorrectnessOfIteration$3 = checkCorrectnessOfIteration$4;
var INCORRECT_ITERATION$1 = !checkCorrectnessOfIteration$3(function(iterable) {
  Array.from(iterable);
});
$$j({
  target: "Array",
  stat: true,
  forced: INCORRECT_ITERATION$1
}, {
  from: from2
});
var fails$m = fails$D;
var correctPrototypeGetter = !fails$m(function() {
  function F() {
  }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var global$D = global$17;
var hasOwn$c = hasOwnProperty_1;
var isCallable$a = isCallable$o;
var toObject$7 = toObject$c;
var sharedKey$1 = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var IE_PROTO = sharedKey$1("IE_PROTO");
var Object$1 = global$D.Object;
var ObjectPrototype$4 = Object$1.prototype;
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$1.getPrototypeOf : function(O) {
  var object = toObject$7(O);
  if (hasOwn$c(object, IE_PROTO))
    return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$a(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof Object$1 ? ObjectPrototype$4 : null;
};
var fails$l = fails$D;
var isCallable$9 = isCallable$o;
var getPrototypeOf$3 = objectGetPrototypeOf;
var redefine$8 = redefine$d.exports;
var wellKnownSymbol$f = wellKnownSymbol$r;
var ITERATOR$3 = wellKnownSymbol$f("iterator");
var BUGGY_SAFARI_ITERATORS$1 = false;
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;
if ([].keys) {
  arrayIterator = [].keys();
  if (!("next" in arrayIterator))
    BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$3(getPrototypeOf$3(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
      IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == void 0 || fails$l(function() {
  var test2 = {};
  return IteratorPrototype$2[ITERATOR$3].call(test2) !== test2;
});
if (NEW_ITERATOR_PROTOTYPE)
  IteratorPrototype$2 = {};
if (!isCallable$9(IteratorPrototype$2[ITERATOR$3])) {
  redefine$8(IteratorPrototype$2, ITERATOR$3, function() {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var defineProperty$9 = objectDefineProperty.f;
var hasOwn$b = hasOwnProperty_1;
var wellKnownSymbol$e = wellKnownSymbol$r;
var TO_STRING_TAG$2 = wellKnownSymbol$e("toStringTag");
var setToStringTag$6 = function(target, TAG, STATIC) {
  if (target && !STATIC)
    target = target.prototype;
  if (target && !hasOwn$b(target, TO_STRING_TAG$2)) {
    defineProperty$9(target, TO_STRING_TAG$2, {
      configurable: true,
      value: TAG
    });
  }
};
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$4 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;
var setToStringTag$5 = setToStringTag$6;
var Iterators$2 = iterators;
var returnThis$1 = function() {
  return this;
};
var createIteratorConstructor$1 = function(IteratorConstructor, NAME2, next2, ENUMERABLE_NEXT) {
  var TO_STRING_TAG2 = NAME2 + " Iterator";
  IteratorConstructor.prototype = create$4(IteratorPrototype$1, {
    next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next2)
  });
  setToStringTag$5(IteratorConstructor, TO_STRING_TAG2, false);
  Iterators$2[TO_STRING_TAG2] = returnThis$1;
  return IteratorConstructor;
};
var global$C = global$17;
var isCallable$8 = isCallable$o;
var String$2 = global$C.String;
var TypeError$c = global$C.TypeError;
var aPossiblePrototype$1 = function(argument) {
  if (typeof argument == "object" || isCallable$8(argument))
    return argument;
  throw TypeError$c("Can't set " + String$2(argument) + " as a prototype");
};
var uncurryThis$k = functionUncurryThis;
var anObject$8 = anObject$k;
var aPossiblePrototype = aPossiblePrototype$1;
var objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var CORRECT_SETTER = false;
  var test2 = {};
  var setter;
  try {
    setter = uncurryThis$k(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
    setter(test2, []);
    CORRECT_SETTER = test2 instanceof Array;
  } catch (error) {
  }
  return function setPrototypeOf2(O, proto) {
    anObject$8(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER)
      setter(O, proto);
    else
      O.__proto__ = proto;
    return O;
  };
}() : void 0);
var $$i = _export;
var call$9 = functionCall;
var FunctionName$1 = functionName;
var isCallable$7 = isCallable$o;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf$2 = objectGetPrototypeOf;
var setPrototypeOf$5 = objectSetPrototypeOf;
var setToStringTag$4 = setToStringTag$6;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$b;
var redefine$7 = redefine$d.exports;
var wellKnownSymbol$d = wellKnownSymbol$r;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;
var PROPER_FUNCTION_NAME$1 = FunctionName$1.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = FunctionName$1.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$2 = wellKnownSymbol$d("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";
var returnThis = function() {
  return this;
};
var defineIterator$3 = function(Iterable, NAME2, IteratorConstructor, next2, DEFAULT, IS_SET, FORCED2) {
  createIteratorConstructor(IteratorConstructor, NAME2, next2);
  var getIterationMethod = function(KIND) {
    if (KIND === DEFAULT && defaultIterator)
      return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
      return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys4() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values3() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries3() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function() {
      return new IteratorConstructor(this);
    };
  };
  var TO_STRING_TAG2 = NAME2 + " Iterator";
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$2] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME2 == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$2(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$5) {
          setPrototypeOf$5(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$2])) {
          redefine$7(CurrentIteratorPrototype, ITERATOR$2, returnThis);
        }
      }
      setToStringTag$4(CurrentIteratorPrototype, TO_STRING_TAG2, true);
    }
  }
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty$5(IterablePrototype, "name", VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values3() {
        return call$9(nativeIterator, this);
      };
    }
  }
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED2)
      for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine$7(IterablePrototype, KEY, methods[KEY]);
        }
      }
    else
      $$i({
        target: NAME2,
        proto: true,
        forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
      }, methods);
  }
  if (IterablePrototype[ITERATOR$2] !== defaultIterator) {
    redefine$7(IterablePrototype, ITERATOR$2, defaultIterator, {
      name: DEFAULT
    });
  }
  Iterators$1[NAME2] = defaultIterator;
  return methods;
};
var charAt$1 = stringMultibyte.charAt;
var toString$6 = toString$a;
var InternalStateModule$7 = internalState;
var defineIterator$2 = defineIterator$3;
var STRING_ITERATOR = "String Iterator";
var setInternalState$7 = InternalStateModule$7.set;
var getInternalState$5 = InternalStateModule$7.getterFor(STRING_ITERATOR);
defineIterator$2(String, "String", function(iterated) {
  setInternalState$7(this, {
    type: STRING_ITERATOR,
    string: toString$6(iterated),
    index: 0
  });
}, function next() {
  var state = getInternalState$5(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length)
    return {
      value: void 0,
      done: true
    };
  point = charAt$1(string, index);
  state.index += point.length;
  return {
    value: point,
    done: false
  };
});
var $$h = _export;
var DESCRIPTORS$b = descriptors;
var global$B = global$17;
var uncurryThis$j = functionUncurryThis;
var hasOwn$a = hasOwnProperty_1;
var isCallable$6 = isCallable$o;
var isPrototypeOf$7 = objectIsPrototypeOf;
var toString$5 = toString$a;
var defineProperty$8 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;
var NativeSymbol = global$B.Symbol;
var SymbolPrototype$1 = NativeSymbol && NativeSymbol.prototype;
if (DESCRIPTORS$b && isCallable$6(NativeSymbol) && (!("description" in SymbolPrototype$1) || NativeSymbol().description !== void 0)) {
  var EmptyStringDescriptionStore = {};
  var SymbolWrapper = function Symbol2() {
    var description = arguments.length < 1 || arguments[0] === void 0 ? void 0 : toString$5(arguments[0]);
    var result = isPrototypeOf$7(SymbolPrototype$1, this) ? new NativeSymbol(description) : description === void 0 ? NativeSymbol() : NativeSymbol(description);
    if (description === "")
      EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype$1;
  SymbolPrototype$1.constructor = SymbolWrapper;
  var NATIVE_SYMBOL$1 = String(NativeSymbol("test")) == "Symbol(test)";
  var symbolToString = uncurryThis$j(SymbolPrototype$1.toString);
  var symbolValueOf = uncurryThis$j(SymbolPrototype$1.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$2 = uncurryThis$j("".replace);
  var stringSlice$3 = uncurryThis$j("".slice);
  defineProperty$8(SymbolPrototype$1, "description", {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn$a(EmptyStringDescriptionStore, symbol))
        return "";
      var desc = NATIVE_SYMBOL$1 ? stringSlice$3(string, 7, -1) : replace$2(string, regexp, "$1");
      return desc === "" ? void 0 : desc;
    }
  });
  $$h({
    global: true,
    forced: true
  }, {
    Symbol: SymbolWrapper
  });
}
var global$A = global$17;
var path$1 = global$A;
var wellKnownSymbolWrapped = {};
var wellKnownSymbol$c = wellKnownSymbol$r;
wellKnownSymbolWrapped.f = wellKnownSymbol$c;
var path = path$1;
var hasOwn$9 = hasOwnProperty_1;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$7 = objectDefineProperty.f;
var defineWellKnownSymbol$2 = function(NAME2) {
  var Symbol2 = path.Symbol || (path.Symbol = {});
  if (!hasOwn$9(Symbol2, NAME2))
    defineProperty$7(Symbol2, NAME2, {
      value: wrappedWellKnownSymbolModule$1.f(NAME2)
    });
};
var defineWellKnownSymbol$1 = defineWellKnownSymbol$2;
defineWellKnownSymbol$1("iterator");
var wellKnownSymbol$b = wellKnownSymbol$r;
var create$3 = objectCreate;
var definePropertyModule$3 = objectDefineProperty;
var UNSCOPABLES = wellKnownSymbol$b("unscopables");
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] == void 0) {
  definePropertyModule$3.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}
var addToUnscopables$3 = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};
var toIndexedObject$7 = toIndexedObject$e;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators = iterators;
var InternalStateModule$6 = internalState;
var defineProperty$6 = objectDefineProperty.f;
var defineIterator$1 = defineIterator$3;
var DESCRIPTORS$a = descriptors;
var ARRAY_ITERATOR = "Array Iterator";
var setInternalState$6 = InternalStateModule$6.set;
var getInternalState$4 = InternalStateModule$6.getterFor(ARRAY_ITERATOR);
var es_array_iterator = defineIterator$1(Array, "Array", function(iterated, kind) {
  setInternalState$6(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$7(iterated),
    index: 0,
    kind
  });
}, function() {
  var state = getInternalState$4(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = void 0;
    return {
      value: void 0,
      done: true
    };
  }
  if (kind == "keys")
    return {
      value: index,
      done: false
    };
  if (kind == "values")
    return {
      value: target[index],
      done: false
    };
  return {
    value: [index, target[index]],
    done: false
  };
}, "values");
var values = Iterators.Arguments = Iterators.Array;
addToUnscopables$2("keys");
addToUnscopables$2("values");
addToUnscopables$2("entries");
if (DESCRIPTORS$a && values.name !== "values")
  try {
    defineProperty$6(values, "name", {
      value: "values"
    });
  } catch (error) {
  }
var global$z = global$17;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$b;
var wellKnownSymbol$a = wellKnownSymbol$r;
var ITERATOR$1 = wellKnownSymbol$a("iterator");
var TO_STRING_TAG$1 = wellKnownSymbol$a("toStringTag");
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    if (CollectionPrototype[ITERATOR$1] !== ArrayValues)
      try {
        createNonEnumerableProperty$4(CollectionPrototype, ITERATOR$1, ArrayValues);
      } catch (error) {
        CollectionPrototype[ITERATOR$1] = ArrayValues;
      }
    if (!CollectionPrototype[TO_STRING_TAG$1]) {
      createNonEnumerableProperty$4(CollectionPrototype, TO_STRING_TAG$1, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME])
      for (var METHOD_NAME in ArrayIteratorMethods) {
        if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME])
          try {
            createNonEnumerableProperty$4(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
          } catch (error) {
            CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
          }
      }
  }
};
for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$z[COLLECTION_NAME] && global$z[COLLECTION_NAME].prototype, COLLECTION_NAME);
}
handlePrototype(DOMTokenListPrototype, "DOMTokenList");
var global$y = global$17;
var uncurryThis$i = functionUncurryThis;
var aCallable$4 = aCallable$8;
var isObject$f = isObject$n;
var hasOwn$8 = hasOwnProperty_1;
var arraySlice$9 = arraySlice$a;
var NATIVE_BIND = functionBindNative;
var Function$2 = global$y.Function;
var concat = uncurryThis$i([].concat);
var join$1 = uncurryThis$i([].join);
var factories = {};
var construct = function(C, argsLength, args) {
  if (!hasOwn$8(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++)
      list[i] = "a[" + i + "]";
    factories[argsLength] = Function$2("C,a", "return new C(" + join$1(list, ",") + ")");
  }
  return factories[argsLength](C, args);
};
var functionBind = NATIVE_BIND ? Function$2.bind : function bind(that) {
  var F = aCallable$4(this);
  var Prototype2 = F.prototype;
  var partArgs = arraySlice$9(arguments, 1);
  var boundFunction = function bound() {
    var args = concat(partArgs, arraySlice$9(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject$f(Prototype2))
    boundFunction.prototype = Prototype2;
  return boundFunction;
};
var global$x = global$17;
var isConstructor3 = isConstructor$4;
var tryToString$2 = tryToString$5;
var TypeError$b = global$x.TypeError;
var aConstructor$3 = function(argument) {
  if (isConstructor3(argument))
    return argument;
  throw TypeError$b(tryToString$2(argument) + " is not a constructor");
};
var $$g = _export;
var getBuiltIn$3 = getBuiltIn$9;
var apply$6 = functionApply;
var bind$6 = functionBind;
var aConstructor$2 = aConstructor$3;
var anObject$7 = anObject$k;
var isObject$e = isObject$n;
var create$2 = objectCreate;
var fails$k = fails$D;
var nativeConstruct = getBuiltIn$3("Reflect", "construct");
var ObjectPrototype$3 = Object.prototype;
var push$2 = [].push;
var NEW_TARGET_BUG = fails$k(function() {
  function F() {
  }
  return !(nativeConstruct(function() {
  }, [], F) instanceof F);
});
var ARGS_BUG = !fails$k(function() {
  nativeConstruct(function() {
  });
});
var FORCED$6 = NEW_TARGET_BUG || ARGS_BUG;
$$g({
  target: "Reflect",
  stat: true,
  forced: FORCED$6,
  sham: FORCED$6
}, {
  construct: function construct2(Target, args) {
    aConstructor$2(Target);
    anObject$7(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor$2(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG)
      return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      switch (args.length) {
        case 0:
          return new Target();
        case 1:
          return new Target(args[0]);
        case 2:
          return new Target(args[0], args[1]);
        case 3:
          return new Target(args[0], args[1], args[2]);
        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      }
      var $args = [null];
      apply$6(push$2, $args, args);
      return new (apply$6(bind$6, Target, $args))();
    }
    var proto = newTarget.prototype;
    var instance = create$2(isObject$e(proto) ? proto : ObjectPrototype$3);
    var result = apply$6(Target, instance, args);
    return isObject$e(result) ? result : instance;
  }
});
function _classCallCheck(instance, Constructor2) {
  if (!(instance instanceof Constructor2)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor2, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor2.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor2, staticProps);
  return Constructor2;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof2(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof2(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (_typeof(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var objectGetOwnPropertyNamesExternal = {};
var global$w = global$17;
var toAbsoluteIndex$3 = toAbsoluteIndex$6;
var lengthOfArrayLike$9 = lengthOfArrayLike$e;
var createProperty$3 = createProperty$6;
var Array$4 = global$w.Array;
var max = Math.max;
var arraySliceSimple = function(O, start, end) {
  var length = lengthOfArrayLike$9(O);
  var k = toAbsoluteIndex$3(start, length);
  var fin = toAbsoluteIndex$3(end === void 0 ? length : end, length);
  var result = Array$4(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++)
    createProperty$3(result, n, O[k]);
  result.length = n;
  return result;
};
var classof$5 = classofRaw$1;
var toIndexedObject$6 = toIndexedObject$e;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arraySlice$8 = arraySliceSimple;
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return arraySlice$8(windowNames);
  }
};
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames2(it) {
  return windowNames && classof$5(it) == "Window" ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject$6(it));
};
var $$f = _export;
var global$v = global$17;
var getBuiltIn$2 = getBuiltIn$9;
var apply$5 = functionApply;
var call$8 = functionCall;
var uncurryThis$h = functionUncurryThis;
var DESCRIPTORS$9 = descriptors;
var NATIVE_SYMBOL = nativeSymbol;
var fails$j = fails$D;
var hasOwn$7 = hasOwnProperty_1;
var isArray$1 = isArray$4;
var isCallable$5 = isCallable$o;
var isObject$d = isObject$n;
var isPrototypeOf$6 = objectIsPrototypeOf;
var isSymbol$2 = isSymbol$5;
var anObject$6 = anObject$k;
var toObject$6 = toObject$c;
var toIndexedObject$5 = toIndexedObject$e;
var toPropertyKey$1 = toPropertyKey$5;
var $toString = toString$a;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;
var nativeObjectCreate = objectCreate;
var objectKeys = objectKeys$3;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;
var definePropertiesModule = objectDefineProperties;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var arraySlice$7 = arraySlice$a;
var redefine$6 = redefine$d.exports;
var shared = shared$5.exports;
var sharedKey = sharedKey$4;
var hiddenKeys$1 = hiddenKeys$6;
var uid$2 = uid$5;
var wellKnownSymbol$9 = wellKnownSymbol$r;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol = defineWellKnownSymbol$2;
var setToStringTag$3 = setToStringTag$6;
var InternalStateModule$5 = internalState;
var $forEach$1 = arrayIteration.forEach;
var HIDDEN = sharedKey("hidden");
var SYMBOL = "Symbol";
var PROTOTYPE$1 = "prototype";
var TO_PRIMITIVE = wellKnownSymbol$9("toPrimitive");
var setInternalState$5 = InternalStateModule$5.set;
var getInternalState$3 = InternalStateModule$5.getterFor(SYMBOL);
var ObjectPrototype$2 = Object[PROTOTYPE$1];
var $Symbol = global$v.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE$1];
var TypeError$a = global$v.TypeError;
var QObject = global$v.QObject;
var $stringify = getBuiltIn$2("JSON", "stringify");
var nativeGetOwnPropertyDescriptor$2 = getOwnPropertyDescriptorModule$2.f;
var nativeDefineProperty$1 = definePropertyModule$2.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push$1 = uncurryThis$h([].push);
var AllSymbols = shared("symbols");
var ObjectPrototypeSymbols = shared("op-symbols");
var StringToSymbolRegistry = shared("string-to-symbol-registry");
var SymbolToStringRegistry = shared("symbol-to-string-registry");
var WellKnownSymbolsStore = shared("wks");
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;
var setSymbolDescriptor = DESCRIPTORS$9 && fails$j(function() {
  return nativeObjectCreate(nativeDefineProperty$1({}, "a", {
    get: function() {
      return nativeDefineProperty$1(this, "a", {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function(O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor$2(ObjectPrototype$2, P);
  if (ObjectPrototypeDescriptor)
    delete ObjectPrototype$2[P];
  nativeDefineProperty$1(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$2) {
    nativeDefineProperty$1(ObjectPrototype$2, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty$1;
var wrap = function(tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState$5(symbol, {
    type: SYMBOL,
    tag,
    description
  });
  if (!DESCRIPTORS$9)
    symbol.description = description;
  return symbol;
};
var $defineProperty = function defineProperty3(O, P, Attributes) {
  if (O === ObjectPrototype$2)
    $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$6(O);
  var key = toPropertyKey$1(P);
  anObject$6(Attributes);
  if (hasOwn$7(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn$7(O, HIDDEN))
        nativeDefineProperty$1(O, HIDDEN, createPropertyDescriptor$1(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn$7(O, HIDDEN) && O[HIDDEN][key])
        O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, {
        enumerable: createPropertyDescriptor$1(0, false)
      });
    }
    return setSymbolDescriptor(O, key, Attributes);
  }
  return nativeDefineProperty$1(O, key, Attributes);
};
var $defineProperties = function defineProperties2(O, Properties) {
  anObject$6(O);
  var properties = toIndexedObject$5(Properties);
  var keys4 = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach$1(keys4, function(key) {
    if (!DESCRIPTORS$9 || call$8($propertyIsEnumerable, properties, key))
      $defineProperty(O, key, properties[key]);
  });
  return O;
};
var $create = function create2(O, Properties) {
  return Properties === void 0 ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable = function propertyIsEnumerable3(V) {
  var P = toPropertyKey$1(V);
  var enumerable = call$8(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$2 && hasOwn$7(AllSymbols, P) && !hasOwn$7(ObjectPrototypeSymbols, P))
    return false;
  return enumerable || !hasOwn$7(this, P) || !hasOwn$7(AllSymbols, P) || hasOwn$7(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor2(O, P) {
  var it = toIndexedObject$5(O);
  var key = toPropertyKey$1(P);
  if (it === ObjectPrototype$2 && hasOwn$7(AllSymbols, key) && !hasOwn$7(ObjectPrototypeSymbols, key))
    return;
  var descriptor = nativeGetOwnPropertyDescriptor$2(it, key);
  if (descriptor && hasOwn$7(AllSymbols, key) && !(hasOwn$7(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames3(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$5(O));
  var result = [];
  $forEach$1(names, function(key) {
    if (!hasOwn$7(AllSymbols, key) && !hasOwn$7(hiddenKeys$1, key))
      push$1(result, key);
  });
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$2;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$5(O));
  var result = [];
  $forEach$1(names, function(key) {
    if (hasOwn$7(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$7(ObjectPrototype$2, key))) {
      push$1(result, AllSymbols[key]);
    }
  });
  return result;
};
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol2() {
    if (isPrototypeOf$6(SymbolPrototype, this))
      throw TypeError$a("Symbol is not a constructor");
    var description = !arguments.length || arguments[0] === void 0 ? void 0 : $toString(arguments[0]);
    var tag = uid$2(description);
    var setter = function(value) {
      if (this === ObjectPrototype$2)
        call$8(setter, ObjectPrototypeSymbols, value);
      if (hasOwn$7(this, HIDDEN) && hasOwn$7(this[HIDDEN], tag))
        this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor$1(1, value));
    };
    if (DESCRIPTORS$9 && USE_SETTER)
      setSymbolDescriptor(ObjectPrototype$2, tag, {
        configurable: true,
        set: setter
      });
    return wrap(tag, description);
  };
  SymbolPrototype = $Symbol[PROTOTYPE$1];
  redefine$6(SymbolPrototype, "toString", function toString4() {
    return getInternalState$3(this).tag;
  });
  redefine$6($Symbol, "withoutSetter", function(description) {
    return wrap(uid$2(description), description);
  });
  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule$2.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule$2.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule$1.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
  wrappedWellKnownSymbolModule.f = function(name) {
    return wrap(wellKnownSymbol$9(name), name);
  };
  if (DESCRIPTORS$9) {
    nativeDefineProperty$1(SymbolPrototype, "description", {
      configurable: true,
      get: function description() {
        return getInternalState$3(this).description;
      }
    });
    {
      redefine$6(ObjectPrototype$2, "propertyIsEnumerable", $propertyIsEnumerable, {
        unsafe: true
      });
    }
  }
}
$$f({
  global: true,
  wrap: true,
  forced: !NATIVE_SYMBOL,
  sham: !NATIVE_SYMBOL
}, {
  Symbol: $Symbol
});
$forEach$1(objectKeys(WellKnownSymbolsStore), function(name) {
  defineWellKnownSymbol(name);
});
$$f({
  target: SYMBOL,
  stat: true,
  forced: !NATIVE_SYMBOL
}, {
  for: function(key) {
    var string = $toString(key);
    if (hasOwn$7(StringToSymbolRegistry, string))
      return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  keyFor: function keyFor(sym) {
    if (!isSymbol$2(sym))
      throw TypeError$a(sym + " is not a symbol");
    if (hasOwn$7(SymbolToStringRegistry, sym))
      return SymbolToStringRegistry[sym];
  },
  useSetter: function() {
    USE_SETTER = true;
  },
  useSimple: function() {
    USE_SETTER = false;
  }
});
$$f({
  target: "Object",
  stat: true,
  forced: !NATIVE_SYMBOL,
  sham: !DESCRIPTORS$9
}, {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$$f({
  target: "Object",
  stat: true,
  forced: !NATIVE_SYMBOL
}, {
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
});
$$f({
  target: "Object",
  stat: true,
  forced: fails$j(function() {
    getOwnPropertySymbolsModule.f(1);
  })
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols2(it) {
    return getOwnPropertySymbolsModule.f(toObject$6(it));
  }
});
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails$j(function() {
    var symbol = $Symbol();
    return $stringify([symbol]) != "[null]" || $stringify({
      a: symbol
    }) != "{}" || $stringify(Object(symbol)) != "{}";
  });
  $$f({
    target: "JSON",
    stat: true,
    forced: FORCED_JSON_STRINGIFY
  }, {
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice$7(arguments);
      var $replacer = replacer;
      if (!isObject$d(replacer) && it === void 0 || isSymbol$2(it))
        return;
      if (!isArray$1(replacer))
        replacer = function(key, value) {
          if (isCallable$5($replacer))
            value = call$8($replacer, this, key, value);
          if (!isSymbol$2(value))
            return value;
        };
      args[1] = replacer;
      return apply$5($stringify, null, args);
    }
  });
}
if (!SymbolPrototype[TO_PRIMITIVE]) {
  var valueOf = SymbolPrototype.valueOf;
  redefine$6(SymbolPrototype, TO_PRIMITIVE, function(hint) {
    return call$8(valueOf, this);
  });
}
setToStringTag$3($Symbol, SYMBOL);
hiddenKeys$1[HIDDEN] = true;
var $$e = _export;
var $filter$1 = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$4;
var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$2("filter");
$$e({
  target: "Array",
  proto: true,
  forced: !HAS_SPECIES_SUPPORT$1
}, {
  filter: function filter(callbackfn) {
    return $filter$1(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var isCallable$4 = isCallable$o;
var isObject$c = isObject$n;
var setPrototypeOf$4 = objectSetPrototypeOf;
var inheritIfRequired$4 = function($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (setPrototypeOf$4 && isCallable$4(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject$c(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype)
    setPrototypeOf$4($this, NewTargetPrototype);
  return $this;
};
var isObject$b = isObject$n;
var classof$4 = classofRaw$1;
var wellKnownSymbol$8 = wellKnownSymbol$r;
var MATCH$2 = wellKnownSymbol$8("match");
var isRegexp = function(it) {
  var isRegExp2;
  return isObject$b(it) && ((isRegExp2 = it[MATCH$2]) !== void 0 ? !!isRegExp2 : classof$4(it) == "RegExp");
};
var getBuiltIn$1 = getBuiltIn$9;
var definePropertyModule$1 = objectDefineProperty;
var wellKnownSymbol$7 = wellKnownSymbol$r;
var DESCRIPTORS$8 = descriptors;
var SPECIES$2 = wellKnownSymbol$7("species");
var setSpecies$4 = function(CONSTRUCTOR_NAME) {
  var Constructor2 = getBuiltIn$1(CONSTRUCTOR_NAME);
  var defineProperty6 = definePropertyModule$1.f;
  if (DESCRIPTORS$8 && Constructor2 && !Constructor2[SPECIES$2]) {
    defineProperty6(Constructor2, SPECIES$2, {
      configurable: true,
      get: function() {
        return this;
      }
    });
  }
};
var DESCRIPTORS$7 = descriptors;
var global$u = global$17;
var uncurryThis$g = functionUncurryThis;
var isForced$3 = isForced_1;
var inheritIfRequired$3 = inheritIfRequired$4;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$b;
var defineProperty$5 = objectDefineProperty.f;
var getOwnPropertyNames$3 = objectGetOwnPropertyNames.f;
var isPrototypeOf$5 = objectIsPrototypeOf;
var isRegExp$2 = isRegexp;
var toString$4 = toString$a;
var regExpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var redefine$5 = redefine$d.exports;
var fails$i = fails$D;
var hasOwn$6 = hasOwnProperty_1;
var enforceInternalState$1 = internalState.enforce;
var setSpecies$3 = setSpecies$4;
var wellKnownSymbol$6 = wellKnownSymbol$r;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;
var MATCH$1 = wellKnownSymbol$6("match");
var NativeRegExp = global$u.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global$u.SyntaxError;
var getFlags = uncurryThis$g(regExpFlags);
var exec$1 = uncurryThis$g(RegExpPrototype.exec);
var charAt = uncurryThis$g("".charAt);
var replace$1 = uncurryThis$g("".replace);
var stringIndexOf = uncurryThis$g("".indexOf);
var stringSlice$2 = uncurryThis$g("".slice);
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;
var CORRECT_NEW = new NativeRegExp(re1) !== re1;
var MISSED_STICKY = stickyHelpers$1.MISSED_STICKY;
var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y;
var BASE_FORCED = DESCRIPTORS$7 && (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails$i(function() {
  re2[MATCH$1] = false;
  return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, "i") != "/a/i";
}));
var handleDotAll = function(string) {
  var length = string.length;
  var index = 0;
  var result = "";
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === "\\") {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === ".") {
      result += "[\\s\\S]";
    } else {
      if (chr === "[") {
        brackets = true;
      } else if (chr === "]") {
        brackets = false;
      }
      result += chr;
    }
  }
  return result;
};
var handleNCG = function(string) {
  var length = string.length;
  var index = 0;
  var result = "";
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = "";
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === "\\") {
      chr = chr + charAt(string, ++index);
    } else if (chr === "]") {
      brackets = false;
    } else if (!brackets)
      switch (true) {
        case chr === "[":
          brackets = true;
          break;
        case chr === "(":
          if (exec$1(IS_NCG, stringSlice$2(string, index + 1))) {
            index += 2;
            ncg = true;
          }
          result += chr;
          groupid++;
          continue;
        case (chr === ">" && ncg):
          if (groupname === "" || hasOwn$6(names, groupname)) {
            throw new SyntaxError("Invalid capture group name");
          }
          names[groupname] = true;
          named[named.length] = [groupname, groupid];
          ncg = false;
          groupname = "";
          continue;
      }
    if (ncg)
      groupname += chr;
    else
      result += chr;
  }
  return [result, named];
};
if (isForced$3("RegExp", BASE_FORCED)) {
  var RegExpWrapper = function RegExp2(pattern, flags) {
    var thisIsRegExp = isPrototypeOf$5(RegExpPrototype, this);
    var patternIsRegExp = isRegExp$2(pattern);
    var flagsAreUndefined = flags === void 0;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;
    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }
    if (patternIsRegExp || isPrototypeOf$5(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined)
        flags = "flags" in rawPattern ? rawPattern.flags : getFlags(rawPattern);
    }
    pattern = pattern === void 0 ? "" : toString$4(pattern);
    flags = flags === void 0 ? "" : toString$4(flags);
    rawPattern = pattern;
    if (UNSUPPORTED_DOT_ALL && "dotAll" in re1) {
      dotAll = !!flags && stringIndexOf(flags, "s") > -1;
      if (dotAll)
        flags = replace$1(flags, /s/g, "");
    }
    rawFlags = flags;
    if (MISSED_STICKY && "sticky" in re1) {
      sticky = !!flags && stringIndexOf(flags, "y") > -1;
      if (sticky && UNSUPPORTED_Y$1)
        flags = replace$1(flags, /y/g, "");
    }
    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }
    result = inheritIfRequired$3(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
    if (dotAll || sticky || groups.length) {
      state = enforceInternalState$1(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky)
        state.sticky = true;
      if (groups.length)
        state.groups = groups;
    }
    if (pattern !== rawPattern)
      try {
        createNonEnumerableProperty$3(result, "source", rawPattern === "" ? "(?:)" : rawPattern);
      } catch (error) {
      }
    return result;
  };
  var proxy = function(key) {
    key in RegExpWrapper || defineProperty$5(RegExpWrapper, key, {
      configurable: true,
      get: function() {
        return NativeRegExp[key];
      },
      set: function(it) {
        NativeRegExp[key] = it;
      }
    });
  };
  for (var keys$2 = getOwnPropertyNames$3(NativeRegExp), index = 0; keys$2.length > index; ) {
    proxy(keys$2[index++]);
  }
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine$5(global$u, "RegExp", RegExpWrapper);
}
setSpecies$3("RegExp");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var $$d = _export;
var DESCRIPTORS$6 = descriptors;
var ownKeys2 = ownKeys$2;
var toIndexedObject$4 = toIndexedObject$e;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var createProperty$2 = createProperty$6;
$$d({
  target: "Object",
  stat: true,
  sham: !DESCRIPTORS$6
}, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject$4(object);
    var getOwnPropertyDescriptor6 = getOwnPropertyDescriptorModule$1.f;
    var keys4 = ownKeys2(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys4.length > index) {
      descriptor = getOwnPropertyDescriptor6(O, key = keys4[index++]);
      if (descriptor !== void 0)
        createProperty$2(result, key, descriptor);
    }
    return result;
  }
});
var $$c = _export;
var toObject$5 = toObject$c;
var nativeKeys = objectKeys$3;
var fails$h = fails$D;
var FAILS_ON_PRIMITIVES$2 = fails$h(function() {
  nativeKeys(1);
});
$$c({
  target: "Object",
  stat: true,
  forced: FAILS_ON_PRIMITIVES$2
}, {
  keys: function keys2(it) {
    return nativeKeys(toObject$5(it));
  }
});
var $$b = _export;
var uncurryThis$f = functionUncurryThis;
var IndexedObject$1 = indexedObject;
var toIndexedObject$3 = toIndexedObject$e;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$3;
var un$Join = uncurryThis$f([].join);
var ES3_STRINGS = IndexedObject$1 != Object;
var STRICT_METHOD$1 = arrayMethodIsStrict$1("join", ",");
$$b({
  target: "Array",
  proto: true,
  forced: ES3_STRINGS || !STRICT_METHOD$1
}, {
  join: function join(separator) {
    return un$Join(toIndexedObject$3(this), separator === void 0 ? "," : separator);
  }
});
var $$a = _export;
var $map$1 = arrayIteration.map;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$4;
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$1("map");
$$a({
  target: "Array",
  proto: true,
  forced: !HAS_SPECIES_SUPPORT
}, {
  map: function map(callbackfn) {
    return $map$1(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var sameValue$1 = Object.is || function is(x, y) {
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};
var call$7 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$5 = anObject$k;
var requireObjectCoercible$3 = requireObjectCoercible$8;
var sameValue = sameValue$1;
var toString$3 = toString$a;
var getMethod$1 = getMethod$6;
var regExpExec = regexpExecAbstract;
fixRegExpWellKnownSymbolLogic$1("search", function(SEARCH, nativeSearch, maybeCallNative) {
  return [
    function search(regexp) {
      var O = requireObjectCoercible$3(this);
      var searcher = regexp == void 0 ? void 0 : getMethod$1(regexp, SEARCH);
      return searcher ? call$7(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$3(O));
    },
    function(string) {
      var rx = anObject$5(this);
      var S = toString$3(string);
      var res = maybeCallNative(nativeSearch, rx, S);
      if (res.done)
        return res.value;
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0))
        rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex))
        rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});
var global$t = global$17;
var bind$5 = functionBindContext;
var call$6 = functionCall;
var anObject$4 = anObject$k;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$3;
var lengthOfArrayLike$8 = lengthOfArrayLike$e;
var isPrototypeOf$4 = objectIsPrototypeOf;
var getIterator$1 = getIterator$3;
var getIteratorMethod$1 = getIteratorMethod$4;
var iteratorClose = iteratorClose$2;
var TypeError$9 = global$t.TypeError;
var Result = function(stopped, result) {
  this.stopped = stopped;
  this.result = result;
};
var ResultPrototype = Result.prototype;
var iterate$5 = function(iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$5(unboundFunction, that);
  var iterator, iterFn, index, length, result, next2, step;
  var stop = function(condition) {
    if (iterator)
      iteratorClose(iterator, "normal", condition);
    return new Result(true, condition);
  };
  var callFn = function(value) {
    if (AS_ENTRIES) {
      anObject$4(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    }
    return INTERRUPTED ? fn(value, stop) : fn(value);
  };
  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn)
      throw TypeError$9(tryToString$1(iterable) + " is not iterable");
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$8(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$4(ResultPrototype, result))
          return result;
      }
      return new Result(false);
    }
    iterator = getIterator$1(iterable, iterFn);
  }
  next2 = iterator.next;
  while (!(step = call$6(next2, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, "throw", error);
    }
    if (typeof result == "object" && result && isPrototypeOf$4(ResultPrototype, result))
      return result;
  }
  return new Result(false);
};
var $$9 = _export;
var iterate$4 = iterate$5;
var createProperty$1 = createProperty$6;
$$9({
  target: "Object",
  stat: true
}, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate$4(iterable, function(k, v) {
      createProperty$1(obj, k, v);
    }, {
      AS_ENTRIES: true
    });
    return obj;
  }
});
var $$8 = _export;
var $includes$1 = arrayIncludes.includes;
var addToUnscopables$1 = addToUnscopables$3;
$$8({
  target: "Array",
  proto: true
}, {
  includes: function includes(el) {
    return $includes$1(this, el, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables$1("includes");
function _createForOfIteratorHelper$f(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$f(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$f(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$f(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$f(o, minLen);
}
function _arrayLikeToArray$f(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$Q = Object.defineProperty;
var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
var __hasOwnProp$f = Object.prototype.hasOwnProperty;
var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
var __defNormalProp$f = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$Q(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$f = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$f.call(b, prop))
      __defNormalProp$f(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$f) {
    var _iterator = _createForOfIteratorHelper$f(__getOwnPropSymbols$f(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$f.call(b, prop))
          __defNormalProp$f(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var DmComponent = /* @__PURE__ */ function() {
  function DmComponent2() {
    _classCallCheck(this, DmComponent2);
    this.logger = new Logger({
      label: "dm-component"
    });
  }
  _createClass(DmComponent2, [{
    key: "setup",
    value: function setup(config) {
      this._dmSetup = __spreadValues$f(__spreadValues$f({}, this._dmSetup || {}), config || {});
      if (!this._dmSetup.driver || !this._dmSetup.driver.init) {
        throw new Error("[leonardo-dm] A driver is required check documentation");
      }
      this._httpInstance = this._dmSetup.driver.init(this._dmSetup);
      this.setInterceptors(config.interceptors);
    }
  }, {
    key: "get",
    value: function get6(url, headers) {
      this.logger.trace("GET request url: %s - headers: %j", url, headers);
      return this._httpInstance.http(url, "GET", void 0, headers);
    }
  }, {
    key: "post",
    value: function post2(url, data2, headers) {
      this.logger.trace("POST request url: %s - data: %j - headers: %j", url, data2, headers);
      return this._httpInstance.http(url, "POST", data2, headers);
    }
  }, {
    key: "put",
    value: function put(url, data2, headers) {
      this.logger.trace("PUT request url: %s - data: %j - headers: %j", url, data2, headers);
      return this._httpInstance.http(url, "PUT", data2, headers);
    }
  }, {
    key: "head",
    value: function head2(url, headers) {
      this.logger.trace("HEAD request url: %s - headers: %j", url, headers);
      return this._httpInstance.http(url, "HEAD", void 0, headers);
    }
  }, {
    key: "delete",
    value: function _delete(url, headers) {
      this.logger.trace("DELETE request url: %s - headers: %j", url, headers);
      return this._httpInstance.http(url, "DELETE", void 0, headers);
    }
  }, {
    key: "patch",
    value: function patch(url, data2, headers) {
      this.logger.trace("PATCH request url: %s - data: %j - headers: %j", url, data2, headers);
      return this._httpInstance.http(url, "PATCH", data2, headers);
    }
  }, {
    key: "setInterceptors",
    value: function setInterceptors(interceptors) {
      if (interceptors) {
        var request = interceptors.request, response = interceptors.response;
        this._httpInstance.interceptor(request, response);
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance(config) {
      if (!this._instance) {
        this._instance = new DmComponent2();
      }
      if (config) {
        this._instance.setup(config);
      }
      return this._instance;
    }
  }]);
  return DmComponent2;
}();
var global$s = global$17;
var nativePromiseConstructor = global$s.Promise;
var redefine$4 = redefine$d.exports;
var redefineAll$5 = function(target, src, options) {
  for (var key in src)
    redefine$4(target, key, src[key], options);
  return target;
};
var global$r = global$17;
var isPrototypeOf$3 = objectIsPrototypeOf;
var TypeError$8 = global$r.TypeError;
var anInstance$6 = function(it, Prototype2) {
  if (isPrototypeOf$3(Prototype2, it))
    return it;
  throw TypeError$8("Incorrect invocation");
};
var anObject$3 = anObject$k;
var aConstructor$1 = aConstructor$3;
var wellKnownSymbol$5 = wellKnownSymbol$r;
var SPECIES$1 = wellKnownSymbol$5("species");
var speciesConstructor$3 = function(O, defaultConstructor) {
  var C = anObject$3(O).constructor;
  var S;
  return C === void 0 || (S = anObject$3(C)[SPECIES$1]) == void 0 ? defaultConstructor : aConstructor$1(S);
};
var global$q = global$17;
var TypeError$7 = global$q.TypeError;
var validateArgumentsLength$1 = function(passed, required) {
  if (passed < required)
    throw TypeError$7("Not enough arguments");
  return passed;
};
var userAgent$4 = engineUserAgent;
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$4);
var classof$3 = classofRaw$1;
var global$p = global$17;
var engineIsNode = classof$3(global$p.process) == "process";
var global$o = global$17;
var apply$4 = functionApply;
var bind$4 = functionBindContext;
var isCallable$3 = isCallable$o;
var hasOwn$5 = hasOwnProperty_1;
var fails$g = fails$D;
var html = html$2;
var arraySlice$6 = arraySlice$a;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$2 = engineIsNode;
var set$1 = global$o.setImmediate;
var clear = global$o.clearImmediate;
var process$2 = global$o.process;
var Dispatch = global$o.Dispatch;
var Function$1 = global$o.Function;
var MessageChannel = global$o.MessageChannel;
var String$1 = global$o.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = "onreadystatechange";
var location, defer, channel, port;
try {
  location = global$o.location;
} catch (error) {
}
var run = function(id2) {
  if (hasOwn$5(queue$1, id2)) {
    var fn = queue$1[id2];
    delete queue$1[id2];
    fn();
  }
};
var runner = function(id2) {
  return function() {
    run(id2);
  };
};
var listener = function(event) {
  run(event.data);
};
var post = function(id2) {
  global$o.postMessage(String$1(id2), location.protocol + "//" + location.host);
};
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$3(handler) ? handler : Function$1(handler);
    var args = arraySlice$6(arguments, 1);
    queue$1[++counter] = function() {
      apply$4(fn, void 0, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id2) {
    delete queue$1[id2];
  };
  if (IS_NODE$2) {
    defer = function(id2) {
      process$2.nextTick(runner(id2));
    };
  } else if (Dispatch && Dispatch.now) {
    defer = function(id2) {
      Dispatch.now(runner(id2));
    };
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$4(port.postMessage, port);
  } else if (global$o.addEventListener && isCallable$3(global$o.postMessage) && !global$o.importScripts && location && location.protocol !== "file:" && !fails$g(post)) {
    defer = post;
    global$o.addEventListener("message", listener, false);
  } else if (ONREADYSTATECHANGE in createElement("script")) {
    defer = function(id2) {
      html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
        html.removeChild(this);
        run(id2);
      };
    };
  } else {
    defer = function(id2) {
      setTimeout(runner(id2), 0);
    };
  }
}
var task$1 = {
  set: set$1,
  clear
};
var userAgent$3 = engineUserAgent;
var global$n = global$17;
var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$3) && global$n.Pebble !== void 0;
var userAgent$2 = engineUserAgent;
var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent$2);
var global$m = global$17;
var bind$3 = functionBindContext;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$1 = engineIsNode;
var MutationObserver = global$m.MutationObserver || global$m.WebKitMutationObserver;
var document$2 = global$m.document;
var process$1 = global$m.process;
var Promise$1 = global$m.Promise;
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global$m, "queueMicrotask");
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var flush, head, last, notify$1, toggle, node, promise, then;
if (!queueMicrotask) {
  flush = function() {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain))
      parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head)
          notify$1();
        else
          last = void 0;
        throw error;
      }
    }
    last = void 0;
    if (parent)
      parent.enter();
  };
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode("");
    new MutationObserver(flush).observe(node, {
      characterData: true
    });
    notify$1 = function() {
      node.data = toggle = !toggle;
    };
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    promise = Promise$1.resolve(void 0);
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function() {
      then(flush);
    };
  } else if (IS_NODE$1) {
    notify$1 = function() {
      process$1.nextTick(flush);
    };
  } else {
    macrotask = bind$3(macrotask, global$m);
    notify$1 = function() {
      macrotask(flush);
    };
  }
}
var microtask$1 = queueMicrotask || function(fn) {
  var task2 = {
    fn,
    next: void 0
  };
  if (last)
    last.next = task2;
  if (!head) {
    head = task2;
    notify$1();
  }
  last = task2;
};
var newPromiseCapability$2 = {};
var aCallable$3 = aCallable$8;
var PromiseCapability = function(C) {
  var resolve2, reject2;
  this.promise = new C(function($$resolve, $$reject) {
    if (resolve2 !== void 0 || reject2 !== void 0)
      throw TypeError("Bad Promise constructor");
    resolve2 = $$resolve;
    reject2 = $$reject;
  });
  this.resolve = aCallable$3(resolve2);
  this.reject = aCallable$3(reject2);
};
newPromiseCapability$2.f = function(C) {
  return new PromiseCapability(C);
};
var anObject$2 = anObject$k;
var isObject$a = isObject$n;
var newPromiseCapability$1 = newPromiseCapability$2;
var promiseResolve$1 = function(C, x) {
  anObject$2(C);
  if (isObject$a(x) && x.constructor === C)
    return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve2 = promiseCapability.resolve;
  resolve2(x);
  return promiseCapability.promise;
};
var global$l = global$17;
var hostReportErrors$1 = function(a, b) {
  var console = global$l.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};
var perform$1 = function(exec2) {
  try {
    return {
      error: false,
      value: exec2()
    };
  } catch (error) {
    return {
      error: true,
      value: error
    };
  }
};
var Queue$1 = function() {
  this.head = null;
  this.tail = null;
};
Queue$1.prototype = {
  add: function(item) {
    var entry = {
      item,
      next: null
    };
    if (this.head)
      this.tail.next = entry;
    else
      this.head = entry;
    this.tail = entry;
  },
  get: function() {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry)
        this.tail = null;
      return entry.item;
    }
  }
};
var queue = Queue$1;
var engineIsBrowser = typeof window == "object";
var $$7 = _export;
var global$k = global$17;
var getBuiltIn = getBuiltIn$9;
var call$5 = functionCall;
var NativePromise = nativePromiseConstructor;
var redefine$3 = redefine$d.exports;
var redefineAll$4 = redefineAll$5;
var setPrototypeOf$3 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$6;
var setSpecies$2 = setSpecies$4;
var aCallable$2 = aCallable$8;
var isCallable$2 = isCallable$o;
var isObject$9 = isObject$n;
var anInstance$5 = anInstance$6;
var inspectSource = inspectSource$4;
var iterate$3 = iterate$5;
var checkCorrectnessOfIteration$2 = checkCorrectnessOfIteration$4;
var speciesConstructor$2 = speciesConstructor$3;
var task = task$1.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var Queue = queue;
var InternalStateModule$4 = internalState;
var isForced$2 = isForced_1;
var wellKnownSymbol$4 = wellKnownSymbol$r;
var IS_BROWSER = engineIsBrowser;
var IS_NODE = engineIsNode;
var V8_VERSION$1 = engineV8Version;
var SPECIES = wellKnownSymbol$4("species");
var PROMISE = "Promise";
var getInternalState$2 = InternalStateModule$4.getterFor(PROMISE);
var setInternalState$4 = InternalStateModule$4.set;
var getInternalPromiseState = InternalStateModule$4.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromisePrototype = NativePromisePrototype;
var TypeError$6 = global$k.TypeError;
var document$1 = global$k.document;
var process = global$k.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$k.dispatchEvent);
var NATIVE_REJECTION_EVENT = isCallable$2(global$k.PromiseRejectionEvent);
var UNHANDLED_REJECTION = "unhandledrejection";
var REJECTION_HANDLED = "rejectionhandled";
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
var FORCED$5 = isForced$2(PROMISE, function() {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION$1 === 66)
    return true;
  if (V8_VERSION$1 >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE))
    return false;
  var promise2 = new PromiseConstructor(function(resolve2) {
    resolve2(1);
  });
  var FakePromise = function(exec2) {
    exec2(function() {
    }, function() {
    });
  };
  var constructor = promise2.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise2.then(function() {
  }) instanceof FakePromise;
  if (!SUBCLASSING)
    return true;
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});
var INCORRECT_ITERATION = FORCED$5 || !checkCorrectnessOfIteration$2(function(iterable) {
  PromiseConstructor.all(iterable)["catch"](function() {
  });
});
var isThenable = function(it) {
  var then2;
  return isObject$9(it) && isCallable$2(then2 = it.then) ? then2 : false;
};
var callReaction = function(reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve2 = reaction.resolve;
  var reject2 = reaction.reject;
  var domain = reaction.domain;
  var result, then2, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED)
          onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true)
        result = value;
      else {
        if (domain)
          domain.enter();
        result = handler(value);
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject2(TypeError$6("Promise-chain cycle"));
      } else if (then2 = isThenable(result)) {
        call$5(then2, result, resolve2, reject2);
      } else
        resolve2(result);
    } else
      reject2(value);
  } catch (error) {
    if (domain && !exited)
      domain.exit();
    reject2(error);
  }
};
var notify = function(state, isReject) {
  if (state.notified)
    return;
  state.notified = true;
  microtask(function() {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection)
      onUnhandled(state);
  });
};
var dispatchEvent = function(name, promise2, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent("Event");
    event.promise = promise2;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$k.dispatchEvent(event);
  } else
    event = {
      promise: promise2,
      reason
    };
  if (!NATIVE_REJECTION_EVENT && (handler = global$k["on" + name]))
    handler(event);
  else if (name === UNHANDLED_REJECTION)
    hostReportErrors("Unhandled promise rejection", reason);
};
var onUnhandled = function(state) {
  call$5(task, global$k, function() {
    var promise2 = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function() {
        if (IS_NODE) {
          process.emit("unhandledRejection", value, promise2);
        } else
          dispatchEvent(UNHANDLED_REJECTION, promise2, value);
      });
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error)
        throw result.value;
    }
  });
};
var isUnhandled = function(state) {
  return state.rejection !== HANDLED && !state.parent;
};
var onHandleUnhandled = function(state) {
  call$5(task, global$k, function() {
    var promise2 = state.facade;
    if (IS_NODE) {
      process.emit("rejectionHandled", promise2);
    } else
      dispatchEvent(REJECTION_HANDLED, promise2, state.value);
  });
};
var bind$2 = function(fn, state, unwrap) {
  return function(value) {
    fn(state, value, unwrap);
  };
};
var internalReject = function(state, value, unwrap) {
  if (state.done)
    return;
  state.done = true;
  if (unwrap)
    state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};
var internalResolve = function(state, value, unwrap) {
  if (state.done)
    return;
  state.done = true;
  if (unwrap)
    state = unwrap;
  try {
    if (state.facade === value)
      throw TypeError$6("Promise can't be resolved itself");
    var then2 = isThenable(value);
    if (then2) {
      microtask(function() {
        var wrapper2 = {
          done: false
        };
        try {
          call$5(then2, value, bind$2(internalResolve, wrapper2, state), bind$2(internalReject, wrapper2, state));
        } catch (error) {
          internalReject(wrapper2, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({
      done: false
    }, error, state);
  }
};
if (FORCED$5) {
  PromiseConstructor = function Promise2(executor) {
    anInstance$5(this, PromisePrototype);
    aCallable$2(executor);
    call$5(Internal, this);
    var state = getInternalState$2(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromisePrototype = PromiseConstructor.prototype;
  Internal = function Promise2(executor) {
    setInternalState$4(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: void 0
    });
  };
  Internal.prototype = redefineAll$4(PromisePrototype, {
    then: function then2(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor$2(this, PromiseConstructor));
      state.parent = true;
      reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
      reaction.fail = isCallable$2(onRejected) && onRejected;
      reaction.domain = IS_NODE ? process.domain : void 0;
      if (state.state == PENDING)
        state.reactions.add(reaction);
      else
        microtask(function() {
          callReaction(reaction, state);
        });
      return reaction.promise;
    },
    catch: function(onRejected) {
      return this.then(void 0, onRejected);
    }
  });
  OwnPromiseCapability = function() {
    var promise2 = new Internal();
    var state = getInternalState$2(promise2);
    this.promise = promise2;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
    return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
  if (isCallable$2(NativePromise) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;
    if (!SUBCLASSING) {
      redefine$3(NativePromisePrototype, "then", function then2(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function(resolve2, reject2) {
          call$5(nativeThen, that, resolve2, reject2);
        }).then(onFulfilled, onRejected);
      }, {
        unsafe: true
      });
      redefine$3(NativePromisePrototype, "catch", PromisePrototype["catch"], {
        unsafe: true
      });
    }
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) {
    }
    if (setPrototypeOf$3) {
      setPrototypeOf$3(NativePromisePrototype, PromisePrototype);
    }
  }
}
$$7({
  global: true,
  wrap: true,
  forced: FORCED$5
}, {
  Promise: PromiseConstructor
});
setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies$2(PROMISE);
PromiseWrapper = getBuiltIn(PROMISE);
$$7({
  target: PROMISE,
  stat: true,
  forced: FORCED$5
}, {
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    call$5(capability.reject, void 0, r);
    return capability.promise;
  }
});
$$7({
  target: PROMISE,
  stat: true,
  forced: FORCED$5
}, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});
$$7({
  target: PROMISE,
  stat: true,
  forced: INCORRECT_ITERATION
}, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve2 = capability.resolve;
    var reject2 = capability.reject;
    var result = perform(function() {
      var $promiseResolve = aCallable$2(C.resolve);
      var values3 = [];
      var counter2 = 0;
      var remaining = 1;
      iterate$3(iterable, function(promise2) {
        var index = counter2++;
        var alreadyCalled = false;
        remaining++;
        call$5($promiseResolve, C, promise2).then(function(value) {
          if (alreadyCalled)
            return;
          alreadyCalled = true;
          values3[index] = value;
          --remaining || resolve2(values3);
        }, reject2);
      });
      --remaining || resolve2(values3);
    });
    if (result.error)
      reject2(result.value);
    return capability.promise;
  },
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject2 = capability.reject;
    var result = perform(function() {
      var $promiseResolve = aCallable$2(C.resolve);
      iterate$3(iterable, function(promise2) {
        call$5($promiseResolve, C, promise2).then(capability.resolve, reject2);
      });
    });
    if (result.error)
      reject2(result.value);
    return capability.promise;
  }
});
var internalMetadata = {
  exports: {}
};
var fails$f = fails$D;
var arrayBufferNonExtensible = fails$f(function() {
  if (typeof ArrayBuffer == "function") {
    var buffer = new ArrayBuffer(8);
    if (Object.isExtensible(buffer))
      Object.defineProperty(buffer, "a", {
        value: 8
      });
  }
});
var fails$e = fails$D;
var isObject$8 = isObject$n;
var classof$2 = classofRaw$1;
var ARRAY_BUFFER_NON_EXTENSIBLE = arrayBufferNonExtensible;
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES$1 = fails$e(function() {
  $isExtensible(1);
});
var objectIsExtensible = FAILS_ON_PRIMITIVES$1 || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
  if (!isObject$8(it))
    return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof$2(it) == "ArrayBuffer")
    return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;
var fails$d = fails$D;
var freezing = !fails$d(function() {
  return Object.isExtensible(Object.preventExtensions({}));
});
var $$6 = _export;
var uncurryThis$e = functionUncurryThis;
var hiddenKeys = hiddenKeys$6;
var isObject$7 = isObject$n;
var hasOwn$4 = hasOwnProperty_1;
var defineProperty$4 = objectDefineProperty.f;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternalModule = objectGetOwnPropertyNamesExternal;
var isExtensible$1 = objectIsExtensible;
var uid$1 = uid$5;
var FREEZING = freezing;
var REQUIRED = false;
var METADATA = uid$1("meta");
var id$1 = 0;
var setMetadata = function(it) {
  defineProperty$4(it, METADATA, {
    value: {
      objectID: "O" + id$1++,
      weakData: {}
    }
  });
};
var fastKey$1 = function(it, create4) {
  if (!isObject$7(it))
    return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
  if (!hasOwn$4(it, METADATA)) {
    if (!isExtensible$1(it))
      return "F";
    if (!create4)
      return "E";
    setMetadata(it);
  }
  return it[METADATA].objectID;
};
var getWeakData$1 = function(it, create4) {
  if (!hasOwn$4(it, METADATA)) {
    if (!isExtensible$1(it))
      return true;
    if (!create4)
      return false;
    setMetadata(it);
  }
  return it[METADATA].weakData;
};
var onFreeze = function(it) {
  if (FREEZING && REQUIRED && isExtensible$1(it) && !hasOwn$4(it, METADATA))
    setMetadata(it);
  return it;
};
var enable = function() {
  meta.enable = function() {
  };
  REQUIRED = true;
  var getOwnPropertyNames5 = getOwnPropertyNamesModule.f;
  var splice2 = uncurryThis$e([].splice);
  var test2 = {};
  test2[METADATA] = 1;
  if (getOwnPropertyNames5(test2).length) {
    getOwnPropertyNamesModule.f = function(it) {
      var result = getOwnPropertyNames5(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice2(result, i, 1);
          break;
        }
      }
      return result;
    };
    $$6({
      target: "Object",
      stat: true,
      forced: true
    }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};
var meta = internalMetadata.exports = {
  enable,
  fastKey: fastKey$1,
  getWeakData: getWeakData$1,
  onFreeze
};
hiddenKeys[METADATA] = true;
var $$5 = _export;
var global$j = global$17;
var uncurryThis$d = functionUncurryThis;
var isForced$1 = isForced_1;
var redefine$2 = redefine$d.exports;
var InternalMetadataModule$1 = internalMetadata.exports;
var iterate$2 = iterate$5;
var anInstance$4 = anInstance$6;
var isCallable$1 = isCallable$o;
var isObject$6 = isObject$n;
var fails$c = fails$D;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$4;
var setToStringTag$1 = setToStringTag$6;
var inheritIfRequired$2 = inheritIfRequired$4;
var collection$2 = function(CONSTRUCTOR_NAME, wrapper2, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
  var ADDER = IS_MAP ? "set" : "add";
  var NativeConstructor = global$j[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor2 = NativeConstructor;
  var exported = {};
  var fixMethod = function(KEY) {
    var uncurriedNativeMethod = uncurryThis$d(NativePrototype[KEY]);
    redefine$2(NativePrototype, KEY, KEY == "add" ? function add(value) {
      uncurriedNativeMethod(this, value === 0 ? 0 : value);
      return this;
    } : KEY == "delete" ? function(key) {
      return IS_WEAK && !isObject$6(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : KEY == "get" ? function get6(key) {
      return IS_WEAK && !isObject$6(key) ? void 0 : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : KEY == "has" ? function has2(key) {
      return IS_WEAK && !isObject$6(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
    } : function set3(key, value) {
      uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
      return this;
    });
  };
  var REPLACE2 = isForced$1(CONSTRUCTOR_NAME, !isCallable$1(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails$c(function() {
    new NativeConstructor().entries().next();
  })));
  if (REPLACE2) {
    Constructor2 = common.getConstructor(wrapper2, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule$1.enable();
  } else if (isForced$1(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor2();
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    var THROWS_ON_PRIMITIVES = fails$c(function() {
      instance.has(1);
    });
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration$1(function(iterable) {
      new NativeConstructor(iterable);
    });
    var BUGGY_ZERO = !IS_WEAK && fails$c(function() {
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--)
        $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      Constructor2 = wrapper2(function(dummy, iterable) {
        anInstance$4(dummy, NativePrototype);
        var that = inheritIfRequired$2(new NativeConstructor(), dummy, Constructor2);
        if (iterable != void 0)
          iterate$2(iterable, that[ADDER], {
            that,
            AS_ENTRIES: IS_MAP
          });
        return that;
      });
      Constructor2.prototype = NativePrototype;
      NativePrototype.constructor = Constructor2;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod("delete");
      fixMethod("has");
      IS_MAP && fixMethod("get");
    }
    if (BUGGY_ZERO || HASNT_CHAINING)
      fixMethod(ADDER);
    if (IS_WEAK && NativePrototype.clear)
      delete NativePrototype.clear;
  }
  exported[CONSTRUCTOR_NAME] = Constructor2;
  $$5({
    global: true,
    forced: Constructor2 != NativeConstructor
  }, exported);
  setToStringTag$1(Constructor2, CONSTRUCTOR_NAME);
  if (!IS_WEAK)
    common.setStrong(Constructor2, CONSTRUCTOR_NAME, IS_MAP);
  return Constructor2;
};
var uncurryThis$c = functionUncurryThis;
var redefineAll$3 = redefineAll$5;
var getWeakData = internalMetadata.exports.getWeakData;
var anObject$1 = anObject$k;
var isObject$5 = isObject$n;
var anInstance$3 = anInstance$6;
var iterate$1 = iterate$5;
var ArrayIterationModule = arrayIteration;
var hasOwn$3 = hasOwnProperty_1;
var InternalStateModule$3 = internalState;
var setInternalState$3 = InternalStateModule$3.set;
var internalStateGetterFor$1 = InternalStateModule$3.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis$c([].splice);
var id = 0;
var uncaughtFrozenStore = function(store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function() {
  this.entries = [];
};
var findUncaughtFrozen = function(store, key) {
  return find(store.entries, function(it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry)
      return entry[1];
  },
  has: function(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry)
      entry[1] = value;
    else
      this.entries.push([key, value]);
  },
  delete: function(key) {
    var index = findIndex(this.entries, function(it) {
      return it[0] === key;
    });
    if (~index)
      splice(this.entries, index, 1);
    return !!~index;
  }
};
var collectionWeak$1 = {
  getConstructor: function(wrapper2, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor2 = wrapper2(function(that, iterable) {
      anInstance$3(that, Prototype2);
      setInternalState$3(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: void 0
      });
      if (iterable != void 0)
        iterate$1(iterable, that[ADDER], {
          that,
          AS_ENTRIES: IS_MAP
        });
    });
    var Prototype2 = Constructor2.prototype;
    var getInternalState2 = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var define = function(that, key, value) {
      var state = getInternalState2(that);
      var data2 = getWeakData(anObject$1(key), true);
      if (data2 === true)
        uncaughtFrozenStore(state).set(key, value);
      else
        data2[state.id] = value;
      return that;
    };
    redefineAll$3(Prototype2, {
      delete: function(key) {
        var state = getInternalState2(this);
        if (!isObject$5(key))
          return false;
        var data2 = getWeakData(key);
        if (data2 === true)
          return uncaughtFrozenStore(state)["delete"](key);
        return data2 && hasOwn$3(data2, state.id) && delete data2[state.id];
      },
      has: function has2(key) {
        var state = getInternalState2(this);
        if (!isObject$5(key))
          return false;
        var data2 = getWeakData(key);
        if (data2 === true)
          return uncaughtFrozenStore(state).has(key);
        return data2 && hasOwn$3(data2, state.id);
      }
    });
    redefineAll$3(Prototype2, IS_MAP ? {
      get: function get6(key) {
        var state = getInternalState2(this);
        if (isObject$5(key)) {
          var data2 = getWeakData(key);
          if (data2 === true)
            return uncaughtFrozenStore(state).get(key);
          return data2 ? data2[state.id] : void 0;
        }
      },
      set: function set3(key, value) {
        return define(this, key, value);
      }
    } : {
      add: function add(value) {
        return define(this, value, true);
      }
    });
    return Constructor2;
  }
};
var global$i = global$17;
var uncurryThis$b = functionUncurryThis;
var redefineAll$2 = redefineAll$5;
var InternalMetadataModule = internalMetadata.exports;
var collection$1 = collection$2;
var collectionWeak = collectionWeak$1;
var isObject$4 = isObject$n;
var isExtensible2 = objectIsExtensible;
var enforceInternalState = internalState.enforce;
var NATIVE_WEAK_MAP = nativeWeakMap;
var IS_IE11 = !global$i.ActiveXObject && "ActiveXObject" in global$i;
var InternalWeakMap;
var wrapper = function(init) {
  return function WeakMap2() {
    return init(this, arguments.length ? arguments[0] : void 0);
  };
};
var $WeakMap = collection$1("WeakMap", wrapper, collectionWeak);
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, "WeakMap", true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = uncurryThis$b(WeakMapPrototype["delete"]);
  var nativeHas = uncurryThis$b(WeakMapPrototype.has);
  var nativeGet = uncurryThis$b(WeakMapPrototype.get);
  var nativeSet = uncurryThis$b(WeakMapPrototype.set);
  redefineAll$2(WeakMapPrototype, {
    delete: function(key) {
      if (isObject$4(key) && !isExtensible2(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen)
          state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen["delete"](key);
      }
      return nativeDelete(this, key);
    },
    has: function has2(key) {
      if (isObject$4(key) && !isExtensible2(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen)
          state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      }
      return nativeHas(this, key);
    },
    get: function get6(key) {
      if (isObject$4(key) && !isExtensible2(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen)
          state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      }
      return nativeGet(this, key);
    },
    set: function set3(key, value) {
      if (isObject$4(key) && !isExtensible2(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen)
          state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else
        nativeSet(this, key, value);
      return this;
    }
  });
}
var defineProperty$3 = objectDefineProperty.f;
var create$1 = objectCreate;
var redefineAll$1 = redefineAll$5;
var bind$1 = functionBindContext;
var anInstance$2 = anInstance$6;
var iterate = iterate$5;
var defineIterator = defineIterator$3;
var setSpecies$1 = setSpecies$4;
var DESCRIPTORS$5 = descriptors;
var fastKey = internalMetadata.exports.fastKey;
var InternalStateModule$2 = internalState;
var setInternalState$2 = InternalStateModule$2.set;
var internalStateGetterFor = InternalStateModule$2.getterFor;
var collectionStrong$1 = {
  getConstructor: function(wrapper2, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor2 = wrapper2(function(that, iterable) {
      anInstance$2(that, Prototype2);
      setInternalState$2(that, {
        type: CONSTRUCTOR_NAME,
        index: create$1(null),
        first: void 0,
        last: void 0,
        size: 0
      });
      if (!DESCRIPTORS$5)
        that.size = 0;
      if (iterable != void 0)
        iterate(iterable, that[ADDER], {
          that,
          AS_ENTRIES: IS_MAP
        });
    });
    var Prototype2 = Constructor2.prototype;
    var getInternalState2 = internalStateGetterFor(CONSTRUCTOR_NAME);
    var define = function(that, key, value) {
      var state = getInternalState2(that);
      var entry = getEntry(that, key);
      var previous, index;
      if (entry) {
        entry.value = value;
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key,
          value,
          previous: previous = state.last,
          next: void 0,
          removed: false
        };
        if (!state.first)
          state.first = entry;
        if (previous)
          previous.next = entry;
        if (DESCRIPTORS$5)
          state.size++;
        else
          that.size++;
        if (index !== "F")
          state.index[index] = entry;
      }
      return that;
    };
    var getEntry = function(that, key) {
      var state = getInternalState2(that);
      var index = fastKey(key);
      var entry;
      if (index !== "F")
        return state.index[index];
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key)
          return entry;
      }
    };
    redefineAll$1(Prototype2, {
      clear: function clear2() {
        var that = this;
        var state = getInternalState2(that);
        var data2 = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous)
            entry.previous = entry.previous.next = void 0;
          delete data2[entry.index];
          entry = entry.next;
        }
        state.first = state.last = void 0;
        if (DESCRIPTORS$5)
          state.size = 0;
        else
          that.size = 0;
      },
      delete: function(key) {
        var that = this;
        var state = getInternalState2(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next2 = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev)
            prev.next = next2;
          if (next2)
            next2.previous = prev;
          if (state.first == entry)
            state.first = next2;
          if (state.last == entry)
            state.last = prev;
          if (DESCRIPTORS$5)
            state.size--;
          else
            that.size--;
        }
        return !!entry;
      },
      forEach: function forEach4(callbackfn) {
        var state = getInternalState2(this);
        var boundFunction = bind$1(callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          while (entry && entry.removed)
            entry = entry.previous;
        }
      },
      has: function has2(key) {
        return !!getEntry(this, key);
      }
    });
    redefineAll$1(Prototype2, IS_MAP ? {
      get: function get6(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      set: function set3(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS$5)
      defineProperty$3(Prototype2, "size", {
        get: function() {
          return getInternalState2(this).size;
        }
      });
    return Constructor2;
  },
  setStrong: function(Constructor2, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    defineIterator(Constructor2, CONSTRUCTOR_NAME, function(iterated, kind) {
      setInternalState$2(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind,
        last: void 0
      });
    }, function() {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      while (entry && entry.removed)
        entry = entry.previous;
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        state.target = void 0;
        return {
          value: void 0,
          done: true
        };
      }
      if (kind == "keys")
        return {
          value: entry.key,
          done: false
        };
      if (kind == "values")
        return {
          value: entry.value,
          done: false
        };
      return {
        value: [entry.key, entry.value],
        done: false
      };
    }, IS_MAP ? "entries" : "values", !IS_MAP, true);
    setSpecies$1(CONSTRUCTOR_NAME);
  }
};
var collection = collection$2;
var collectionStrong = collectionStrong$1;
collection("Map", function(init) {
  return function Map2() {
    return init(this, arguments.length ? arguments[0] : void 0);
  };
}, collectionStrong);
function _createForOfIteratorHelper$e(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$e(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$e(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$e(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$e(o, minLen);
}
function _arrayLikeToArray$e(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$P = Object.defineProperty;
var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
var __hasOwnProp$e = Object.prototype.hasOwnProperty;
var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = function __defNormalProp2(obj, key, value) {
  return key in obj ? __defProp$P(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$e = function __spreadValues2(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$e.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$e) {
    var _iterator = _createForOfIteratorHelper$e(__getOwnPropSymbols$e(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$e.call(b, prop))
          __defNormalProp$e(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var DEFAULT_CACHE_CONFIG = {
  ttl: Config.cacheTimeout
};
var DmCache = /* @__PURE__ */ function() {
  function DmCache2(_config) {
    _classCallCheck(this, DmCache2);
    this._config = _config;
    this._cacheItems = new WeakMap();
    this._cacheItemsAlt = new Map();
  }
  _createClass(DmCache2, [{
    key: "has",
    value: function has2(key) {
      return this.valid(key);
    }
  }, {
    key: "get",
    value: function get6(key) {
      if (typeof key === "string") {
        return this.getAlt(key);
      }
      var item = this._cacheItems.get(key);
      return this.valid(key, item) ? item == null ? void 0 : item.data : void 0;
    }
  }, {
    key: "set",
    value: function set3(key, value, altKey) {
      var item = {
        endTime: this._config.ttl + +new Date(),
        data: value
      };
      if (altKey) {
        item.altKey = altKey;
        this._cacheItemsAlt.set(altKey, key);
      }
      this._cacheItems.set(key, item);
    }
  }, {
    key: "reset",
    value: function reset(altKey) {
      var _this = this;
      if (!altKey) {
        return;
      }
      if (Array.isArray(altKey)) {
        altKey.forEach(function(k) {
          _this.reset(k);
        });
      } else if (typeof altKey === "string") {
        var key = this._cacheItemsAlt.get(altKey);
        if (key) {
          this.del(key);
        }
      } else {
        Array.from(this._cacheItemsAlt.keys()).forEach(function(key2) {
          if (altKey.test(key2)) {
            _this.reset(key2);
          }
        });
      }
    }
  }, {
    key: "getAlt",
    value: function getAlt(altKey) {
      var key = this._cacheItemsAlt.get(altKey);
      return key ? this.get(key) : void 0;
    }
  }, {
    key: "valid",
    value: function valid(key, item) {
      if (!item) {
        var exists = this._cacheItems.has(key);
        if (!exists) {
          return exists;
        }
      }
      item = item || this._cacheItems.get(key);
      var valid2 = !!item && item.endTime > +new Date();
      if (!valid2) {
        this.del(key, item == null ? void 0 : item.altKey);
      }
      return valid2;
    }
  }, {
    key: "del",
    value: function del(key, altKey) {
      this._cacheItems.delete(key);
      if (altKey) {
        this._cacheItemsAlt.delete(altKey);
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance(config) {
      if (!this._instance) {
        this._instance = new DmCache2(__spreadValues$e(__spreadValues$e({}, DEFAULT_CACHE_CONFIG), config));
      }
      return this._instance;
    }
  }]);
  return DmCache2;
}();
function _createForOfIteratorHelper$d(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$d(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$d(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$d(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$d(o, minLen);
}
function _arrayLikeToArray$d(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$O = Object.defineProperty;
var __defProps$c = Object.defineProperties;
var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = function __defNormalProp3(obj, key, value) {
  return key in obj ? __defProp$O(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$d = function __spreadValues3(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$d) {
    var _iterator = _createForOfIteratorHelper$d(__getOwnPropSymbols$d(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$d.call(b, prop))
          __defNormalProp$d(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$c = function __spreadProps(a, b) {
  return __defProps$c(a, __getOwnPropDescs$c(b));
};
var BaseDriver = /* @__PURE__ */ function() {
  function BaseDriver2() {
    _classCallCheck(this, BaseDriver2);
  }
  _createClass(BaseDriver2, [{
    key: "setUrlWithPaths",
    value: function setUrlWithPaths(url, path2) {
      var finalUrl = url;
      if (path2) {
        Object.entries(path2).forEach(function(_ref) {
          var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
          finalUrl = finalUrl.replace("{".concat(key, "}"), value.toString());
        });
      }
      return finalUrl;
    }
  }, {
    key: "getAuthHeader",
    value: function getAuthHeader() {
      var token = window.localStorage.getItem("jwt_token") || void 0;
      return generateAuthHeader(token);
    }
  }, {
    key: "parseUrl",
    value: function parseUrl(url) {
      var finalUrl;
      var params;
      var useCache = false;
      var altKey;
      var force = false;
      var cacheReset;
      if (typeof url === "string") {
        finalUrl = url;
      } else {
        finalUrl = this.setUrlWithPaths(url.url, url.path);
        params = url.params;
        var cacheKey = url.cache !== void 0 ? url.cache : useCache;
        if (cacheKey && typeof cacheKey === "string") {
          altKey = cacheKey;
        }
        useCache = !!cacheKey;
        force = !!url.force;
        cacheReset = url.cacheReset;
      }
      params = params && Object.entries(params).filter(function(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), value = _ref4[1];
        return value !== void 0;
      }).reduce(function(a, _ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
        return __spreadProps$c(__spreadValues$d({}, a), _defineProperty({}, key, value));
      }, {});
      return {
        url: finalUrl,
        params,
        force,
        cache: useCache,
        cacheKey: altKey,
        cacheReset
      };
    }
  }]);
  return BaseDriver2;
}();
function _createSuper$H(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$H();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$H() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$c(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$c(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$c(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$c(o, minLen);
}
function _arrayLikeToArray$c(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$N = Object.defineProperty;
var __defProps$b = Object.defineProperties;
var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = function __defNormalProp4(obj, key, value) {
  return key in obj ? __defProp$N(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$c = function __spreadValues4(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$c) {
    var _iterator = _createForOfIteratorHelper$c(__getOwnPropSymbols$c(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$c.call(b, prop))
          __defNormalProp$c(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$b = function __spreadProps2(a, b) {
  return __defProps$b(a, __getOwnPropDescs$b(b));
};
var AxiosDriver = /* @__PURE__ */ function(_BaseDriver) {
  _inherits(AxiosDriver2, _BaseDriver);
  var _super = _createSuper$H(AxiosDriver2);
  function AxiosDriver2(config) {
    var _this;
    _classCallCheck(this, AxiosDriver2);
    _this = _super.call(this);
    _this._cache = DmCache.getInstance();
    if (config) {
      _this.init(config);
    }
    return _this;
  }
  _createClass(AxiosDriver2, [{
    key: "init",
    value: function init(config) {
      var axiosConfig = {};
      if (config.host) {
        axiosConfig = {
          baseURL: config.host + (config.baseUrl || "/")
        };
      }
      if (config.headers) {
        this._headers = config.headers;
      }
      this._instance = axios.create(axiosConfig);
      return this;
    }
  }, {
    key: "done",
    value: function done(response) {
      var data2 = response.data, status = response.status, statusText = response.statusText, headers = response.headers;
      return {
        data: data2,
        status,
        statusText,
        headers
      };
    }
  }, {
    key: "http",
    value: function http(url) {
      var _this2 = this;
      var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET";
      var data2 = arguments.length > 2 ? arguments[2] : void 0;
      var headers = arguments.length > 3 ? arguments[3] : void 0;
      if (!this._instance) {
        throw new Error("[leonardo-dm] AxiosDriver not properly initialized");
      }
      var parsedInfo = this.parseUrl(url);
      var config = {
        method,
        url: parsedInfo.url,
        params: parsedInfo.params
      };
      if (data2) {
        config.data = data2;
      }
      if (headers) {
        config.headers = headers;
      }
      if (this._headers) {
        config.headers = __spreadValues$c(__spreadValues$c({}, this._headers), config.headers);
      }
      config.headers = __spreadValues$c(__spreadProps$b(__spreadValues$c({}, this.getAuthHeader()), {
        "Time-Zone": jstz.determine().name()
      }), config.headers);
      var useCache = parsedInfo.cache && (!config.method || ["get", "head"].includes(config.method.toLowerCase()));
      if (useCache && !parsedInfo.force) {
        var cachedResponse = this._cache.get(config);
        if (cachedResponse) {
          return Promise.resolve(this.done(cachedResponse));
        }
      }
      return this._instance(config).then(function(response) {
        if (useCache) {
          _this2._cache.set(config, response.data, parsedInfo.cacheKey);
        }
        _this2._cache.reset(parsedInfo.cacheReset);
        return _this2.done(response);
      });
    }
  }, {
    key: "interceptor",
    value: function interceptor(req, res) {
      if (req && this._instance) {
        this._instance.interceptors.request.use(function(request) {
          req(void 0, request);
          return request;
        }, function(error) {
          req(error, void 0);
          return Promise.reject(error);
        });
      }
      if (res && this._instance) {
        this._instance.interceptors.response.use(function(response) {
          res(void 0, response);
          return response;
        }, function(error) {
          if (error == null ? void 0 : error.response) {
            res(error, void 0);
          }
          return Promise.reject(error);
        });
      }
    }
  }]);
  return AxiosDriver2;
}(BaseDriver);
function _createForOfIteratorHelper$b(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$b(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$b(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$b(o, minLen);
}
function _arrayLikeToArray$b(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$M = Object.defineProperty;
var __defProps$a = Object.defineProperties;
var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = function __defNormalProp5(obj, key, value) {
  return key in obj ? __defProp$M(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$b = function __spreadValues5(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$b) {
    var _iterator = _createForOfIteratorHelper$b(__getOwnPropSymbols$b(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$b.call(b, prop))
          __defNormalProp$b(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$a = function __spreadProps3(a, b) {
  return __defProps$a(a, __getOwnPropDescs$a(b));
};
var DmLeonardo = /* @__PURE__ */ function() {
  function DmLeonardo2() {
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, DmLeonardo2);
    this.logger = new Logger({
      label: "dm"
    });
    this._jsonConvert = new JsonConvert();
    this._jsonConvert.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
    this._client = DmComponent.getInstance(__spreadValues$b({
      driver: new AxiosDriver(),
      baseUrl: Config.dmEnvironment.baseUrl,
      host: Config.dmEnvironment.host,
      interceptors: {
        response: function response(error) {
          httpInterceptorErrorMaintenance(error);
        }
      }
    }, setup));
  }
  _createClass(DmLeonardo2, [{
    key: "parseModifier",
    value: function parseModifier(modifier) {
      switch (modifier) {
        case "essential":
        case "summary":
          return _defineProperty({}, modifier, "true");
        default:
          return {};
      }
    }
  }, {
    key: "parseOrdering",
    value: function parseOrdering(ordering) {
      var result;
      if (ordering && Object.keys(ordering).length > 0) {
        result = Object.entries(ordering).map(function(_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2), name = _ref3[0], order = _ref3[1];
          return (order === "DESC" ? "-" : "") + name;
        }).join(",");
      }
      return result;
    }
  }, {
    key: "parseGenericParams",
    value: function parseGenericParams() {
      var _ref4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref4$page = _ref4.page, page = _ref4$page === void 0 ? 1 : _ref4$page, modifier = _ref4.modifier, ordering = _ref4.ordering, _ref4$limit = _ref4.limit, limit = _ref4$limit === void 0 ? Config.dmEnvironment.defaultLimitResults : _ref4$limit, filterBySearch = _ref4.filterBySearch, search = _ref4.search, disablePagination = _ref4.disablePagination, notEmpty = _ref4.notEmpty;
      var params = __spreadProps$a(__spreadValues$b({}, this.parseModifier(modifier)), {
        page: disablePagination ? void 0 : page == null ? void 0 : page.toString(),
        limit: disablePagination ? void 0 : limit == null ? void 0 : limit.toString(),
        ordering: this.parseOrdering(ordering),
        filterBySearch: filterBySearch == null ? void 0 : filterBySearch.toString(),
        search: search == null ? void 0 : search.toString(),
        disable_pagination: disablePagination ? "true" : void 0,
        not_empty: notEmpty ? "true" : void 0
      });
      return Object.fromEntries(Object.entries(params).filter(function(_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2), value = _ref6[1];
        return ![void 0, ""].includes(value);
      }));
    }
  }, {
    key: "getEntity",
    value: function getEntity(params, _ref7) {
      var complete = _ref7.complete, summary = _ref7.summary, essential = _ref7.essential;
      if ("summary" in params) {
        return summary;
      } else if ("essential" in params) {
        return essential;
      }
      return complete;
    }
  }, {
    key: "parseEmailExport",
    value: function parseEmailExport(_ref8) {
      var emailList = _ref8.emailList;
      var emails = encodeURI(emailList.map(function(e) {
        return e.email;
      }).join(","));
      return {
        response_email_recipients: emails
      };
    }
  }, {
    key: "parseFilterParams",
    value: function parseFilterParams(filter3) {
      if (!filter3) {
        return {};
      }
      return Object.entries(filter3).filter(function(_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2), value = _ref10[1];
        return Array.isArray(value) ? value.length : !!value;
      }).reduce(function(a, _ref11) {
        var _ref12 = _slicedToArray(_ref11, 2), key = _ref12[0], value = _ref12[1];
        return __spreadProps$a(__spreadValues$b({}, a), _defineProperty({}, key, Array.isArray(value) ? value.map(function(v) {
          return v.id;
        }).join(",") : value));
      }, {});
    }
  }, {
    key: "getAsGenericFilter",
    value: function getAsGenericFilter(url, cache, entity, filter3) {
      var _this = this;
      var filterParams = this.parseFilterParams(filter3);
      var finalParams = this.parseGenericParams({
        modifier: "essential",
        disablePagination: true
      });
      return this._client.get({
        url,
        params: __spreadValues$b(__spreadValues$b({}, finalParams), filterParams),
        cache
      }).then(function(_ref13) {
        var data2 = _ref13.data;
        return _this._jsonConvert.deserializeObject(data2, entity);
      }).catch(function(e) {
        _this.logger.error(e);
        throw e;
      });
    }
  }]);
  return DmLeonardo2;
}();
var $$4 = _export;
var fails$b = fails$D;
var toIndexedObject$2 = toIndexedObject$e;
var nativeGetOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var DESCRIPTORS$4 = descriptors;
var FAILS_ON_PRIMITIVES = fails$b(function() {
  nativeGetOwnPropertyDescriptor$1(1);
});
var FORCED$4 = !DESCRIPTORS$4 || FAILS_ON_PRIMITIVES;
$$4({
  target: "Object",
  stat: true,
  forced: FORCED$4,
  sham: !DESCRIPTORS$4
}, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor3(it, key) {
    return nativeGetOwnPropertyDescriptor$1(toIndexedObject$2(it), key);
  }
});
var uncurryThis$a = functionUncurryThis;
var thisNumberValue$1 = uncurryThis$a(1 .valueOf);
var whitespaces$1 = "	\n\v\f\r                　\u2028\u2029\uFEFF";
var uncurryThis$9 = functionUncurryThis;
var requireObjectCoercible$2 = requireObjectCoercible$8;
var toString$2 = toString$a;
var whitespaces = whitespaces$1;
var replace = uncurryThis$9("".replace);
var whitespace = "[" + whitespaces + "]";
var ltrim = RegExp("^" + whitespace + whitespace + "*");
var rtrim = RegExp(whitespace + whitespace + "*$");
var createMethod$1 = function(TYPE) {
  return function($this) {
    var string = toString$2(requireObjectCoercible$2($this));
    if (TYPE & 1)
      string = replace(string, ltrim, "");
    if (TYPE & 2)
      string = replace(string, rtrim, "");
    return string;
  };
};
var stringTrim = {
  start: createMethod$1(1),
  end: createMethod$1(2),
  trim: createMethod$1(3)
};
var DESCRIPTORS$3 = descriptors;
var global$h = global$17;
var uncurryThis$8 = functionUncurryThis;
var isForced = isForced_1;
var redefine$1 = redefine$d.exports;
var hasOwn$2 = hasOwnProperty_1;
var inheritIfRequired$1 = inheritIfRequired$4;
var isPrototypeOf$2 = objectIsPrototypeOf;
var isSymbol$1 = isSymbol$5;
var toPrimitive = toPrimitive$2;
var fails$a = fails$D;
var getOwnPropertyNames$2 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var defineProperty$2 = objectDefineProperty.f;
var thisNumberValue = thisNumberValue$1;
var trim = stringTrim.trim;
var NUMBER = "Number";
var NativeNumber = global$h[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError$5 = global$h.TypeError;
var arraySlice$5 = uncurryThis$8("".slice);
var charCodeAt = uncurryThis$8("".charCodeAt);
var toNumeric = function(value) {
  var primValue = toPrimitive(value, "number");
  return typeof primValue == "bigint" ? primValue : toNumber(primValue);
};
var toNumber = function(argument) {
  var it = toPrimitive(argument, "number");
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol$1(it))
    throw TypeError$5("Cannot convert a Symbol value to a number");
  if (typeof it == "string" && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120)
        return NaN;
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66:
        case 98:
          radix = 2;
          maxCode = 49;
          break;
        case 79:
        case 111:
          radix = 8;
          maxCode = 55;
          break;
        default:
          return +it;
      }
      digits = arraySlice$5(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        if (code < 48 || code > maxCode)
          return NaN;
      }
      return parseInt(digits, radix);
    }
  }
  return +it;
};
if (isForced(NUMBER, !NativeNumber(" 0o1") || !NativeNumber("0b1") || NativeNumber("+0x1"))) {
  var NumberWrapper = function Number2(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    return isPrototypeOf$2(NumberPrototype, dummy) && fails$a(function() {
      thisNumberValue(dummy);
    }) ? inheritIfRequired$1(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys$1 = DESCRIPTORS$3 ? getOwnPropertyNames$2(NativeNumber) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(","), j$1 = 0, key$1; keys$1.length > j$1; j$1++) {
    if (hasOwn$2(NativeNumber, key$1 = keys$1[j$1]) && !hasOwn$2(NumberWrapper, key$1)) {
      defineProperty$2(NumberWrapper, key$1, getOwnPropertyDescriptor$1(NativeNumber, key$1));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine$1(global$h, NUMBER, NumberWrapper);
}
var __defProp$L = Object.defineProperty;
var __getOwnPropDesc$B = Object.getOwnPropertyDescriptor;
var __decorateClass$B = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$L(target, key, result);
  return result;
};
var GenericResponseEntity = /* @__PURE__ */ _createClass(function GenericResponseEntity2() {
  _classCallCheck(this, GenericResponseEntity2);
  this.count = 0;
  this.next = null;
  this.previous = null;
});
__decorateClass$B([JsonProperty("count", Number, true)], GenericResponseEntity.prototype, "count", 2);
__decorateClass$B([JsonProperty("next", String, true)], GenericResponseEntity.prototype, "next", 2);
__decorateClass$B([JsonProperty("previous", String, true)], GenericResponseEntity.prototype, "previous", 2);
GenericResponseEntity = __decorateClass$B([JsonObject("GenericResponseEntity")], GenericResponseEntity);
var AccountPermissionsEntity = /* @__PURE__ */ _createClass(function AccountPermissionsEntity2() {
  _classCallCheck(this, AccountPermissionsEntity2);
  this.account = null;
  this.id = 0;
  this.permission_create_account_credential = false;
  this.permission_download_resident = false;
  this.permission_download_unit = false;
  this.permission_download_work_order = false;
  this.permission_edit_account_credential = false;
  this.permission_mobile_photo_annotation = false;
  this.permission_define_approval_steps = false;
  this.permission_live_chat = false;
  this.permission_login_with_sso = false;
  this.permission_sso_get_properties_from_idp = false;
  this.permission_sso_get_role_from_idp = false;
  this.permission_upload_sftp = false;
  this.permission_upload_work_order = false;
  this.permission_view_account_credential = false;
  this.permission_view_code_templates_tasks = false;
  this.permission_view_contacts = false;
  this.permission_view_dashboard = false;
  this.permission_view_documents = false;
  this.permission_view_documents_setup = false;
  this.permission_view_dynamic_forms = false;
  this.permission_view_help_section = false;
  this.permission_view_on_demand_instructions = false;
  this.permission_view_property_groups = false;
  this.permission_view_reports = false;
  this.permission_view_reports_mimo = false;
  this.permission_view_templates = false;
  this.permission_view_templates_calendar = false;
  this.permission_view_trigger_templates = false;
  this.permission_view_make_ready_board = false;
  this.permission_resident_inspection = false;
  this.permission_view_unit_workflows = false;
  this.permission_view_units = false;
  this.permission_view_work_order = false;
  this.permission_view_workflows = false;
  this.white_label = 0;
});
__decorateClass$B([JsonProperty("account", Number, true)], AccountPermissionsEntity.prototype, "account", 2);
__decorateClass$B([JsonProperty("id", Number, true)], AccountPermissionsEntity.prototype, "id", 2);
__decorateClass$B([JsonProperty("permission_create_account_credential", Boolean, true)], AccountPermissionsEntity.prototype, "permission_create_account_credential", 2);
__decorateClass$B([JsonProperty("permission_download_resident", Boolean, true)], AccountPermissionsEntity.prototype, "permission_download_resident", 2);
__decorateClass$B([JsonProperty("permission_download_unit", Boolean, true)], AccountPermissionsEntity.prototype, "permission_download_unit", 2);
__decorateClass$B([JsonProperty("permission_download_work_order", Boolean, true)], AccountPermissionsEntity.prototype, "permission_download_work_order", 2);
__decorateClass$B([JsonProperty("permission_edit_account_credential", Boolean, true)], AccountPermissionsEntity.prototype, "permission_edit_account_credential", 2);
__decorateClass$B([JsonProperty("permission_mobile_photo_annotation", Boolean)], AccountPermissionsEntity.prototype, "permission_mobile_photo_annotation", 2);
__decorateClass$B([JsonProperty("permission_define_approval_steps", Boolean)], AccountPermissionsEntity.prototype, "permission_define_approval_steps", 2);
__decorateClass$B([JsonProperty("permission_live_chat", Boolean)], AccountPermissionsEntity.prototype, "permission_live_chat", 2);
__decorateClass$B([JsonProperty("permission_login_with_sso", Boolean, true)], AccountPermissionsEntity.prototype, "permission_login_with_sso", 2);
__decorateClass$B([JsonProperty("permission_sso_get_properties_from_idp", Boolean, true)], AccountPermissionsEntity.prototype, "permission_sso_get_properties_from_idp", 2);
__decorateClass$B([JsonProperty("permission_sso_get_role_from_idp", Boolean, true)], AccountPermissionsEntity.prototype, "permission_sso_get_role_from_idp", 2);
__decorateClass$B([JsonProperty("permission_upload_sftp", Boolean)], AccountPermissionsEntity.prototype, "permission_upload_sftp", 2);
__decorateClass$B([JsonProperty("permission_upload_work_order", Boolean, true)], AccountPermissionsEntity.prototype, "permission_upload_work_order", 2);
__decorateClass$B([JsonProperty("permission_view_account_credential", Boolean, true)], AccountPermissionsEntity.prototype, "permission_view_account_credential", 2);
__decorateClass$B([JsonProperty("permission_view_code_templates_tasks", Boolean)], AccountPermissionsEntity.prototype, "permission_view_code_templates_tasks", 2);
__decorateClass$B([JsonProperty("permission_view_contacts", Boolean)], AccountPermissionsEntity.prototype, "permission_view_contacts", 2);
__decorateClass$B([JsonProperty("permission_view_dashboard", Boolean)], AccountPermissionsEntity.prototype, "permission_view_dashboard", 2);
__decorateClass$B([JsonProperty("permission_view_documents", Boolean)], AccountPermissionsEntity.prototype, "permission_view_documents", 2);
__decorateClass$B([JsonProperty("permission_view_documents_setup", Boolean)], AccountPermissionsEntity.prototype, "permission_view_documents_setup", 2);
__decorateClass$B([JsonProperty("permission_view_dynamic_forms", Boolean)], AccountPermissionsEntity.prototype, "permission_view_dynamic_forms", 2);
__decorateClass$B([JsonProperty("permission_view_help_section", Boolean)], AccountPermissionsEntity.prototype, "permission_view_help_section", 2);
__decorateClass$B([JsonProperty("permission_view_on_demand_instructions", Boolean)], AccountPermissionsEntity.prototype, "permission_view_on_demand_instructions", 2);
__decorateClass$B([JsonProperty("permission_view_property_groups", Boolean)], AccountPermissionsEntity.prototype, "permission_view_property_groups", 2);
__decorateClass$B([JsonProperty("permission_view_reports", Boolean)], AccountPermissionsEntity.prototype, "permission_view_reports", 2);
__decorateClass$B([JsonProperty("permission_view_reports_mimo", Boolean, true)], AccountPermissionsEntity.prototype, "permission_view_reports_mimo", 2);
__decorateClass$B([JsonProperty("permission_view_templates", Boolean)], AccountPermissionsEntity.prototype, "permission_view_templates", 2);
__decorateClass$B([JsonProperty("permission_view_templates_calendar", Boolean)], AccountPermissionsEntity.prototype, "permission_view_templates_calendar", 2);
__decorateClass$B([JsonProperty("permission_view_trigger_templates", Boolean)], AccountPermissionsEntity.prototype, "permission_view_trigger_templates", 2);
__decorateClass$B([JsonProperty("permission_view_make_ready_board", Boolean)], AccountPermissionsEntity.prototype, "permission_view_make_ready_board", 2);
__decorateClass$B([JsonProperty("permission_resident_inspection", Boolean)], AccountPermissionsEntity.prototype, "permission_resident_inspection", 2);
__decorateClass$B([JsonProperty("permission_view_unit_workflows", Boolean)], AccountPermissionsEntity.prototype, "permission_view_unit_workflows", 2);
__decorateClass$B([JsonProperty("permission_view_units", Boolean)], AccountPermissionsEntity.prototype, "permission_view_units", 2);
__decorateClass$B([JsonProperty("permission_view_work_order", Boolean)], AccountPermissionsEntity.prototype, "permission_view_work_order", 2);
__decorateClass$B([JsonProperty("permission_view_workflows", Boolean)], AccountPermissionsEntity.prototype, "permission_view_workflows", 2);
__decorateClass$B([JsonProperty("white_label", Number, true)], AccountPermissionsEntity.prototype, "white_label", 2);
AccountPermissionsEntity = __decorateClass$B([JsonObject("AccountPermissionsEntity")], AccountPermissionsEntity);
function _createSuper$G(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$G();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$G() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$K = Object.defineProperty;
var __getOwnPropDesc$A = Object.getOwnPropertyDescriptor;
var __decorateClass$A = function __decorateClass2(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$K(target, key, result);
  return result;
};
var SectorResultEntity = /* @__PURE__ */ _createClass(function SectorResultEntity2() {
  _classCallCheck(this, SectorResultEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$A([JsonProperty("id", Number)], SectorResultEntity.prototype, "id", 2);
__decorateClass$A([JsonProperty("name", String)], SectorResultEntity.prototype, "name", 2);
SectorResultEntity = __decorateClass$A([JsonObject("SectorResultEntity")], SectorResultEntity);
var SectorResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(SectorResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$G(SectorResponseEntity2);
  function SectorResponseEntity2() {
    var _this;
    _classCallCheck(this, SectorResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(SectorResponseEntity2);
}(GenericResponseEntity);
__decorateClass$A([JsonProperty("results", [SectorResultEntity])], SectorResponseEntity.prototype, "results", 2);
SectorResponseEntity = __decorateClass$A([JsonObject("SectorResponseEntity")], SectorResponseEntity);
var SectorUrls = {
  sectors: "/api/2.0/sectors/"
};
function _createSuper$F(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$F();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$F() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$a(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$a(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$a(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$a(o, minLen);
}
function _arrayLikeToArray$a(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$J = Object.defineProperty;
var __defProps$9 = Object.defineProperties;
var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = function __defNormalProp6(obj, key, value) {
  return key in obj ? __defProp$J(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$a = function __spreadValues6(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$a) {
    var _iterator = _createForOfIteratorHelper$a(__getOwnPropSymbols$a(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$a.call(b, prop))
          __defNormalProp$a(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$9 = function __spreadProps4(a, b) {
  return __defProps$9(a, __getOwnPropDescs$9(b));
};
var SECTOR_CACHE_KEYS = {
  list: "sector"
};
var SectorDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(SectorDm2, _DmLeonardo);
  var _super = _createSuper$F(SectorDm2);
  function SectorDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, SectorDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-sector";
    return _this;
  }
  _createClass(SectorDm2, [{
    key: "getSectorsList",
    value: function getSectorsList(params) {
      var _this2 = this;
      var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var url = SectorUrls.sectors;
      var finalParams = this.parseGenericParams(__spreadProps$9(__spreadValues$a({}, params), {
        modifier: "essential"
      }));
      return this._client.get({
        url,
        params: finalParams,
        cache: SECTOR_CACHE_KEYS.list,
        force
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, SectorResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }]);
  return SectorDm2;
}(DmLeonardo);
var AccountUrls = {
  accounts: "/api/2.0/accounts/",
  accountId: "/api/2.0/accounts/{id}"
};
var $$3 = _export;
var $find$1 = arrayIteration.find;
var addToUnscopables = addToUnscopables$3;
var FIND = "find";
var SKIPS_HOLES = true;
if (FIND in [])
  Array(1)[FIND](function() {
    SKIPS_HOLES = false;
  });
$$3({
  target: "Array",
  proto: true,
  forced: SKIPS_HOLES
}, {
  find: function find2(callbackfn) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  }
});
addToUnscopables(FIND);
var __defProp$I = Object.defineProperty;
var __getOwnPropDesc$z = Object.getOwnPropertyDescriptor;
var __decorateClass$z = function __decorateClass3(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$I(target, key, result);
  return result;
};
var SectorConverter = /* @__PURE__ */ function() {
  function SectorConverter2() {
    _classCallCheck(this, SectorConverter2);
  }
  _createClass(SectorConverter2, [{
    key: "serialize",
    value: function serialize(data2) {
      var _a;
      if (typeof data2 === "string") {
        var sector = (_a = DmCache.getInstance().get(SECTOR_CACHE_KEYS.list)) == null ? void 0 : _a.results.find(function(s) {
          return s.name === data2;
        });
        if (sector) {
          return sector.id;
        }
      } else if (typeof data2 === "number") {
        return data2;
      }
      return 0;
    }
  }, {
    key: "deserialize",
    value: function deserialize(data2) {
      var _a;
      var sector = (_a = DmCache.getInstance().get(SECTOR_CACHE_KEYS.list)) == null ? void 0 : _a.results.find(function(s) {
        return s.id === data2;
      });
      if (sector) {
        return sector.name;
      }
      return "";
    }
  }]);
  return SectorConverter2;
}();
SectorConverter = __decorateClass$z([JsonConverter], SectorConverter);
function _createSuper$E(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$E();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$E() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$H = Object.defineProperty;
var __getOwnPropDesc$y = Object.getOwnPropertyDescriptor;
var __decorateClass$y = function __decorateClass4(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$H(target, key, result);
  return result;
};
var AccountEssentialWhiteLabelEntity = /* @__PURE__ */ _createClass(function AccountEssentialWhiteLabelEntity2() {
  _classCallCheck(this, AccountEssentialWhiteLabelEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$y([JsonProperty("id", Number)], AccountEssentialWhiteLabelEntity.prototype, "id", 2);
__decorateClass$y([JsonProperty("name", String)], AccountEssentialWhiteLabelEntity.prototype, "name", 2);
AccountEssentialWhiteLabelEntity = __decorateClass$y([JsonObject("AccountEssentialWhiteLabelEntity")], AccountEssentialWhiteLabelEntity);
var AccountListEssentialResultEntity = /* @__PURE__ */ _createClass(function AccountListEssentialResultEntity2() {
  _classCallCheck(this, AccountListEssentialResultEntity2);
  this.alias = "";
  this.id = 0;
  this.name = "";
  this.sector = 0;
  this.status = 0;
  this.updating = false;
  this.white_label = null;
});
__decorateClass$y([JsonProperty("alias", String, true)], AccountListEssentialResultEntity.prototype, "alias", 2);
__decorateClass$y([JsonProperty("id", Number)], AccountListEssentialResultEntity.prototype, "id", 2);
__decorateClass$y([JsonProperty("name", String)], AccountListEssentialResultEntity.prototype, "name", 2);
__decorateClass$y([JsonProperty("sector", SectorConverter)], AccountListEssentialResultEntity.prototype, "sector", 2);
__decorateClass$y([JsonProperty("status", Number)], AccountListEssentialResultEntity.prototype, "status", 2);
__decorateClass$y([JsonProperty("updating", Boolean)], AccountListEssentialResultEntity.prototype, "updating", 2);
__decorateClass$y([JsonProperty("white_label", AccountEssentialWhiteLabelEntity, true)], AccountListEssentialResultEntity.prototype, "white_label", 2);
AccountListEssentialResultEntity = __decorateClass$y([JsonObject("AccountListEssentialResultEntity")], AccountListEssentialResultEntity);
var AccountListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(AccountListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$E(AccountListEssentialResponseEntity2);
  function AccountListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, AccountListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(AccountListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$y([JsonProperty("results", [AccountListEssentialResultEntity])], AccountListEssentialResponseEntity.prototype, "results", 2);
AccountListEssentialResponseEntity = __decorateClass$y([JsonObject("AccountListEssentialResponseEntity")], AccountListEssentialResponseEntity);
function _createSuper$D(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$D();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$D() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$G = Object.defineProperty;
var __getOwnPropDesc$x = Object.getOwnPropertyDescriptor;
var __decorateClass$x = function __decorateClass5(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$G(target, key, result);
  return result;
};
var AccountSummaryWhiteLabelEntity = /* @__PURE__ */ function(_AccountEssentialWhit) {
  _inherits(AccountSummaryWhiteLabelEntity2, _AccountEssentialWhit);
  var _super = _createSuper$D(AccountSummaryWhiteLabelEntity2);
  function AccountSummaryWhiteLabelEntity2() {
    _classCallCheck(this, AccountSummaryWhiteLabelEntity2);
    return _super.apply(this, arguments);
  }
  return _createClass(AccountSummaryWhiteLabelEntity2);
}(AccountEssentialWhiteLabelEntity);
AccountSummaryWhiteLabelEntity = __decorateClass$x([JsonObject("AccountSummaryWhiteLabelEntity")], AccountSummaryWhiteLabelEntity);
var UserEntity = /* @__PURE__ */ _createClass(function UserEntity2() {
  _classCallCheck(this, UserEntity2);
  this.email = "";
  this.first_name = "";
  this.id = 0;
  this.last_name = "";
});
__decorateClass$x([JsonProperty("email", String)], UserEntity.prototype, "email", 2);
__decorateClass$x([JsonProperty("first_name", String)], UserEntity.prototype, "first_name", 2);
__decorateClass$x([JsonProperty("id", Number)], UserEntity.prototype, "id", 2);
__decorateClass$x([JsonProperty("last_name", String)], UserEntity.prototype, "last_name", 2);
UserEntity = __decorateClass$x([JsonObject("UserEntity")], UserEntity);
var OwnerEntity = /* @__PURE__ */ _createClass(function OwnerEntity2() {
  _classCallCheck(this, OwnerEntity2);
  this.account = 0;
  this.account_status = 0;
  this.id = 0;
  this.is_active = false;
  this.role = 0;
  this.user = new UserEntity();
});
__decorateClass$x([JsonProperty("account", Number)], OwnerEntity.prototype, "account", 2);
__decorateClass$x([JsonProperty("account_status", Number)], OwnerEntity.prototype, "account_status", 2);
__decorateClass$x([JsonProperty("id", Number)], OwnerEntity.prototype, "id", 2);
__decorateClass$x([JsonProperty("is_active", Boolean)], OwnerEntity.prototype, "is_active", 2);
__decorateClass$x([JsonProperty("role", Number)], OwnerEntity.prototype, "role", 2);
__decorateClass$x([JsonProperty("user", UserEntity)], OwnerEntity.prototype, "user", 2);
OwnerEntity = __decorateClass$x([JsonObject("OwnerEntity")], OwnerEntity);
var AccountListSummaryResultEntity = /* @__PURE__ */ function(_AccountListEssential) {
  _inherits(AccountListSummaryResultEntity2, _AccountListEssential);
  var _super2 = _createSuper$D(AccountListSummaryResultEntity2);
  function AccountListSummaryResultEntity2() {
    var _this;
    _classCallCheck(this, AccountListSummaryResultEntity2);
    _this = _super2.apply(this, arguments);
    _this.owners = [];
    return _this;
  }
  return _createClass(AccountListSummaryResultEntity2);
}(AccountListEssentialResultEntity);
__decorateClass$x([JsonProperty("owners", [OwnerEntity], true)], AccountListSummaryResultEntity.prototype, "owners", 2);
AccountListSummaryResultEntity = __decorateClass$x([JsonObject("AccountListSummaryResultEntity")], AccountListSummaryResultEntity);
var AccountListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(AccountListSummaryResponseEntity2, _GenericResponseEntit);
  var _super3 = _createSuper$D(AccountListSummaryResponseEntity2);
  function AccountListSummaryResponseEntity2() {
    var _this2;
    _classCallCheck(this, AccountListSummaryResponseEntity2);
    _this2 = _super3.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(AccountListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$x([JsonProperty("results", [AccountListSummaryResultEntity])], AccountListSummaryResponseEntity.prototype, "results", 2);
AccountListSummaryResponseEntity = __decorateClass$x([JsonObject("AccountListSummaryResponseEntity")], AccountListSummaryResponseEntity);
function _createSuper$C(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$C();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$C() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$F = Object.defineProperty;
var __getOwnPropDesc$w = Object.getOwnPropertyDescriptor;
var __decorateClass$w = function __decorateClass6(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$F(target, key, result);
  return result;
};
var PartialUserEntity = /* @__PURE__ */ _createClass(function PartialUserEntity2() {
  _classCallCheck(this, PartialUserEntity2);
  this.first_name = "";
  this.id = 0;
  this.last_name = "";
});
__decorateClass$w([JsonProperty("first_name", String)], PartialUserEntity.prototype, "first_name", 2);
__decorateClass$w([JsonProperty("id", Number)], PartialUserEntity.prototype, "id", 2);
__decorateClass$w([JsonProperty("last_name", String)], PartialUserEntity.prototype, "last_name", 2);
PartialUserEntity = __decorateClass$w([JsonObject("PartialUserEntity")], PartialUserEntity);
var AccountUserEntity = /* @__PURE__ */ _createClass(function AccountUserEntity2() {
  _classCallCheck(this, AccountUserEntity2);
  this.id = 0;
  this.user = new PartialUserEntity();
});
__decorateClass$w([JsonProperty("id", Number)], AccountUserEntity.prototype, "id", 2);
__decorateClass$w([JsonProperty("user", PartialUserEntity)], AccountUserEntity.prototype, "user", 2);
AccountUserEntity = __decorateClass$w([JsonObject("AccountUserEntity")], AccountUserEntity);
var CountryEntity = /* @__PURE__ */ _createClass(function CountryEntity2() {
  _classCallCheck(this, CountryEntity2);
  this.code = "";
  this.date_mask = "";
  this.id = 0;
  this.level_1_label = "";
  this.level_2_label = "";
  this.level_3_label = "";
  this.level_4_label = "";
  this.name = "";
  this.phone_mask = "";
});
__decorateClass$w([JsonProperty("code", String)], CountryEntity.prototype, "code", 2);
__decorateClass$w([JsonProperty("date_mask", String)], CountryEntity.prototype, "date_mask", 2);
__decorateClass$w([JsonProperty("id", Number)], CountryEntity.prototype, "id", 2);
__decorateClass$w([JsonProperty("level_1_label", String)], CountryEntity.prototype, "level_1_label", 2);
__decorateClass$w([JsonProperty("level_2_label", String)], CountryEntity.prototype, "level_2_label", 2);
__decorateClass$w([JsonProperty("level_3_label", String)], CountryEntity.prototype, "level_3_label", 2);
__decorateClass$w([JsonProperty("level_4_label", String)], CountryEntity.prototype, "level_4_label", 2);
__decorateClass$w([JsonProperty("name", String)], CountryEntity.prototype, "name", 2);
__decorateClass$w([JsonProperty("phone_mask", String)], CountryEntity.prototype, "phone_mask", 2);
CountryEntity = __decorateClass$w([JsonObject("CountryEntity")], CountryEntity);
var PortfolioEntity = /* @__PURE__ */ _createClass(function PortfolioEntity2() {
  _classCallCheck(this, PortfolioEntity2);
  this.full_management = false;
  this.id = 0;
  this.name = "";
});
__decorateClass$w([JsonProperty("full_management", Boolean)], PortfolioEntity.prototype, "full_management", 2);
__decorateClass$w([JsonProperty("id", Number)], PortfolioEntity.prototype, "id", 2);
__decorateClass$w([JsonProperty("name", String)], PortfolioEntity.prototype, "name", 2);
PortfolioEntity = __decorateClass$w([JsonObject("PortfolioEntity")], PortfolioEntity);
var PropertyEntity = /* @__PURE__ */ function(_PortfolioEntity) {
  _inherits(PropertyEntity2, _PortfolioEntity);
  var _super = _createSuper$C(PropertyEntity2);
  function PropertyEntity2() {
    _classCallCheck(this, PropertyEntity2);
    return _super.apply(this, arguments);
  }
  return _createClass(PropertyEntity2);
}(PortfolioEntity);
PropertyEntity = __decorateClass$w([JsonObject("PropertyEntity")], PropertyEntity);
var ManagedByMeEntity = /* @__PURE__ */ _createClass(function ManagedByMeEntity2() {
  _classCallCheck(this, ManagedByMeEntity2);
  this.account_users = [];
  this.id = 0;
  this.name = "";
  this.portfolios = [];
  this.properties = [];
});
__decorateClass$w([JsonProperty("account_users", [AccountUserEntity])], ManagedByMeEntity.prototype, "account_users", 2);
__decorateClass$w([JsonProperty("id", String)], ManagedByMeEntity.prototype, "id", 2);
__decorateClass$w([JsonProperty("name", String)], ManagedByMeEntity.prototype, "name", 2);
__decorateClass$w([JsonProperty("portfolios", [PortfolioEntity])], ManagedByMeEntity.prototype, "portfolios", 2);
__decorateClass$w([JsonProperty("properties", [PropertyEntity])], ManagedByMeEntity.prototype, "properties", 2);
ManagedByMeEntity = __decorateClass$w([JsonObject("ManagedByMeEntity")], ManagedByMeEntity);
var ManagedToMeEntity = /* @__PURE__ */ _createClass(function ManagedToMeEntity2() {
  _classCallCheck(this, ManagedToMeEntity2);
  this.id = 0;
  this.name = "";
  this.portfolios = [];
  this.properties = [];
});
__decorateClass$w([JsonProperty("id", Number)], ManagedToMeEntity.prototype, "id", 2);
__decorateClass$w([JsonProperty("name", String)], ManagedToMeEntity.prototype, "name", 2);
__decorateClass$w([JsonProperty("portfolios", [PortfolioEntity])], ManagedToMeEntity.prototype, "portfolios", 2);
__decorateClass$w([JsonProperty("properties", [PropertyEntity])], ManagedToMeEntity.prototype, "properties", 2);
ManagedToMeEntity = __decorateClass$w([JsonObject("ManagedToMeEntity")], ManagedToMeEntity);
var AccountListCompleteResultEntity = /* @__PURE__ */ function(_AccountListSummaryRe) {
  _inherits(AccountListCompleteResultEntity2, _AccountListSummaryRe);
  var _super2 = _createSuper$C(AccountListCompleteResultEntity2);
  function AccountListCompleteResultEntity2() {
    var _this;
    _classCallCheck(this, AccountListCompleteResultEntity2);
    _this = _super2.apply(this, arguments);
    _this.country = null;
    _this.managed_by_me = [];
    _this.managed_to_me = [];
    _this.permissions = new AccountPermissionsEntity();
    _this.progress_critical_danger = "";
    _this.progress_critical_warning = "";
    _this.progress_minor_danger = "";
    _this.progress_minor_warning = "";
    _this.progress_normal_danger = "";
    _this.progress_normal_warning = "";
    _this.white_label = null;
    return _this;
  }
  return _createClass(AccountListCompleteResultEntity2);
}(AccountListSummaryResultEntity);
__decorateClass$w([JsonProperty("country", CountryEntity, true)], AccountListCompleteResultEntity.prototype, "country", 2);
__decorateClass$w([JsonProperty("managed_by_me", [ManagedByMeEntity])], AccountListCompleteResultEntity.prototype, "managed_by_me", 2);
__decorateClass$w([JsonProperty("managed_to_me", [ManagedToMeEntity])], AccountListCompleteResultEntity.prototype, "managed_to_me", 2);
__decorateClass$w([JsonProperty("permissions", AccountPermissionsEntity)], AccountListCompleteResultEntity.prototype, "permissions", 2);
__decorateClass$w([JsonProperty("progress_critical_danger", String)], AccountListCompleteResultEntity.prototype, "progress_critical_danger", 2);
__decorateClass$w([JsonProperty("progress_critical_warning", String)], AccountListCompleteResultEntity.prototype, "progress_critical_warning", 2);
__decorateClass$w([JsonProperty("progress_minor_danger", String)], AccountListCompleteResultEntity.prototype, "progress_minor_danger", 2);
__decorateClass$w([JsonProperty("progress_minor_warning", String)], AccountListCompleteResultEntity.prototype, "progress_minor_warning", 2);
__decorateClass$w([JsonProperty("progress_normal_danger", String)], AccountListCompleteResultEntity.prototype, "progress_normal_danger", 2);
__decorateClass$w([JsonProperty("progress_normal_warning", String)], AccountListCompleteResultEntity.prototype, "progress_normal_warning", 2);
__decorateClass$w([JsonProperty("white_label", Number, true)], AccountListCompleteResultEntity.prototype, "white_label", 2);
AccountListCompleteResultEntity = __decorateClass$w([JsonObject("AccountListCompleteResultEntity")], AccountListCompleteResultEntity);
var AccountListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(AccountListCompleteResponseEntity2, _GenericResponseEntit);
  var _super3 = _createSuper$C(AccountListCompleteResponseEntity2);
  function AccountListCompleteResponseEntity2() {
    var _this2;
    _classCallCheck(this, AccountListCompleteResponseEntity2);
    _this2 = _super3.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(AccountListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$w([JsonProperty("results", [AccountListCompleteResultEntity])], AccountListCompleteResponseEntity.prototype, "results", 2);
AccountListCompleteResponseEntity = __decorateClass$w([JsonObject("AccountListCompleteResponseEntity")], AccountListCompleteResponseEntity);
function _createSuper$B(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$B();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$B() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$E = Object.defineProperty;
var __getOwnPropDesc$v = Object.getOwnPropertyDescriptor;
var __decorateClass$v = function __decorateClass7(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$E(target, key, result);
  return result;
};
var AccountGetResponseEntity = /* @__PURE__ */ function(_AccountListCompleteR) {
  _inherits(AccountGetResponseEntity2, _AccountListCompleteR);
  var _super = _createSuper$B(AccountGetResponseEntity2);
  function AccountGetResponseEntity2() {
    _classCallCheck(this, AccountGetResponseEntity2);
    return _super.apply(this, arguments);
  }
  return _createClass(AccountGetResponseEntity2);
}(AccountListCompleteResultEntity);
AccountGetResponseEntity = __decorateClass$v([JsonObject("AccountGetResponseEntity")], AccountGetResponseEntity);
var __defProp$D = Object.defineProperty;
var __getOwnPropDesc$u = Object.getOwnPropertyDescriptor;
var __decorateClass$u = function __decorateClass8(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$D(target, key, result);
  return result;
};
var CreateUserEntity = /* @__PURE__ */ _createClass(function CreateUserEntity2() {
  _classCallCheck(this, CreateUserEntity2);
  this.email = "";
  this.first_name = "";
  this.last_name = "";
  this.password = "";
});
__decorateClass$u([JsonProperty("email", String)], CreateUserEntity.prototype, "email", 2);
__decorateClass$u([JsonProperty("first_name", String)], CreateUserEntity.prototype, "first_name", 2);
__decorateClass$u([JsonProperty("last_name", String)], CreateUserEntity.prototype, "last_name", 2);
__decorateClass$u([JsonProperty("password", String)], CreateUserEntity.prototype, "password", 2);
CreateUserEntity = __decorateClass$u([JsonObject("CreateUserEntity")], CreateUserEntity);
var AccountCreateRequestEntity = /* @__PURE__ */ _createClass(function AccountCreateRequestEntity2() {
  _classCallCheck(this, AccountCreateRequestEntity2);
  this.country = "";
  this.name = "";
  this.permissions = new AccountPermissionsEntity();
  this.sector = "";
  this.status = "";
  this.time_zone = "";
  this.user = new CreateUserEntity();
  this.white_label = "";
});
__decorateClass$u([JsonProperty("country", String, true)], AccountCreateRequestEntity.prototype, "country", 2);
__decorateClass$u([JsonProperty("name", String)], AccountCreateRequestEntity.prototype, "name", 2);
__decorateClass$u([JsonProperty("permissions", AccountPermissionsEntity)], AccountCreateRequestEntity.prototype, "permissions", 2);
__decorateClass$u([JsonProperty("sector", String)], AccountCreateRequestEntity.prototype, "sector", 2);
__decorateClass$u([JsonProperty("status", String)], AccountCreateRequestEntity.prototype, "status", 2);
__decorateClass$u([JsonProperty("time_zone", String, true)], AccountCreateRequestEntity.prototype, "time_zone", 2);
__decorateClass$u([JsonProperty("user", CreateUserEntity)], AccountCreateRequestEntity.prototype, "user", 2);
__decorateClass$u([JsonProperty("white_label", String, true)], AccountCreateRequestEntity.prototype, "white_label", 2);
AccountCreateRequestEntity = __decorateClass$u([JsonObject("AccountCreateRequestEntity")], AccountCreateRequestEntity);
var AccountUpdateRequestEntity = /* @__PURE__ */ _createClass(function AccountUpdateRequestEntity2() {
  _classCallCheck(this, AccountUpdateRequestEntity2);
  this.country = "";
  this.name = "";
  this.permissions = new AccountPermissionsEntity();
  this.sector = "";
  this.status = "";
  this.time_zone = "";
  this.user = new CreateUserEntity();
  this.white_label = "";
});
__decorateClass$u([JsonProperty("country", String, true)], AccountUpdateRequestEntity.prototype, "country", 2);
__decorateClass$u([JsonProperty("name", String)], AccountUpdateRequestEntity.prototype, "name", 2);
__decorateClass$u([JsonProperty("permissions", AccountPermissionsEntity)], AccountUpdateRequestEntity.prototype, "permissions", 2);
__decorateClass$u([JsonProperty("sector", String, true)], AccountUpdateRequestEntity.prototype, "sector", 2);
__decorateClass$u([JsonProperty("status", String, true)], AccountUpdateRequestEntity.prototype, "status", 2);
__decorateClass$u([JsonProperty("time_zone", String, true)], AccountUpdateRequestEntity.prototype, "time_zone", 2);
__decorateClass$u([JsonProperty("user", CreateUserEntity)], AccountUpdateRequestEntity.prototype, "user", 2);
__decorateClass$u([JsonProperty("white_label", String, true)], AccountUpdateRequestEntity.prototype, "white_label", 2);
AccountUpdateRequestEntity = __decorateClass$u([JsonObject("AccountUpdateRequestEntity")], AccountUpdateRequestEntity);
function _createSuper$A(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$A();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$A() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$9(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$9(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$9(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$9(o, minLen);
}
function _arrayLikeToArray$9(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$C = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = function __defNormalProp7(obj, key, value) {
  return key in obj ? __defProp$C(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$9 = function __spreadValues7(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$9) {
    var _iterator = _createForOfIteratorHelper$9(__getOwnPropSymbols$9(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$9.call(b, prop))
          __defNormalProp$9(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var ACCOUNT_CACHE_KEYS = {
  list: "accounts",
  filter: "account-filter",
  get: function get(id2) {
    return "account__".concat(id2);
  }
};
var AccountDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(AccountDm2, _DmLeonardo);
  var _super = _createSuper$A(AccountDm2);
  function AccountDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, AccountDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-account";
    return _this;
  }
  _createClass(AccountDm2, [{
    key: "getAccountsList",
    value: function getAccountsList(params) {
      var _this2 = this;
      var url = AccountUrls.accounts;
      var finalParams = this.parseGenericParams(__spreadValues$9({
        modifier: "summary"
      }, params));
      return new SectorDm().getSectorsList().then(function() {
        return _this2._client.get({
          url,
          params: finalParams,
          cache: ACCOUNT_CACHE_KEYS.list
        }).then(function(_ref) {
          var data2 = _ref.data;
          return _this2._jsonConvert.deserializeObject(data2, AccountListSummaryResponseEntity);
        }).catch(function(e) {
          _this2.logger.error(e);
          throw e;
        });
      });
    }
  }, {
    key: "getAccountsAsFilter",
    value: function getAccountsAsFilter(filter3) {
      return this.getAsGenericFilter(AccountUrls.accounts, ACCOUNT_CACHE_KEYS.filter, AccountListEssentialResponseEntity, __spreadValues$9({
        not_empty: "true"
      }, filter3));
    }
  }, {
    key: "getAccount",
    value: function getAccount(id2) {
      var _this3 = this;
      var url = AccountUrls.accountId;
      return this._client.get({
        url,
        path: {
          id: id2
        },
        cache: ACCOUNT_CACHE_KEYS.get(id2)
      }).then(function(_ref2) {
        var data2 = _ref2.data;
        return _this3._jsonConvert.deserializeObject(data2, AccountGetResponseEntity);
      }).catch(function(e) {
        _this3.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "deleteAccount",
    value: function deleteAccount(id2) {
      var _this4 = this;
      var url = AccountUrls.accountId;
      return this._client.delete({
        url,
        path: {
          id: id2
        },
        cacheReset: new RegExp("^".concat(ACCOUNT_CACHE_KEYS.list, ".*"))
      }).then(function(_ref3) {
        var data2 = _ref3.data;
        return data2;
      }).catch(function(e) {
        _this4.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "createAccount",
    value: function createAccount(content) {
      var _this5 = this;
      var url = AccountUrls.accounts;
      var entity = this._jsonConvert.serializeObject(content, AccountCreateRequestEntity);
      return this._client.post({
        url,
        cacheReset: ACCOUNT_CACHE_KEYS.list
      }, entity).then(function(_ref4) {
        var data2 = _ref4.data;
        return _this5._jsonConvert.deserializeObject(data2, AccountGetResponseEntity);
      }).catch(function(e) {
        _this5.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "updateAccount",
    value: function updateAccount(id2, content) {
      var _this6 = this;
      var url = AccountUrls.accountId;
      var entity = this._jsonConvert.serializeObject(content, AccountUpdateRequestEntity);
      return this._client.patch({
        url,
        path: {
          id: id2
        },
        cacheReset: [ACCOUNT_CACHE_KEYS.get(id2), ACCOUNT_CACHE_KEYS.list]
      }, entity, {
        "Content-Type": "multipart/form-data"
      }).then(function(_ref5) {
        var data2 = _ref5.data;
        return _this6._jsonConvert.deserializeObject(data2, AccountGetResponseEntity);
      }).catch(function(e) {
        _this6.logger.error(e);
        throw e;
      });
    }
  }]);
  return AccountDm2;
}(DmLeonardo);
function useAccountDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new AccountDm(config);
  }, [config]);
  return {
    getAccountsList: useCallback(function(params) {
      return Api.getAccountsList(params);
    }, [Api]),
    getAccountsAsFilter: useCallback(function(filter3) {
      return Api.getAccountsAsFilter(filter3);
    }, [Api]),
    getAccount: useCallback(function(id2) {
      return Api.getAccount(id2);
    }, [Api]),
    createAccount: useCallback(function(params) {
      return Api.createAccount(params);
    }, [Api]),
    updateAccount: useCallback(function(id2, params) {
      return Api.updateAccount(id2, params);
    }, [Api]),
    deleteAccount: useCallback(function(id2) {
      return Api.deleteAccount(id2);
    }, [Api])
  };
}
function _createSuper$z(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$z();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$z() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$B = Object.defineProperty;
var __getOwnPropDesc$t = Object.getOwnPropertyDescriptor;
var __decorateClass$t = function __decorateClass9(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$B(target, key, result);
  return result;
};
var CountryResultEntity = /* @__PURE__ */ _createClass(function CountryResultEntity2() {
  _classCallCheck(this, CountryResultEntity2);
  this.code = "";
  this.date_mask = "";
  this.id = 0;
  this.level_1_label = "";
  this.level_2_label = "";
  this.level_3_label = "";
  this.level_4_label = "";
  this.name = "";
  this.phone_mask = "";
});
__decorateClass$t([JsonProperty("code", String)], CountryResultEntity.prototype, "code", 2);
__decorateClass$t([JsonProperty("date_mask", String)], CountryResultEntity.prototype, "date_mask", 2);
__decorateClass$t([JsonProperty("id", Number)], CountryResultEntity.prototype, "id", 2);
__decorateClass$t([JsonProperty("level_1_label", String)], CountryResultEntity.prototype, "level_1_label", 2);
__decorateClass$t([JsonProperty("level_2_label", String)], CountryResultEntity.prototype, "level_2_label", 2);
__decorateClass$t([JsonProperty("level_3_label", String)], CountryResultEntity.prototype, "level_3_label", 2);
__decorateClass$t([JsonProperty("level_4_label", String)], CountryResultEntity.prototype, "level_4_label", 2);
__decorateClass$t([JsonProperty("name", String)], CountryResultEntity.prototype, "name", 2);
__decorateClass$t([JsonProperty("phone_mask", String)], CountryResultEntity.prototype, "phone_mask", 2);
CountryResultEntity = __decorateClass$t([JsonObject("CountryResultEntity")], CountryResultEntity);
var CountryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(CountryResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$z(CountryResponseEntity2);
  function CountryResponseEntity2() {
    var _this;
    _classCallCheck(this, CountryResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(CountryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$t([JsonProperty("results", [CountryResultEntity])], CountryResponseEntity.prototype, "results", 2);
CountryResponseEntity = __decorateClass$t([JsonObject("CountryResponseEntity")], CountryResponseEntity);
var CountryUrls = {
  countries: "/api/2.0/countries/"
};
function _createSuper$y(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$y();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$y() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$8(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$8(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$8(o, minLen);
}
function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$A = Object.defineProperty;
var __defProps$8 = Object.defineProperties;
var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = function __defNormalProp8(obj, key, value) {
  return key in obj ? __defProp$A(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$8 = function __spreadValues8(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$8) {
    var _iterator = _createForOfIteratorHelper$8(__getOwnPropSymbols$8(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$8.call(b, prop))
          __defNormalProp$8(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$8 = function __spreadProps5(a, b) {
  return __defProps$8(a, __getOwnPropDescs$8(b));
};
var COUNTRY_CACHE_KEYS = {
  list: "country"
};
var CountryDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(CountryDm2, _DmLeonardo);
  var _super = _createSuper$y(CountryDm2);
  function CountryDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, CountryDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-country";
    return _this;
  }
  _createClass(CountryDm2, [{
    key: "getCountriesList",
    value: function getCountriesList(params) {
      var _this2 = this;
      var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var url = CountryUrls.countries;
      var finalParams = this.parseGenericParams(__spreadProps$8(__spreadValues$8({}, params), {
        modifier: "essential"
      }));
      return this._client.get({
        url,
        params: finalParams,
        cache: COUNTRY_CACHE_KEYS.list,
        force
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, CountryResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }]);
  return CountryDm2;
}(DmLeonardo);
function useCountryDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new CountryDm(config);
  }, [config]);
  return {
    getCountriesList: useCallback(function(params) {
      var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      return Api.getCountriesList(params, force);
    }, [Api])
  };
}
function _createSuper$x(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$x();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$x() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$z = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __decorateClass$s = function __decorateClass10(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$z(target, key, result);
  return result;
};
var GroupsListEssentialResultEntity = /* @__PURE__ */ _createClass(function GroupsListEssentialResultEntity2() {
  _classCallCheck(this, GroupsListEssentialResultEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$s([JsonProperty("id", Number)], GroupsListEssentialResultEntity.prototype, "id", 2);
__decorateClass$s([JsonProperty("name", String)], GroupsListEssentialResultEntity.prototype, "name", 2);
GroupsListEssentialResultEntity = __decorateClass$s([JsonObject("GroupsListEssentialResultEntity")], GroupsListEssentialResultEntity);
var GroupsListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(GroupsListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$x(GroupsListEssentialResponseEntity2);
  function GroupsListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, GroupsListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(GroupsListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$s([JsonProperty("results", [GroupsListEssentialResultEntity])], GroupsListEssentialResponseEntity.prototype, "results", 2);
GroupsListEssentialResponseEntity = __decorateClass$s([JsonObject("GroupsListEssentialResponseEntity")], GroupsListEssentialResponseEntity);
function _createSuper$w(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$w();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$w() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$y = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __decorateClass$r = function __decorateClass11(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$y(target, key, result);
  return result;
};
var GroupSummaryPropertyEntity = /* @__PURE__ */ _createClass(function GroupSummaryPropertyEntity2() {
  _classCallCheck(this, GroupSummaryPropertyEntity2);
  this.id = 0;
  this.name = "";
  this.pms_platform = 0;
});
__decorateClass$r([JsonProperty("id", Number)], GroupSummaryPropertyEntity.prototype, "id", 2);
__decorateClass$r([JsonProperty("name", String)], GroupSummaryPropertyEntity.prototype, "name", 2);
__decorateClass$r([JsonProperty("pms_platform", Number)], GroupSummaryPropertyEntity.prototype, "pms_platform", 2);
GroupSummaryPropertyEntity = __decorateClass$r([JsonObject("GroupSummaryPropertyEntity")], GroupSummaryPropertyEntity);
var GroupSummaryPortfolioEntity = /* @__PURE__ */ _createClass(function GroupSummaryPortfolioEntity2() {
  _classCallCheck(this, GroupSummaryPortfolioEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$r([JsonProperty("id", Number)], GroupSummaryPortfolioEntity.prototype, "id", 2);
__decorateClass$r([JsonProperty("name", String)], GroupSummaryPortfolioEntity.prototype, "name", 2);
GroupSummaryPortfolioEntity = __decorateClass$r([JsonObject("GroupSummaryPortfolioEntity")], GroupSummaryPortfolioEntity);
var GroupsListSummaryResultEntity = /* @__PURE__ */ function(_GroupsListEssentialR) {
  _inherits(GroupsListSummaryResultEntity2, _GroupsListEssentialR);
  var _super = _createSuper$w(GroupsListSummaryResultEntity2);
  function GroupsListSummaryResultEntity2() {
    var _this;
    _classCallCheck(this, GroupsListSummaryResultEntity2);
    _this = _super.apply(this, arguments);
    _this.account = 0;
    _this.properties = [];
    _this.portfolios = [];
    return _this;
  }
  return _createClass(GroupsListSummaryResultEntity2);
}(GroupsListEssentialResultEntity);
__decorateClass$r([JsonProperty("account", Number)], GroupsListSummaryResultEntity.prototype, "account", 2);
__decorateClass$r([JsonProperty("properties", [GroupSummaryPropertyEntity])], GroupsListSummaryResultEntity.prototype, "properties", 2);
__decorateClass$r([JsonProperty("portfolios", [GroupSummaryPortfolioEntity])], GroupsListSummaryResultEntity.prototype, "portfolios", 2);
GroupsListSummaryResultEntity = __decorateClass$r([JsonObject("GroupsListSummaryResultEntity")], GroupsListSummaryResultEntity);
var GroupsListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(GroupsListSummaryResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$w(GroupsListSummaryResponseEntity2);
  function GroupsListSummaryResponseEntity2() {
    var _this2;
    _classCallCheck(this, GroupsListSummaryResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(GroupsListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$r([JsonProperty("results", [GroupsListSummaryResultEntity])], GroupsListSummaryResponseEntity.prototype, "results", 2);
GroupsListSummaryResponseEntity = __decorateClass$r([JsonObject("GroupsListSummaryResponseEntity")], GroupsListSummaryResponseEntity);
function _createSuper$v(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$v();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$v() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$x = Object.defineProperty;
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __decorateClass$q = function __decorateClass12(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$x(target, key, result);
  return result;
};
var GroupCompletePropertyEntity = /* @__PURE__ */ function(_GroupSummaryProperty) {
  _inherits(GroupCompletePropertyEntity2, _GroupSummaryProperty);
  var _super = _createSuper$v(GroupCompletePropertyEntity2);
  function GroupCompletePropertyEntity2() {
    var _this;
    _classCallCheck(this, GroupCompletePropertyEntity2);
    _this = _super.apply(this, arguments);
    _this.account = 0;
    _this.portfolio = 0;
    _this.time_zone = "";
    return _this;
  }
  return _createClass(GroupCompletePropertyEntity2);
}(GroupSummaryPropertyEntity);
__decorateClass$q([JsonProperty("account", Number)], GroupCompletePropertyEntity.prototype, "account", 2);
__decorateClass$q([JsonProperty("portfolio", Number)], GroupCompletePropertyEntity.prototype, "portfolio", 2);
__decorateClass$q([JsonProperty("time_zone", Number)], GroupCompletePropertyEntity.prototype, "time_zone", 2);
GroupCompletePropertyEntity = __decorateClass$q([JsonObject("GroupCompletePropertyEntity")], GroupCompletePropertyEntity);
var GroupCompletePortfolioEntity = /* @__PURE__ */ function(_GroupSummaryPortfoli) {
  _inherits(GroupCompletePortfolioEntity2, _GroupSummaryPortfoli);
  var _super2 = _createSuper$v(GroupCompletePortfolioEntity2);
  function GroupCompletePortfolioEntity2() {
    var _this2;
    _classCallCheck(this, GroupCompletePortfolioEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.account = 0;
    return _this2;
  }
  return _createClass(GroupCompletePortfolioEntity2);
}(GroupSummaryPortfolioEntity);
__decorateClass$q([JsonProperty("account", Number)], GroupCompletePortfolioEntity.prototype, "account", 2);
GroupCompletePortfolioEntity = __decorateClass$q([JsonObject("GroupCompletePortfolioEntity")], GroupCompletePortfolioEntity);
var GroupsListCompleteResultEntity = /* @__PURE__ */ function(_GroupsListSummaryRes) {
  _inherits(GroupsListCompleteResultEntity2, _GroupsListSummaryRes);
  var _super3 = _createSuper$v(GroupsListCompleteResultEntity2);
  function GroupsListCompleteResultEntity2() {
    var _this3;
    _classCallCheck(this, GroupsListCompleteResultEntity2);
    _this3 = _super3.apply(this, arguments);
    _this3.account_user = 0;
    _this3.properties = [];
    _this3.portfolios = [];
    return _this3;
  }
  return _createClass(GroupsListCompleteResultEntity2);
}(GroupsListSummaryResultEntity);
__decorateClass$q([JsonProperty("account_user", Number)], GroupsListCompleteResultEntity.prototype, "account_user", 2);
__decorateClass$q([JsonProperty("properties", [GroupCompletePropertyEntity])], GroupsListCompleteResultEntity.prototype, "properties", 2);
__decorateClass$q([JsonProperty("portfolios", [GroupCompletePortfolioEntity])], GroupsListCompleteResultEntity.prototype, "portfolios", 2);
GroupsListCompleteResultEntity = __decorateClass$q([JsonObject("GroupsListCompleteResultEntity")], GroupsListCompleteResultEntity);
var GroupsListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(GroupsListCompleteResponseEntity2, _GenericResponseEntit);
  var _super4 = _createSuper$v(GroupsListCompleteResponseEntity2);
  function GroupsListCompleteResponseEntity2() {
    var _this4;
    _classCallCheck(this, GroupsListCompleteResponseEntity2);
    _this4 = _super4.apply(this, arguments);
    _this4.results = [];
    return _this4;
  }
  return _createClass(GroupsListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$q([JsonProperty("results", [GroupsListCompleteResultEntity])], GroupsListCompleteResponseEntity.prototype, "results", 2);
GroupsListCompleteResponseEntity = __decorateClass$q([JsonObject("GroupsListCompleteResponseEntity")], GroupsListCompleteResponseEntity);
var GroupUrls = {
  group: "/api/2.0/groups/"
};
function _createSuper$u(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$u();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$u() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$7(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$7(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$7(o, minLen);
}
function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$w = Object.defineProperty;
var __defProps$7 = Object.defineProperties;
var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = function __defNormalProp9(obj, key, value) {
  return key in obj ? __defProp$w(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$7 = function __spreadValues9(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$7) {
    var _iterator = _createForOfIteratorHelper$7(__getOwnPropSymbols$7(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$7.call(b, prop))
          __defNormalProp$7(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$7 = function __spreadProps6(a, b) {
  return __defProps$7(a, __getOwnPropDescs$7(b));
};
var GROUP_CACHE_KEYS = {
  list: "group",
  filter: "group-filter"
};
var GroupsDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(GroupsDm2, _DmLeonardo);
  var _super = _createSuper$u(GroupsDm2);
  function GroupsDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, GroupsDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-group";
    return _this;
  }
  _createClass(GroupsDm2, [{
    key: "getGroupsList",
    value: function getGroupsList(params) {
      var _this2 = this;
      var url = GroupUrls.group;
      var finalParams = this.parseGenericParams(__spreadProps$7(__spreadValues$7({}, params), {
        modifier: "summary"
      }));
      return this._client.get({
        url,
        params: finalParams,
        cache: GROUP_CACHE_KEYS.list
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, GroupsListSummaryResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getGroupsAsFilter",
    value: function getGroupsAsFilter(filter3) {
      return this.getAsGenericFilter(GroupUrls.group, GROUP_CACHE_KEYS.filter, GroupsListEssentialResponseEntity, __spreadValues$7({
        not_empty: "true"
      }, filter3));
    }
  }]);
  return GroupsDm2;
}(DmLeonardo);
function useGroupListDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new GroupsDm(config);
  }, [config]);
  return {
    getGroupsList: useCallback(function(params) {
      return Api.getGroupsList(params);
    }, [Api]),
    getGroupsAsFilter: useCallback(function(filter3) {
      return Api.getGroupsAsFilter(filter3);
    }, [Api])
  };
}
var __defProp$v = Object.defineProperty;
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __decorateClass$p = function __decorateClass13(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$v(target, key, result);
  return result;
};
var DateConverter = /* @__PURE__ */ function() {
  function DateConverter2() {
    _classCallCheck(this, DateConverter2);
  }
  _createClass(DateConverter2, [{
    key: "serialize",
    value: function serialize(date) {
      return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join("-");
    }
  }, {
    key: "deserialize",
    value: function deserialize(date) {
      return new Date(date);
    }
  }]);
  return DateConverter2;
}();
DateConverter = __decorateClass$p([JsonConverter], DateConverter);
function _createSuper$t(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$t();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$t() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$u = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __decorateClass$o = function __decorateClass14(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$u(target, key, result);
  return result;
};
var UsersListEssentialResultEntity = /* @__PURE__ */ _createClass(function UsersListEssentialResultEntity2() {
  _classCallCheck(this, UsersListEssentialResultEntity2);
  this.id = 0;
  this.first_name = "";
  this.last_name = "";
  this.email = "";
});
__decorateClass$o([JsonProperty("id", Number)], UsersListEssentialResultEntity.prototype, "id", 2);
__decorateClass$o([JsonProperty("first_name", String, true)], UsersListEssentialResultEntity.prototype, "first_name", 2);
__decorateClass$o([JsonProperty("last_name", String, true)], UsersListEssentialResultEntity.prototype, "last_name", 2);
__decorateClass$o([JsonProperty("email", String)], UsersListEssentialResultEntity.prototype, "email", 2);
UsersListEssentialResultEntity = __decorateClass$o([JsonObject("UsersListEssentialResultEntity")], UsersListEssentialResultEntity);
var UsersListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(UsersListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$t(UsersListEssentialResponseEntity2);
  function UsersListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, UsersListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(UsersListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$o([JsonProperty("results", [UsersListEssentialResultEntity])], UsersListEssentialResponseEntity.prototype, "results", 2);
UsersListEssentialResponseEntity = __decorateClass$o([JsonObject("UsersListEssentialResponseEntity")], UsersListEssentialResponseEntity);
function _createSuper$s(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$s();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$s() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$t = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __decorateClass$n = function __decorateClass15(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$t(target, key, result);
  return result;
};
var SummaryRoleEntity = /* @__PURE__ */ _createClass(function SummaryRoleEntity2() {
  _classCallCheck(this, SummaryRoleEntity2);
  this.id = 0;
  this.name = "";
  this.is_active = false;
  this.base_type = 0;
  this.permissions = 0;
});
__decorateClass$n([JsonProperty("id", Number)], SummaryRoleEntity.prototype, "id", 2);
__decorateClass$n([JsonProperty("name", String)], SummaryRoleEntity.prototype, "name", 2);
__decorateClass$n([JsonProperty("is_active", Boolean)], SummaryRoleEntity.prototype, "is_active", 2);
__decorateClass$n([JsonProperty("base_type", Number)], SummaryRoleEntity.prototype, "base_type", 2);
__decorateClass$n([JsonProperty("permissions", Number)], SummaryRoleEntity.prototype, "permissions", 2);
SummaryRoleEntity = __decorateClass$n([JsonObject("SummaryRoleEntity")], SummaryRoleEntity);
var WhiteLabelEntity = /* @__PURE__ */ _createClass(function WhiteLabelEntity2() {
  _classCallCheck(this, WhiteLabelEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$n([JsonProperty("id", Number)], WhiteLabelEntity.prototype, "id", 2);
__decorateClass$n([JsonProperty("name", String)], WhiteLabelEntity.prototype, "name", 2);
WhiteLabelEntity = __decorateClass$n([JsonObject("WhiteLabelEntity")], WhiteLabelEntity);
var SummaryAccountUsersEntity = /* @__PURE__ */ _createClass(function SummaryAccountUsersEntity2() {
  _classCallCheck(this, SummaryAccountUsersEntity2);
  this.id = 0;
  this.account = 0;
  this.managed_by = null;
  this.is_active = false;
  this.account_status = 0;
  this.editable = false;
  this.role = new SummaryRoleEntity();
  this.role_permissions_modified = false;
  this.wants_approval_summary_notifications = false;
});
__decorateClass$n([JsonProperty("id", Number)], SummaryAccountUsersEntity.prototype, "id", 2);
__decorateClass$n([JsonProperty("account", Number)], SummaryAccountUsersEntity.prototype, "account", 2);
__decorateClass$n([JsonProperty("managed_by", Number, true)], SummaryAccountUsersEntity.prototype, "managed_by", 2);
__decorateClass$n([JsonProperty("is_active", Boolean)], SummaryAccountUsersEntity.prototype, "is_active", 2);
__decorateClass$n([JsonProperty("account_status", Number)], SummaryAccountUsersEntity.prototype, "account_status", 2);
__decorateClass$n([JsonProperty("editable", Boolean)], SummaryAccountUsersEntity.prototype, "editable", 2);
__decorateClass$n([JsonProperty("role", SummaryRoleEntity)], SummaryAccountUsersEntity.prototype, "role", 2);
__decorateClass$n([JsonProperty("role_permissions_modified", Boolean)], SummaryAccountUsersEntity.prototype, "role_permissions_modified", 2);
__decorateClass$n([JsonProperty("wants_approval_summary_notifications", Boolean, true)], SummaryAccountUsersEntity.prototype, "wants_approval_summary_notifications", 2);
SummaryAccountUsersEntity = __decorateClass$n([JsonObject("SummaryAccountUsersEntity")], SummaryAccountUsersEntity);
var UsersListSummaryResultEntity = /* @__PURE__ */ function(_UsersListEssentialRe) {
  _inherits(UsersListSummaryResultEntity2, _UsersListEssentialRe);
  var _super = _createSuper$s(UsersListSummaryResultEntity2);
  function UsersListSummaryResultEntity2() {
    var _this;
    _classCallCheck(this, UsersListSummaryResultEntity2);
    _this = _super.apply(this, arguments);
    _this.editable = false;
    _this.account_users = [];
    _this.is_active = false;
    _this.title = "";
    _this.is_superuser = false;
    _this.is_staff = false;
    _this.white_label = new WhiteLabelEntity();
    _this.is_white_label_admin = false;
    return _this;
  }
  return _createClass(UsersListSummaryResultEntity2);
}(UsersListEssentialResultEntity);
__decorateClass$n([JsonProperty("editable", Boolean)], UsersListSummaryResultEntity.prototype, "editable", 2);
__decorateClass$n([JsonProperty("account_users", [SummaryAccountUsersEntity])], UsersListSummaryResultEntity.prototype, "account_users", 2);
__decorateClass$n([JsonProperty("is_active", Boolean)], UsersListSummaryResultEntity.prototype, "is_active", 2);
__decorateClass$n([JsonProperty("title", String, true)], UsersListSummaryResultEntity.prototype, "title", 2);
__decorateClass$n([JsonProperty("is_superuser", Boolean)], UsersListSummaryResultEntity.prototype, "is_superuser", 2);
__decorateClass$n([JsonProperty("is_staff", Boolean)], UsersListSummaryResultEntity.prototype, "is_staff", 2);
__decorateClass$n([JsonProperty("white_label", WhiteLabelEntity, true)], UsersListSummaryResultEntity.prototype, "white_label", 2);
__decorateClass$n([JsonProperty("is_white_label_admin", Boolean)], UsersListSummaryResultEntity.prototype, "is_white_label_admin", 2);
UsersListSummaryResultEntity = __decorateClass$n([JsonObject("UsersListSummaryResultEntity")], UsersListSummaryResultEntity);
var UsersListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(UsersListSummaryResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$s(UsersListSummaryResponseEntity2);
  function UsersListSummaryResponseEntity2() {
    var _this2;
    _classCallCheck(this, UsersListSummaryResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(UsersListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$n([JsonProperty("results", [UsersListSummaryResultEntity])], UsersListSummaryResponseEntity.prototype, "results", 2);
UsersListSummaryResponseEntity = __decorateClass$n([JsonObject("UsersListSummaryResponseEntity")], UsersListSummaryResponseEntity);
function _createSuper$r(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$r();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$r() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$s = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __decorateClass$m = function __decorateClass16(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$s(target, key, result);
  return result;
};
var UserPropertyEntity = /* @__PURE__ */ _createClass(function UserPropertyEntity2() {
  _classCallCheck(this, UserPropertyEntity2);
  this.id = 0;
  this.name = "";
  this.pms_platform = 0;
  this.account = 0;
  this.portfolio = 0;
  this.time_zone = "";
});
__decorateClass$m([JsonProperty("id", Number)], UserPropertyEntity.prototype, "id", 2);
__decorateClass$m([JsonProperty("name", String)], UserPropertyEntity.prototype, "name", 2);
__decorateClass$m([JsonProperty("pms_platform", Number)], UserPropertyEntity.prototype, "pms_platform", 2);
__decorateClass$m([JsonProperty("account", Number)], UserPropertyEntity.prototype, "account", 2);
__decorateClass$m([JsonProperty("portfolio", Number)], UserPropertyEntity.prototype, "portfolio", 2);
__decorateClass$m([JsonProperty("time_zone", String, true)], UserPropertyEntity.prototype, "time_zone", 2);
UserPropertyEntity = __decorateClass$m([JsonObject("UserPropertyEntity")], UserPropertyEntity);
var GroupEntity = /* @__PURE__ */ _createClass(function GroupEntity2() {
  _classCallCheck(this, GroupEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$m([JsonProperty("id", Number)], GroupEntity.prototype, "id", 2);
__decorateClass$m([JsonProperty("name", String)], GroupEntity.prototype, "name", 2);
GroupEntity = __decorateClass$m([JsonObject("GroupEntity")], GroupEntity);
var UserPortfolioEntity = /* @__PURE__ */ _createClass(function UserPortfolioEntity2() {
  _classCallCheck(this, UserPortfolioEntity2);
  this.id = 0;
  this.name = "";
  this.account = 0;
  this.groups = [];
});
__decorateClass$m([JsonProperty("id", Number)], UserPortfolioEntity.prototype, "id", 2);
__decorateClass$m([JsonProperty("name", String)], UserPortfolioEntity.prototype, "name", 2);
__decorateClass$m([JsonProperty("account", Number)], UserPortfolioEntity.prototype, "account", 2);
__decorateClass$m([JsonProperty("groups", [GroupEntity])], UserPortfolioEntity.prototype, "groups", 2);
UserPortfolioEntity = __decorateClass$m([JsonObject("UserPortfolioEntity")], UserPortfolioEntity);
var RoleEntity = /* @__PURE__ */ function(_SummaryRoleEntity) {
  _inherits(RoleEntity2, _SummaryRoleEntity);
  var _super = _createSuper$r(RoleEntity2);
  function RoleEntity2() {
    var _this;
    _classCallCheck(this, RoleEntity2);
    _this = _super.apply(this, arguments);
    _this.parent_base_type = 0;
    return _this;
  }
  return _createClass(RoleEntity2);
}(SummaryRoleEntity);
__decorateClass$m([JsonProperty("parent_base_type", Number, true)], RoleEntity.prototype, "parent_base_type", 2);
RoleEntity = __decorateClass$m([JsonObject("RoleEntity")], RoleEntity);
var AccountUsersEntity = /* @__PURE__ */ function(_SummaryAccountUsersE) {
  _inherits(AccountUsersEntity2, _SummaryAccountUsersE);
  var _super2 = _createSuper$r(AccountUsersEntity2);
  function AccountUsersEntity2() {
    var _this2;
    _classCallCheck(this, AccountUsersEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.is_owner = false;
    _this2.properties = [];
    _this2.portfolios = [];
    _this2.role = new RoleEntity();
    return _this2;
  }
  return _createClass(AccountUsersEntity2);
}(SummaryAccountUsersEntity);
__decorateClass$m([JsonProperty("is_owner", Boolean)], AccountUsersEntity.prototype, "is_owner", 2);
__decorateClass$m([JsonProperty("properties", [UserPropertyEntity])], AccountUsersEntity.prototype, "properties", 2);
__decorateClass$m([JsonProperty("portfolios", [UserPortfolioEntity], true)], AccountUsersEntity.prototype, "portfolios", 2);
__decorateClass$m([JsonProperty("role", RoleEntity)], AccountUsersEntity.prototype, "role", 2);
AccountUsersEntity = __decorateClass$m([JsonObject("AccountUsersEntity")], AccountUsersEntity);
var UsersListCompleteResultEntity = /* @__PURE__ */ function(_UsersListSummaryResu) {
  _inherits(UsersListCompleteResultEntity2, _UsersListSummaryResu);
  var _super3 = _createSuper$r(UsersListCompleteResultEntity2);
  function UsersListCompleteResultEntity2() {
    var _this3;
    _classCallCheck(this, UsersListCompleteResultEntity2);
    _this3 = _super3.apply(this, arguments);
    _this3.gender = 0;
    _this3.image = "";
    _this3.last_login = "";
    _this3.account_users = [];
    _this3.accounts_for_new_account_users = [0];
    return _this3;
  }
  return _createClass(UsersListCompleteResultEntity2);
}(UsersListSummaryResultEntity);
__decorateClass$m([JsonProperty("gender", Number, true)], UsersListCompleteResultEntity.prototype, "gender", 2);
__decorateClass$m([JsonProperty("image", String, true)], UsersListCompleteResultEntity.prototype, "image", 2);
__decorateClass$m([JsonProperty("last_login", String, true)], UsersListCompleteResultEntity.prototype, "last_login", 2);
__decorateClass$m([JsonProperty("account_users", [AccountUsersEntity])], UsersListCompleteResultEntity.prototype, "account_users", 2);
__decorateClass$m([JsonProperty("accounts_for_new_account_users", [Number])], UsersListCompleteResultEntity.prototype, "accounts_for_new_account_users", 2);
UsersListCompleteResultEntity = __decorateClass$m([JsonObject("UsersListCompleteResultEntity")], UsersListCompleteResultEntity);
var UsersListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(UsersListCompleteResponseEntity2, _GenericResponseEntit);
  var _super4 = _createSuper$r(UsersListCompleteResponseEntity2);
  function UsersListCompleteResponseEntity2() {
    var _this4;
    _classCallCheck(this, UsersListCompleteResponseEntity2);
    _this4 = _super4.apply(this, arguments);
    _this4.results = [];
    return _this4;
  }
  return _createClass(UsersListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$m([JsonProperty("results", [UsersListCompleteResultEntity])], UsersListCompleteResponseEntity.prototype, "results", 2);
UsersListCompleteResponseEntity = __decorateClass$m([JsonObject("UsersListCompleteResponseEntity")], UsersListCompleteResponseEntity);
var UserUrls = {
  user: "/api/2.0/users/",
  userId: "api/2.0/user/{id}/",
  userExport: "/api/2.0/account-users/export-users/",
  userAccount: "/api/2.0/account-users/"
};
function _createSuper$q(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$q();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$q() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$6(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$6(o, minLen);
}
function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$r = Object.defineProperty;
var __defProps$6 = Object.defineProperties;
var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = function __defNormalProp10(obj, key, value) {
  return key in obj ? __defProp$r(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$6 = function __spreadValues10(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$6) {
    var _iterator = _createForOfIteratorHelper$6(__getOwnPropSymbols$6(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$6.call(b, prop))
          __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$6 = function __spreadProps7(a, b) {
  return __defProps$6(a, __getOwnPropDescs$6(b));
};
var USER_CACHE_KEYS = {
  list: "user",
  get: function get2(id2) {
    return "user__".concat(id2);
  }
};
var UsersList = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(UsersList2, _DmLeonardo);
  var _super = _createSuper$q(UsersList2);
  function UsersList2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, UsersList2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-user";
    return _this;
  }
  _createClass(UsersList2, [{
    key: "getUsersList",
    value: function getUsersList(params, filter3) {
      var _this2 = this;
      var url = UserUrls.user;
      var genericParams = this.parseGenericParams(__spreadProps$6(__spreadValues$6({}, params), {
        modifier: "summary"
      }));
      var filterParams = this.parseFilterParams(filter3);
      return this._client.get({
        url,
        params: __spreadValues$6(__spreadValues$6({}, genericParams), filterParams),
        cache: USER_CACHE_KEYS.list
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, UsersListSummaryResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "exportUsersList",
    value: function exportUsersList(params, filter3) {
      var _this3 = this;
      var url = UserUrls.userExport;
      var genericParams = this.parseEmailExport(params);
      var filterParams = this.parseFilterParams(filter3);
      return this._client.get({
        url,
        params: __spreadValues$6(__spreadValues$6({}, genericParams), filterParams)
      }).then(function(_ref2) {
        var status = _ref2.status;
        return status;
      }).catch(function(e) {
        _this3.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getUser",
    value: function getUser(id2) {
      var _this4 = this;
      var url = UserUrls.userId;
      return this._client.get({
        url,
        path: {
          id: id2
        },
        cache: USER_CACHE_KEYS.get(id2)
      }).then(function(_ref3) {
        var data2 = _ref3.data;
        return _this4._jsonConvert.deserializeObject(data2, UsersListCompleteResultEntity);
      }).catch(function(e) {
        _this4.logger.error(e);
        throw e;
      });
    }
  }]);
  return UsersList2;
}(DmLeonardo);
function useUserListDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new UsersList(config);
  }, [config]);
  return {
    getUsersList: useCallback(function(params, filter3) {
      return Api.getUsersList(params, filter3);
    }, [Api]),
    exportUsersList: useCallback(function(params, filter3) {
      return Api.exportUsersList(params, filter3);
    }, [Api]),
    getUser: useCallback(function(id2) {
      return Api.getUser(id2);
    }, [Api])
  };
}
function _createSuper$p(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$p();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$p() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$l = function __decorateClass17(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$q(target, key, result);
  return result;
};
var UnitEssentialResultEntity = /* @__PURE__ */ _createClass(function UnitEssentialResultEntity2() {
  _classCallCheck(this, UnitEssentialResultEntity2);
  this.id = 0;
  this.number = "";
});
__decorateClass$l([JsonProperty("id", Number)], UnitEssentialResultEntity.prototype, "id", 2);
__decorateClass$l([JsonProperty("number", String)], UnitEssentialResultEntity.prototype, "number", 2);
UnitEssentialResultEntity = __decorateClass$l([JsonObject("UnitEssentialResultEntity")], UnitEssentialResultEntity);
var UnitEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(UnitEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$p(UnitEssentialResponseEntity2);
  function UnitEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, UnitEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(UnitEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$l([JsonProperty("results", [UnitEssentialResultEntity])], UnitEssentialResponseEntity.prototype, "results", 2);
UnitEssentialResponseEntity = __decorateClass$l([JsonObject("UnitEssentialResponseEntity")], UnitEssentialResponseEntity);
function _createSuper$o(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$o();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$o() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$k = function __decorateClass18(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$p(target, key, result);
  return result;
};
var UnitTypeSummaryEntity = /* @__PURE__ */ _createClass(function UnitTypeSummaryEntity2() {
  _classCallCheck(this, UnitTypeSummaryEntity2);
  this.id = 0;
  this.name = "";
  this.account = 0;
});
__decorateClass$k([JsonProperty("id", Number)], UnitTypeSummaryEntity.prototype, "id", 2);
__decorateClass$k([JsonProperty("name", String)], UnitTypeSummaryEntity.prototype, "name", 2);
__decorateClass$k([JsonProperty("account", Number)], UnitTypeSummaryEntity.prototype, "account", 2);
UnitTypeSummaryEntity = __decorateClass$k([JsonObject("UnitTypeSummaryEntity")], UnitTypeSummaryEntity);
var UnitListSummaryResultEntity = /* @__PURE__ */ function(_UnitEssentialResultE) {
  _inherits(UnitListSummaryResultEntity2, _UnitEssentialResultE);
  var _super = _createSuper$o(UnitListSummaryResultEntity2);
  function UnitListSummaryResultEntity2() {
    var _this;
    _classCallCheck(this, UnitListSummaryResultEntity2);
    _this = _super.apply(this, arguments);
    _this.unit_type = new UnitTypeSummaryEntity();
    _this.property = 0;
    _this.building = "";
    _this.sq_feet = 0;
    _this.possible_sync_missing = false;
    return _this;
  }
  return _createClass(UnitListSummaryResultEntity2);
}(UnitEssentialResultEntity);
__decorateClass$k([JsonProperty("unit_type", UnitTypeSummaryEntity)], UnitListSummaryResultEntity.prototype, "unit_type", 2);
__decorateClass$k([JsonProperty("property", Number)], UnitListSummaryResultEntity.prototype, "property", 2);
__decorateClass$k([JsonProperty("building", String, true)], UnitListSummaryResultEntity.prototype, "building", 2);
__decorateClass$k([JsonProperty("sq_feet", Number, true)], UnitListSummaryResultEntity.prototype, "sq_feet", 2);
__decorateClass$k([JsonProperty("possible_sync_missing", Boolean, true)], UnitListSummaryResultEntity.prototype, "possible_sync_missing", 2);
UnitListSummaryResultEntity = __decorateClass$k([JsonObject("UnitListSummaryResultEntity")], UnitListSummaryResultEntity);
var UnitListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(UnitListSummaryResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$o(UnitListSummaryResponseEntity2);
  function UnitListSummaryResponseEntity2() {
    var _this2;
    _classCallCheck(this, UnitListSummaryResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(UnitListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$k([JsonProperty("results", [UnitListSummaryResultEntity])], UnitListSummaryResponseEntity.prototype, "results", 2);
UnitListSummaryResponseEntity = __decorateClass$k([JsonObject("UnitListSummaryResponseEntity")], UnitListSummaryResponseEntity);
function _createSuper$n(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$n();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$n() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$j = function __decorateClass19(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$o(target, key, result);
  return result;
};
var UnitTypeCompleteEntity = /* @__PURE__ */ function(_UnitTypeSummaryEntit) {
  _inherits(UnitTypeCompleteEntity2, _UnitTypeSummaryEntit);
  var _super = _createSuper$n(UnitTypeCompleteEntity2);
  function UnitTypeCompleteEntity2() {
    var _this;
    _classCallCheck(this, UnitTypeCompleteEntity2);
    _this = _super.apply(this, arguments);
    _this.description = "";
    return _this;
  }
  return _createClass(UnitTypeCompleteEntity2);
}(UnitTypeSummaryEntity);
__decorateClass$j([JsonProperty("description", String, true)], UnitTypeCompleteEntity.prototype, "description", 2);
UnitTypeCompleteEntity = __decorateClass$j([JsonObject("UnitTypeCompleteEntity")], UnitTypeCompleteEntity);
var UnitListCompleteResultEntity = /* @__PURE__ */ function(_UnitListSummaryResul) {
  _inherits(UnitListCompleteResultEntity2, _UnitListSummaryResul);
  var _super2 = _createSuper$n(UnitListCompleteResultEntity2);
  function UnitListCompleteResultEntity2() {
    var _this2;
    _classCallCheck(this, UnitListCompleteResultEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.unit_type = new UnitTypeCompleteEntity();
    _this2.portfolio = 0;
    _this2.number_absolute = 0;
    _this2.phase = "";
    _this2.groups = [];
    _this2.designation = "";
    _this2.resident_name = "";
    _this2.roommate_1 = "";
    _this2.roommate_2 = "";
    _this2.roommate_3 = "";
    _this2.roommate_4 = "";
    _this2.move_in_date = new Date();
    _this2.move_out_date = new Date();
    _this2.lease_start_date = new Date();
    _this2.lease_end_date = new Date();
    _this2.lease_status = "";
    _this2.on_notice = "";
    _this2.lease_term = "";
    _this2.lease_type = "";
    _this2.required_deposit = 0;
    _this2.deposit_on_hand = 0;
    _this2.garage_deposit = 0;
    _this2.key_deposit = 0;
    _this2.misc_deposit = 0;
    _this2.pet_deposit = 0;
    _this2.security_deposit = 0;
    _this2.storage_deposit = 0;
    _this2.insurance_provider = "";
    _this2.renters_insurance = 0;
    _this2.market_rent = 0;
    _this2.lease_rent = 0;
    _this2.pets = false;
    _this2.pet_rent = 0;
    _this2.rent = 0;
    _this2.corporate_rent = 0;
    _this2.other_rent_discount = 0;
    _this2.balance = 0;
    _this2.parking_fee = 0;
    _this2.telecom_fee = 0;
    _this2.admin_fee = 0;
    _this2.boat_slip_fee = 0;
    _this2.cable_fee = 0;
    _this2.carport_fee = 0;
    _this2.electric_fee = 0;
    _this2.furniture_fee = 0;
    _this2.garage_fee = 0;
    _this2.gas_fee = 0;
    _this2.guest_suite_fee = 0;
    _this2.hud_fee = 0;
    _this2.internet_fee = 0;
    _this2.lease_break_fee = 0;
    _this2.misc_fee = 0;
    _this2.pest_fee = 0;
    _this2.recycling_fee = 0;
    _this2.rubs_fee = 0;
    _this2.scep_fee = 0;
    _this2.short_term_fee = 0;
    _this2.sewer_fee = 0;
    _this2.storage_fee = 0;
    _this2.transfer_fee = 0;
    _this2.trash_fee = 0;
    _this2.utility_fee = 0;
    _this2.valet_waste_fee = 0;
    _this2.washer_dryer_fee = 0;
    _this2.water_fee = 0;
    _this2.fee_6_month = 0;
    _this2.total_amenity_fee = 0;
    _this2.month_to_month_fee = 0;
    _this2.admin_concession = 0;
    _this2.cable_concession = 0;
    _this2.electric_concession = 0;
    _this2.garage_concession = 0;
    _this2.gift_card_concession = 0;
    _this2.guest_suite_concession = 0;
    _this2.housing_concession = 0;
    _this2.internet_concession = 0;
    _this2.misc_concession = 0;
    _this2.office_model_concession = 0;
    _this2.parking_concession = 0;
    _this2.pest_concession = 0;
    _this2.pet_concession = 0;
    _this2.referral_concession = 0;
    _this2.renewal_concession = 0;
    _this2.storage_concession = 0;
    _this2.trash_concession = 0;
    _this2.washer_dryer_concession = 0;
    _this2.water_concession = 0;
    _this2.rent_concession = 0;
    _this2.preferred_employer_discount = 0;
    _this2.lock_off_discount = 0;
    _this2.employee_discount = 0;
    _this2.furniture_concession = 0;
    _this2.lock_off_premium = 0;
    _this2.short_term_premium = 0;
    _this2.model_unit = 0;
    _this2.no_prorate_credit = 0;
    _this2.total_billing = 0;
    _this2.gift_card = 0;
    _this2.lock_key = 0;
    _this2.double_occupancy = 0;
    _this2.preferred_employer = 0;
    _this2.udf1_name = "";
    _this2.udf1_value = 0;
    _this2.udf2_name = "";
    _this2.udf2_value = 0;
    _this2.udf3_name = "";
    _this2.udf3_value = 0;
    _this2.udf4_name = "";
    _this2.udf4_value = 0;
    _this2.parcel_locker = 0;
    _this2.pet_fee = 0;
    _this2.one_time_concession = 0;
    _this2.recurring_concession = 0;
    _this2.bike_storage = 0;
    _this2.premium_view_fee = 0;
    _this2.premium_location_fee = 0;
    _this2.upgraded_unit_fee = 0;
    _this2.amenity_access_fee = 0;
    _this2.turn_status = 0;
    return _this2;
  }
  return _createClass(UnitListCompleteResultEntity2);
}(UnitListSummaryResultEntity);
__decorateClass$j([JsonProperty("unit_type", UnitTypeCompleteEntity)], UnitListCompleteResultEntity.prototype, "unit_type", 2);
__decorateClass$j([JsonProperty("portfolio", Number)], UnitListCompleteResultEntity.prototype, "portfolio", 2);
__decorateClass$j([JsonProperty("number_absolute", Number, true)], UnitListCompleteResultEntity.prototype, "number_absolute", 2);
__decorateClass$j([JsonProperty("phase", String, true)], UnitListCompleteResultEntity.prototype, "phase", 2);
__decorateClass$j([JsonProperty("groups", [GroupEntity])], UnitListCompleteResultEntity.prototype, "groups", 2);
__decorateClass$j([JsonProperty("designation", String, true)], UnitListCompleteResultEntity.prototype, "designation", 2);
__decorateClass$j([JsonProperty("resident_name", String, true)], UnitListCompleteResultEntity.prototype, "resident_name", 2);
__decorateClass$j([JsonProperty("roommate_1", String, true)], UnitListCompleteResultEntity.prototype, "roommate_1", 2);
__decorateClass$j([JsonProperty("roommate_2", String, true)], UnitListCompleteResultEntity.prototype, "roommate_2", 2);
__decorateClass$j([JsonProperty("roommate_3", String, true)], UnitListCompleteResultEntity.prototype, "roommate_3", 2);
__decorateClass$j([JsonProperty("roommate_4", String, true)], UnitListCompleteResultEntity.prototype, "roommate_4", 2);
__decorateClass$j([JsonProperty("move_in_date", DateConverter, true)], UnitListCompleteResultEntity.prototype, "move_in_date", 2);
__decorateClass$j([JsonProperty("move_out_date", DateConverter, true)], UnitListCompleteResultEntity.prototype, "move_out_date", 2);
__decorateClass$j([JsonProperty("lease_start_date", DateConverter, true)], UnitListCompleteResultEntity.prototype, "lease_start_date", 2);
__decorateClass$j([JsonProperty("lease_end_date", DateConverter, true)], UnitListCompleteResultEntity.prototype, "lease_end_date", 2);
__decorateClass$j([JsonProperty("lease_status", String, true)], UnitListCompleteResultEntity.prototype, "lease_status", 2);
__decorateClass$j([JsonProperty("on_notice", String, true)], UnitListCompleteResultEntity.prototype, "on_notice", 2);
__decorateClass$j([JsonProperty("lease_term", String, true)], UnitListCompleteResultEntity.prototype, "lease_term", 2);
__decorateClass$j([JsonProperty("lease_type", String, true)], UnitListCompleteResultEntity.prototype, "lease_type", 2);
__decorateClass$j([JsonProperty("required_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "required_deposit", 2);
__decorateClass$j([JsonProperty("deposit_on_hand", Number, true)], UnitListCompleteResultEntity.prototype, "deposit_on_hand", 2);
__decorateClass$j([JsonProperty("garage_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "garage_deposit", 2);
__decorateClass$j([JsonProperty("key_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "key_deposit", 2);
__decorateClass$j([JsonProperty("misc_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "misc_deposit", 2);
__decorateClass$j([JsonProperty("pet_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "pet_deposit", 2);
__decorateClass$j([JsonProperty("security_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "security_deposit", 2);
__decorateClass$j([JsonProperty("storage_deposit", Number, true)], UnitListCompleteResultEntity.prototype, "storage_deposit", 2);
__decorateClass$j([JsonProperty("insurance_provider", String, true)], UnitListCompleteResultEntity.prototype, "insurance_provider", 2);
__decorateClass$j([JsonProperty("renters_insurance", Number, true)], UnitListCompleteResultEntity.prototype, "renters_insurance", 2);
__decorateClass$j([JsonProperty("market_rent", Number, true)], UnitListCompleteResultEntity.prototype, "market_rent", 2);
__decorateClass$j([JsonProperty("lease_rent", Number, true)], UnitListCompleteResultEntity.prototype, "lease_rent", 2);
__decorateClass$j([JsonProperty("pets", Boolean)], UnitListCompleteResultEntity.prototype, "pets", 2);
__decorateClass$j([JsonProperty("pet_rent", Number, true)], UnitListCompleteResultEntity.prototype, "pet_rent", 2);
__decorateClass$j([JsonProperty("rent", Number, true)], UnitListCompleteResultEntity.prototype, "rent", 2);
__decorateClass$j([JsonProperty("corporate_rent", Number, true)], UnitListCompleteResultEntity.prototype, "corporate_rent", 2);
__decorateClass$j([JsonProperty("other_rent_discount", Number, true)], UnitListCompleteResultEntity.prototype, "other_rent_discount", 2);
__decorateClass$j([JsonProperty("balance", Number, true)], UnitListCompleteResultEntity.prototype, "balance", 2);
__decorateClass$j([JsonProperty("parking_fee", Number, true)], UnitListCompleteResultEntity.prototype, "parking_fee", 2);
__decorateClass$j([JsonProperty("telecom_fee", Number, true)], UnitListCompleteResultEntity.prototype, "telecom_fee", 2);
__decorateClass$j([JsonProperty("admin_fee", Number, true)], UnitListCompleteResultEntity.prototype, "admin_fee", 2);
__decorateClass$j([JsonProperty("boat_slip_fee", Number, true)], UnitListCompleteResultEntity.prototype, "boat_slip_fee", 2);
__decorateClass$j([JsonProperty("cable_fee", Number, true)], UnitListCompleteResultEntity.prototype, "cable_fee", 2);
__decorateClass$j([JsonProperty("carport_fee", Number, true)], UnitListCompleteResultEntity.prototype, "carport_fee", 2);
__decorateClass$j([JsonProperty("electric_fee", Number, true)], UnitListCompleteResultEntity.prototype, "electric_fee", 2);
__decorateClass$j([JsonProperty("furniture_fee", Number, true)], UnitListCompleteResultEntity.prototype, "furniture_fee", 2);
__decorateClass$j([JsonProperty("garage_fee", Number, true)], UnitListCompleteResultEntity.prototype, "garage_fee", 2);
__decorateClass$j([JsonProperty("gas_fee", Number, true)], UnitListCompleteResultEntity.prototype, "gas_fee", 2);
__decorateClass$j([JsonProperty("guest_suite_fee", Number, true)], UnitListCompleteResultEntity.prototype, "guest_suite_fee", 2);
__decorateClass$j([JsonProperty("hud_fee", Number, true)], UnitListCompleteResultEntity.prototype, "hud_fee", 2);
__decorateClass$j([JsonProperty("internet_fee", Number, true)], UnitListCompleteResultEntity.prototype, "internet_fee", 2);
__decorateClass$j([JsonProperty("lease_break_fee", Number, true)], UnitListCompleteResultEntity.prototype, "lease_break_fee", 2);
__decorateClass$j([JsonProperty("misc_fee", Number, true)], UnitListCompleteResultEntity.prototype, "misc_fee", 2);
__decorateClass$j([JsonProperty("pest_fee", Number, true)], UnitListCompleteResultEntity.prototype, "pest_fee", 2);
__decorateClass$j([JsonProperty("recycling_fee", Number, true)], UnitListCompleteResultEntity.prototype, "recycling_fee", 2);
__decorateClass$j([JsonProperty("rubs_fee", Number, true)], UnitListCompleteResultEntity.prototype, "rubs_fee", 2);
__decorateClass$j([JsonProperty("scep_fee", Number, true)], UnitListCompleteResultEntity.prototype, "scep_fee", 2);
__decorateClass$j([JsonProperty("short_term_fee", Number, true)], UnitListCompleteResultEntity.prototype, "short_term_fee", 2);
__decorateClass$j([JsonProperty("sewer_fee", Number, true)], UnitListCompleteResultEntity.prototype, "sewer_fee", 2);
__decorateClass$j([JsonProperty("storage_fee", Number, true)], UnitListCompleteResultEntity.prototype, "storage_fee", 2);
__decorateClass$j([JsonProperty("transfer_fee", Number, true)], UnitListCompleteResultEntity.prototype, "transfer_fee", 2);
__decorateClass$j([JsonProperty("trash_fee", Number, true)], UnitListCompleteResultEntity.prototype, "trash_fee", 2);
__decorateClass$j([JsonProperty("utility_fee", Number, true)], UnitListCompleteResultEntity.prototype, "utility_fee", 2);
__decorateClass$j([JsonProperty("valet_waste_fee", Number, true)], UnitListCompleteResultEntity.prototype, "valet_waste_fee", 2);
__decorateClass$j([JsonProperty("washer_dryer_fee", Number, true)], UnitListCompleteResultEntity.prototype, "washer_dryer_fee", 2);
__decorateClass$j([JsonProperty("water_fee", Number, true)], UnitListCompleteResultEntity.prototype, "water_fee", 2);
__decorateClass$j([JsonProperty("fee_6_month", Number, true)], UnitListCompleteResultEntity.prototype, "fee_6_month", 2);
__decorateClass$j([JsonProperty("total_amenity_fee", Number, true)], UnitListCompleteResultEntity.prototype, "total_amenity_fee", 2);
__decorateClass$j([JsonProperty("month_to_month_fee", Number, true)], UnitListCompleteResultEntity.prototype, "month_to_month_fee", 2);
__decorateClass$j([JsonProperty("admin_concession", Number, true)], UnitListCompleteResultEntity.prototype, "admin_concession", 2);
__decorateClass$j([JsonProperty("cable_concession", Number, true)], UnitListCompleteResultEntity.prototype, "cable_concession", 2);
__decorateClass$j([JsonProperty("electric_concession", Number, true)], UnitListCompleteResultEntity.prototype, "electric_concession", 2);
__decorateClass$j([JsonProperty("garage_concession", Number, true)], UnitListCompleteResultEntity.prototype, "garage_concession", 2);
__decorateClass$j([JsonProperty("gift_card_concession", Number, true)], UnitListCompleteResultEntity.prototype, "gift_card_concession", 2);
__decorateClass$j([JsonProperty("guest_suite_concession", Number, true)], UnitListCompleteResultEntity.prototype, "guest_suite_concession", 2);
__decorateClass$j([JsonProperty("housing_concession", Number, true)], UnitListCompleteResultEntity.prototype, "housing_concession", 2);
__decorateClass$j([JsonProperty("internet_concession", Number, true)], UnitListCompleteResultEntity.prototype, "internet_concession", 2);
__decorateClass$j([JsonProperty("misc_concession", Number, true)], UnitListCompleteResultEntity.prototype, "misc_concession", 2);
__decorateClass$j([JsonProperty("office_model_concession", Number, true)], UnitListCompleteResultEntity.prototype, "office_model_concession", 2);
__decorateClass$j([JsonProperty("parking_concession", Number, true)], UnitListCompleteResultEntity.prototype, "parking_concession", 2);
__decorateClass$j([JsonProperty("pest_concession", Number, true)], UnitListCompleteResultEntity.prototype, "pest_concession", 2);
__decorateClass$j([JsonProperty("pet_concession", Number, true)], UnitListCompleteResultEntity.prototype, "pet_concession", 2);
__decorateClass$j([JsonProperty("referral_concession", Number, true)], UnitListCompleteResultEntity.prototype, "referral_concession", 2);
__decorateClass$j([JsonProperty("renewal_concession", Number, true)], UnitListCompleteResultEntity.prototype, "renewal_concession", 2);
__decorateClass$j([JsonProperty("storage_concession", Number, true)], UnitListCompleteResultEntity.prototype, "storage_concession", 2);
__decorateClass$j([JsonProperty("trash_concession", Number, true)], UnitListCompleteResultEntity.prototype, "trash_concession", 2);
__decorateClass$j([JsonProperty("washer_dryer_concession", Number, true)], UnitListCompleteResultEntity.prototype, "washer_dryer_concession", 2);
__decorateClass$j([JsonProperty("water_concession", Number, true)], UnitListCompleteResultEntity.prototype, "water_concession", 2);
__decorateClass$j([JsonProperty("rent_concession", Number, true)], UnitListCompleteResultEntity.prototype, "rent_concession", 2);
__decorateClass$j([JsonProperty("preferred_employer_discount", Number, true)], UnitListCompleteResultEntity.prototype, "preferred_employer_discount", 2);
__decorateClass$j([JsonProperty("lock_off_discount", Number, true)], UnitListCompleteResultEntity.prototype, "lock_off_discount", 2);
__decorateClass$j([JsonProperty("employee_discount", Number, true)], UnitListCompleteResultEntity.prototype, "employee_discount", 2);
__decorateClass$j([JsonProperty("furniture_concession", Number, true)], UnitListCompleteResultEntity.prototype, "furniture_concession", 2);
__decorateClass$j([JsonProperty("lock_off_premium", Number, true)], UnitListCompleteResultEntity.prototype, "lock_off_premium", 2);
__decorateClass$j([JsonProperty("short_term_premium", Number, true)], UnitListCompleteResultEntity.prototype, "short_term_premium", 2);
__decorateClass$j([JsonProperty("model_unit", Number, true)], UnitListCompleteResultEntity.prototype, "model_unit", 2);
__decorateClass$j([JsonProperty("no_prorate_credit", Number, true)], UnitListCompleteResultEntity.prototype, "no_prorate_credit", 2);
__decorateClass$j([JsonProperty("total_billing", Number, true)], UnitListCompleteResultEntity.prototype, "total_billing", 2);
__decorateClass$j([JsonProperty("gift_card", Number, true)], UnitListCompleteResultEntity.prototype, "gift_card", 2);
__decorateClass$j([JsonProperty("lock_key", Number, true)], UnitListCompleteResultEntity.prototype, "lock_key", 2);
__decorateClass$j([JsonProperty("double_occupancy", Number, true)], UnitListCompleteResultEntity.prototype, "double_occupancy", 2);
__decorateClass$j([JsonProperty("preferred_employer", Number, true)], UnitListCompleteResultEntity.prototype, "preferred_employer", 2);
__decorateClass$j([JsonProperty("udf1_name", String, true)], UnitListCompleteResultEntity.prototype, "udf1_name", 2);
__decorateClass$j([JsonProperty("udf1_value", Number, true)], UnitListCompleteResultEntity.prototype, "udf1_value", 2);
__decorateClass$j([JsonProperty("udf2_name", String, true)], UnitListCompleteResultEntity.prototype, "udf2_name", 2);
__decorateClass$j([JsonProperty("udf2_value", Number, true)], UnitListCompleteResultEntity.prototype, "udf2_value", 2);
__decorateClass$j([JsonProperty("udf3_name", String, true)], UnitListCompleteResultEntity.prototype, "udf3_name", 2);
__decorateClass$j([JsonProperty("udf3_value", Number, true)], UnitListCompleteResultEntity.prototype, "udf3_value", 2);
__decorateClass$j([JsonProperty("udf4_name", String, true)], UnitListCompleteResultEntity.prototype, "udf4_name", 2);
__decorateClass$j([JsonProperty("udf4_value", Number, true)], UnitListCompleteResultEntity.prototype, "udf4_value", 2);
__decorateClass$j([JsonProperty("parcel_locker", Number, true)], UnitListCompleteResultEntity.prototype, "parcel_locker", 2);
__decorateClass$j([JsonProperty("pet_fee", Number, true)], UnitListCompleteResultEntity.prototype, "pet_fee", 2);
__decorateClass$j([JsonProperty("one_time_concession", Number, true)], UnitListCompleteResultEntity.prototype, "one_time_concession", 2);
__decorateClass$j([JsonProperty("recurring_concession", Number, true)], UnitListCompleteResultEntity.prototype, "recurring_concession", 2);
__decorateClass$j([JsonProperty("bike_storage", Number, true)], UnitListCompleteResultEntity.prototype, "bike_storage", 2);
__decorateClass$j([JsonProperty("premium_view_fee", Number, true)], UnitListCompleteResultEntity.prototype, "premium_view_fee", 2);
__decorateClass$j([JsonProperty("premium_location_fee", Number, true)], UnitListCompleteResultEntity.prototype, "premium_location_fee", 2);
__decorateClass$j([JsonProperty("upgraded_unit_fee", Number, true)], UnitListCompleteResultEntity.prototype, "upgraded_unit_fee", 2);
__decorateClass$j([JsonProperty("amenity_access_fee", Number, true)], UnitListCompleteResultEntity.prototype, "amenity_access_fee", 2);
__decorateClass$j([JsonProperty("turn_status", Number, true)], UnitListCompleteResultEntity.prototype, "turn_status", 2);
UnitListCompleteResultEntity = __decorateClass$j([JsonObject("UnitListCompleteResultEntity")], UnitListCompleteResultEntity);
var UnitListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(UnitListCompleteResponseEntity2, _GenericResponseEntit);
  var _super3 = _createSuper$n(UnitListCompleteResponseEntity2);
  function UnitListCompleteResponseEntity2() {
    var _this3;
    _classCallCheck(this, UnitListCompleteResponseEntity2);
    _this3 = _super3.apply(this, arguments);
    _this3.results = [];
    return _this3;
  }
  return _createClass(UnitListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$j([JsonProperty("results", [UnitListCompleteResultEntity])], UnitListCompleteResponseEntity.prototype, "results", 2);
UnitListCompleteResponseEntity = __decorateClass$j([JsonObject("UnitListCompleteResponseEntity")], UnitListCompleteResponseEntity);
var UnitUrls = {
  units: "/api/2.0/unit/"
};
function _createSuper$m(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$m();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$m() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$5(o, minLen);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$n = Object.defineProperty;
var __defProps$5 = Object.defineProperties;
var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = function __defNormalProp11(obj, key, value) {
  return key in obj ? __defProp$n(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$5 = function __spreadValues11(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$5) {
    var _iterator = _createForOfIteratorHelper$5(__getOwnPropSymbols$5(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$5.call(b, prop))
          __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$5 = function __spreadProps8(a, b) {
  return __defProps$5(a, __getOwnPropDescs$5(b));
};
var UNIT_CACHE_KEYS = {
  list: "unit"
};
var UnitDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(UnitDm2, _DmLeonardo);
  var _super = _createSuper$m(UnitDm2);
  function UnitDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, UnitDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-unit";
    return _this;
  }
  _createClass(UnitDm2, [{
    key: "getUnitsList",
    value: function getUnitsList(params) {
      var _this2 = this;
      var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var url = UnitUrls.units;
      var finalParams = this.parseGenericParams({
        search: params.search,
        disablePagination: true,
        modifier: "summary"
      });
      return this._client.get({
        url,
        params: __spreadProps$5(__spreadValues$5({}, finalParams), {
          property: params.property.toString()
        }),
        cache: UNIT_CACHE_KEYS.list,
        force
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, UnitListSummaryResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }]);
  return UnitDm2;
}(DmLeonardo);
function useUnitDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new UnitDm(config);
  }, [config]);
  return {
    getUnitsList: useCallback(function(params) {
      var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      return Api.getUnitsList(params, force);
    }, [Api])
  };
}
function _createSuper$l(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$l();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$l() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = function __decorateClass20(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$m(target, key, result);
  return result;
};
var MergeUnitsDuplicatesEssentialResultEntity = /* @__PURE__ */ _createClass(function MergeUnitsDuplicatesEssentialResultEntity2() {
  _classCallCheck(this, MergeUnitsDuplicatesEssentialResultEntity2);
  this.building = "";
  this.id = 0;
  this.possible_sync_missing = false;
  this.property = 0;
  this.sq_feet = 0;
  this.number = "";
  this.unit_type = new UnitTypeSummaryEntity();
});
__decorateClass$i([JsonProperty("building", String)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "building", 2);
__decorateClass$i([JsonProperty("id", Number)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "id", 2);
__decorateClass$i([JsonProperty("possible_sync_missing", Boolean, true)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "possible_sync_missing", 2);
__decorateClass$i([JsonProperty("property", Number)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "property", 2);
__decorateClass$i([JsonProperty("sq_feet", Number)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "sq_feet", 2);
__decorateClass$i([JsonProperty("number", String)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "number", 2);
__decorateClass$i([JsonProperty("unit_type", UnitTypeSummaryEntity)], MergeUnitsDuplicatesEssentialResultEntity.prototype, "unit_type", 2);
MergeUnitsDuplicatesEssentialResultEntity = __decorateClass$i([JsonObject("MergeUnitsDuplicatesEssentialResultEntity")], MergeUnitsDuplicatesEssentialResultEntity);
var MergeUnitsDuplicatesEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(MergeUnitsDuplicatesEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$l(MergeUnitsDuplicatesEssentialResponseEntity2);
  function MergeUnitsDuplicatesEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, MergeUnitsDuplicatesEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(MergeUnitsDuplicatesEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$i([JsonProperty("results", [[MergeUnitsDuplicatesEssentialResultEntity]])], MergeUnitsDuplicatesEssentialResponseEntity.prototype, "results", 2);
MergeUnitsDuplicatesEssentialResponseEntity = __decorateClass$i([JsonObject("MergeUnitsDuplicatesEssentialResponseEntity")], MergeUnitsDuplicatesEssentialResponseEntity);
function _createSuper$k(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$k();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$k() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = function __decorateClass21(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$l(target, key, result);
  return result;
};
var MergeUnisDuplicatesGetResponseEntity = /* @__PURE__ */ function(_MergeUnitsDuplicates) {
  _inherits(MergeUnisDuplicatesGetResponseEntity2, _MergeUnitsDuplicates);
  var _super = _createSuper$k(MergeUnisDuplicatesGetResponseEntity2);
  function MergeUnisDuplicatesGetResponseEntity2() {
    _classCallCheck(this, MergeUnisDuplicatesGetResponseEntity2);
    return _super.apply(this, arguments);
  }
  return _createClass(MergeUnisDuplicatesGetResponseEntity2);
}(MergeUnitsDuplicatesEssentialResultEntity);
MergeUnisDuplicatesGetResponseEntity = __decorateClass$h([JsonObject("MergeUnisDuplicatesGetResponseEntity")], MergeUnisDuplicatesGetResponseEntity);
function _createSuper$j(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$j();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$j() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = function __decorateClass22(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$k(target, key, result);
  return result;
};
var MergeUnitsHistoryUnitTypeEntity = /* @__PURE__ */ _createClass(function MergeUnitsHistoryUnitTypeEntity2() {
  _classCallCheck(this, MergeUnitsHistoryUnitTypeEntity2);
  this.id = 0;
  this.name = "";
  this.account = 0;
});
__decorateClass$g([JsonProperty("id", Number)], MergeUnitsHistoryUnitTypeEntity.prototype, "id", 2);
__decorateClass$g([JsonProperty("name", String)], MergeUnitsHistoryUnitTypeEntity.prototype, "name", 2);
__decorateClass$g([JsonProperty("account", Number)], MergeUnitsHistoryUnitTypeEntity.prototype, "account", 2);
MergeUnitsHistoryUnitTypeEntity = __decorateClass$g([JsonObject("MergeUnitsHistoryUnitTypeEntity")], MergeUnitsHistoryUnitTypeEntity);
var MergeUnitsHistoryUnitEntity = /* @__PURE__ */ _createClass(function MergeUnitsHistoryUnitEntity2() {
  _classCallCheck(this, MergeUnitsHistoryUnitEntity2);
  this.id = 0;
  this.number = "";
  this.unit_type = new MergeUnitsHistoryUnitTypeEntity();
  this.property = 0;
  this.building = "";
  this.sq_feet = 0;
  this.possible_sync_missing = false;
});
__decorateClass$g([JsonProperty("id", Number)], MergeUnitsHistoryUnitEntity.prototype, "id", 2);
__decorateClass$g([JsonProperty("number", String)], MergeUnitsHistoryUnitEntity.prototype, "number", 2);
__decorateClass$g([JsonProperty("unit_type", MergeUnitsHistoryUnitTypeEntity)], MergeUnitsHistoryUnitEntity.prototype, "unit_type", 2);
__decorateClass$g([JsonProperty("property", Number)], MergeUnitsHistoryUnitEntity.prototype, "property", 2);
__decorateClass$g([JsonProperty("building", String)], MergeUnitsHistoryUnitEntity.prototype, "building", 2);
__decorateClass$g([JsonProperty("sq_feet", Number)], MergeUnitsHistoryUnitEntity.prototype, "sq_feet", 2);
__decorateClass$g([JsonProperty("possible_sync_missing", Boolean, true)], MergeUnitsHistoryUnitEntity.prototype, "possible_sync_missing", 2);
MergeUnitsHistoryUnitEntity = __decorateClass$g([JsonObject("MergeUnitsHistoryUnitEntity")], MergeUnitsHistoryUnitEntity);
var MergeUnitsHistoryResultEntity = /* @__PURE__ */ _createClass(function MergeUnitsHistoryResultEntity2() {
  _classCallCheck(this, MergeUnitsHistoryResultEntity2);
  this.id = 0;
  this.date = "";
  this.reverted = false;
  this.revert_date = "";
  this.unit_src = new MergeUnitsHistoryUnitEntity();
  this.unit_dst = new MergeUnitsHistoryUnitEntity();
});
__decorateClass$g([JsonProperty("id", Number)], MergeUnitsHistoryResultEntity.prototype, "id", 2);
__decorateClass$g([JsonProperty("date", String)], MergeUnitsHistoryResultEntity.prototype, "date", 2);
__decorateClass$g([JsonProperty("reverted", Boolean)], MergeUnitsHistoryResultEntity.prototype, "reverted", 2);
__decorateClass$g([JsonProperty("revert_date", String)], MergeUnitsHistoryResultEntity.prototype, "revert_date", 2);
__decorateClass$g([JsonProperty("unit_src", MergeUnitsHistoryUnitEntity)], MergeUnitsHistoryResultEntity.prototype, "unit_src", 2);
__decorateClass$g([JsonProperty("unit_dst", MergeUnitsHistoryUnitEntity)], MergeUnitsHistoryResultEntity.prototype, "unit_dst", 2);
MergeUnitsHistoryResultEntity = __decorateClass$g([JsonObject("MergeUnitsHistoryResultEntity")], MergeUnitsHistoryResultEntity);
var MergeUnitsHistoryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(MergeUnitsHistoryResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$j(MergeUnitsHistoryResponseEntity2);
  function MergeUnitsHistoryResponseEntity2() {
    var _this;
    _classCallCheck(this, MergeUnitsHistoryResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(MergeUnitsHistoryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$g([JsonProperty("results", [MergeUnitsHistoryResultEntity])], MergeUnitsHistoryResponseEntity.prototype, "results", 2);
MergeUnitsHistoryResponseEntity = __decorateClass$g([JsonObject("MergeUnitsHistoryResponseEntity")], MergeUnitsHistoryResponseEntity);
var MergeUnitsUrls = {
  mergeDuplicates: "/api/2.0/unit/duplicates/",
  mergeList: "/api/2.0/merge-units/",
  mergeBatch: "/api/2.0/merge-units/merge-batch/",
  mergeRevert: "/api/2.0/merge-units/revert/"
};
function _createSuper$i(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$i();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$i() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var MERGE_UNITS_CACHE_KEYS = {
  get: function get3(id2) {
    return "merge-units_".concat(id2);
  },
  history: function history(id2) {
    return "merge-units_history_".concat(id2);
  }
};
var MergeUnitsDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(MergeUnitsDm2, _DmLeonardo);
  var _super = _createSuper$i(MergeUnitsDm2);
  function MergeUnitsDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, MergeUnitsDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-merge-units";
    return _this;
  }
  _createClass(MergeUnitsDm2, [{
    key: "getMergeUnitsDuplicatesList",
    value: function getMergeUnitsDuplicatesList(property) {
      var _this2 = this;
      var url = MergeUnitsUrls.mergeDuplicates;
      return this._client.get({
        url,
        params: {
          property: property.toString()
        },
        cache: MERGE_UNITS_CACHE_KEYS.get(property)
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, MergeUnitsDuplicatesEssentialResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getMergeUnitsHistory",
    value: function getMergeUnitsHistory(property, page) {
      var _this3 = this;
      var url = MergeUnitsUrls.mergeList;
      return this._client.get({
        url,
        params: {
          page: page.toString() || "1",
          property: property.toString(),
          reverted: "false"
        },
        cache: MERGE_UNITS_CACHE_KEYS.history(property)
      }).then(function(_ref2) {
        var data2 = _ref2.data;
        return _this3._jsonConvert.deserializeObject(data2, MergeUnitsHistoryResponseEntity);
      }).catch(function(e) {
        _this3.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "createMergeUnit",
    value: function createMergeUnit(units) {
      var _this4 = this;
      var url = MergeUnitsUrls.mergeBatch;
      var finalParams = this.parseMergeUnitParams(units);
      var property = units[0][0].property;
      return this._client.post({
        url,
        cacheReset: [MERGE_UNITS_CACHE_KEYS.get(property), MERGE_UNITS_CACHE_KEYS.history(property)]
      }, finalParams).catch(function(e) {
        _this4.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "revertMergeEvent",
    value: function revertMergeEvent(merge_event_id) {
      var _this5 = this;
      var url = MergeUnitsUrls.mergeRevert;
      return this._client.post({
        url,
        cacheReset: [new RegExp(MERGE_UNITS_CACHE_KEYS.get("") + ".*"), new RegExp(MERGE_UNITS_CACHE_KEYS.history("") + ".*")]
      }, {
        merge_event_id
      }).catch(function(e) {
        _this5.logger.error(e);
      });
    }
  }, {
    key: "parseMergeUnitParams",
    value: function parseMergeUnitParams(units) {
      var parsedMergeUnits = units.map(function(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2), src = _ref4[0], dst = _ref4[1];
        return {
          unit_src: src.id,
          unit_dst: dst.id
        };
      });
      return {
        units: parsedMergeUnits
      };
    }
  }]);
  return MergeUnitsDm2;
}(DmLeonardo);
function useMergeUnitsDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new MergeUnitsDm(config);
  }, [config]);
  return {
    getMergeUnitsDuplicatesList: useCallback(function(params) {
      return Api.getMergeUnitsDuplicatesList(params);
    }, [Api]),
    getMergeUnitsHistory: useCallback(function(params, page) {
      return Api.getMergeUnitsHistory(params, page);
    }, [Api]),
    createMergeUnit: useCallback(function(params) {
      return Api.createMergeUnit(params);
    }, [Api]),
    revertMergeEvent: useCallback(function(params) {
      return Api.revertMergeEvent(params);
    }, [Api])
  };
}
function _createSuper$h(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$h();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$h() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = function __decorateClass23(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$j(target, key, result);
  return result;
};
var PortfoliosListEssentialResultEntity = /* @__PURE__ */ _createClass(function PortfoliosListEssentialResultEntity2() {
  _classCallCheck(this, PortfoliosListEssentialResultEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$f([JsonProperty("id", Number)], PortfoliosListEssentialResultEntity.prototype, "id", 2);
__decorateClass$f([JsonProperty("name", String)], PortfoliosListEssentialResultEntity.prototype, "name", 2);
PortfoliosListEssentialResultEntity = __decorateClass$f([JsonObject("PortfoliosListEssentialResultEntity")], PortfoliosListEssentialResultEntity);
var PortfoliosListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(PortfoliosListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$h(PortfoliosListEssentialResponseEntity2);
  function PortfoliosListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, PortfoliosListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(PortfoliosListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$f([JsonProperty("results", [PortfoliosListEssentialResultEntity])], PortfoliosListEssentialResponseEntity.prototype, "results", 2);
PortfoliosListEssentialResponseEntity = __decorateClass$f([JsonObject("PortfoliosListEssentialResponseEntity")], PortfoliosListEssentialResponseEntity);
function _createSuper$g(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$g();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$g() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = function __decorateClass24(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$i(target, key, result);
  return result;
};
var PortfolioSummaryGroupEntity = /* @__PURE__ */ _createClass(function PortfolioSummaryGroupEntity2() {
  _classCallCheck(this, PortfolioSummaryGroupEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$e([JsonProperty("id", Number)], PortfolioSummaryGroupEntity.prototype, "id", 2);
__decorateClass$e([JsonProperty("name", String)], PortfolioSummaryGroupEntity.prototype, "name", 2);
PortfolioSummaryGroupEntity = __decorateClass$e([JsonObject("PortfolioSummaryGroupEntity")], PortfolioSummaryGroupEntity);
var PortfoliosListSummaryResultEntity = /* @__PURE__ */ function(_PortfoliosListEssent) {
  _inherits(PortfoliosListSummaryResultEntity2, _PortfoliosListEssent);
  var _super = _createSuper$g(PortfoliosListSummaryResultEntity2);
  function PortfoliosListSummaryResultEntity2() {
    var _this;
    _classCallCheck(this, PortfoliosListSummaryResultEntity2);
    _this = _super.apply(this, arguments);
    _this.account = 0;
    _this.groups = [];
    return _this;
  }
  return _createClass(PortfoliosListSummaryResultEntity2);
}(PortfoliosListEssentialResultEntity);
__decorateClass$e([JsonProperty("account", Number)], PortfoliosListSummaryResultEntity.prototype, "account", 2);
__decorateClass$e([JsonProperty("groups", [PortfolioSummaryGroupEntity])], PortfoliosListSummaryResultEntity.prototype, "groups", 2);
PortfoliosListSummaryResultEntity = __decorateClass$e([JsonObject("PortfoliosListSummaryResultEntity")], PortfoliosListSummaryResultEntity);
var PortfoliosListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(PortfoliosListSummaryResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$g(PortfoliosListSummaryResponseEntity2);
  function PortfoliosListSummaryResponseEntity2() {
    var _this2;
    _classCallCheck(this, PortfoliosListSummaryResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(PortfoliosListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$e([JsonProperty("results", [PortfoliosListSummaryResultEntity])], PortfoliosListSummaryResponseEntity.prototype, "results", 2);
PortfoliosListSummaryResponseEntity = __decorateClass$e([JsonObject("PortfoliosListSummaryResponseEntity")], PortfoliosListSummaryResponseEntity);
function _createSuper$f(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$f();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$f() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = function __decorateClass25(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$h(target, key, result);
  return result;
};
var PortfolioGroupEntity = /* @__PURE__ */ function(_PortfolioSummaryGrou) {
  _inherits(PortfolioGroupEntity2, _PortfolioSummaryGrou);
  var _super = _createSuper$f(PortfolioGroupEntity2);
  function PortfolioGroupEntity2() {
    var _this;
    _classCallCheck(this, PortfolioGroupEntity2);
    _this = _super.apply(this, arguments);
    _this.account = 0;
    return _this;
  }
  return _createClass(PortfolioGroupEntity2);
}(PortfolioSummaryGroupEntity);
__decorateClass$d([JsonProperty("account", Number)], PortfolioGroupEntity.prototype, "account", 2);
PortfolioGroupEntity = __decorateClass$d([JsonObject("PortfolioGroupEntity")], PortfolioGroupEntity);
var PortfoliosListCompleteResultEntity = /* @__PURE__ */ function(_PortfoliosListSummar) {
  _inherits(PortfoliosListCompleteResultEntity2, _PortfoliosListSummar);
  var _super2 = _createSuper$f(PortfoliosListCompleteResultEntity2);
  function PortfoliosListCompleteResultEntity2() {
    var _this2;
    _classCallCheck(this, PortfoliosListCompleteResultEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.property_count = 0;
    _this2.groups = [];
    return _this2;
  }
  return _createClass(PortfoliosListCompleteResultEntity2);
}(PortfoliosListSummaryResultEntity);
__decorateClass$d([JsonProperty("property_count", Number)], PortfoliosListCompleteResultEntity.prototype, "property_count", 2);
__decorateClass$d([JsonProperty("groups", [PortfolioGroupEntity])], PortfoliosListCompleteResultEntity.prototype, "groups", 2);
PortfoliosListCompleteResultEntity = __decorateClass$d([JsonObject("PortfoliosListCompleteResultEntity")], PortfoliosListCompleteResultEntity);
var PortfoliosListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(PortfoliosListCompleteResponseEntity2, _GenericResponseEntit);
  var _super3 = _createSuper$f(PortfoliosListCompleteResponseEntity2);
  function PortfoliosListCompleteResponseEntity2() {
    var _this3;
    _classCallCheck(this, PortfoliosListCompleteResponseEntity2);
    _this3 = _super3.apply(this, arguments);
    _this3.results = [];
    return _this3;
  }
  return _createClass(PortfoliosListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$d([JsonProperty("results", [PortfoliosListCompleteResultEntity])], PortfoliosListCompleteResponseEntity.prototype, "results", 2);
PortfoliosListCompleteResponseEntity = __decorateClass$d([JsonObject("PortfoliosListCompleteResponseEntity")], PortfoliosListCompleteResponseEntity);
var PortfolioUrls = {
  portfolio: "/api/2.0/portfolios/"
};
function _createSuper$e(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$e();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$e() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$g = Object.defineProperty;
var __defProps$4 = Object.defineProperties;
var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = function __defNormalProp12(obj, key, value) {
  return key in obj ? __defProp$g(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$4 = function __spreadValues12(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$4) {
    var _iterator = _createForOfIteratorHelper$4(__getOwnPropSymbols$4(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$4.call(b, prop))
          __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$4 = function __spreadProps9(a, b) {
  return __defProps$4(a, __getOwnPropDescs$4(b));
};
var PORTFOLIO_CACHE_KEY = {
  list: "portfolio",
  filter: "portfolio-filter"
};
var PorfoliosDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(PorfoliosDm2, _DmLeonardo);
  var _super = _createSuper$e(PorfoliosDm2);
  function PorfoliosDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, PorfoliosDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-portfolio";
    return _this;
  }
  _createClass(PorfoliosDm2, [{
    key: "getPortfoliosList",
    value: function getPortfoliosList(params) {
      var _this2 = this;
      var url = PortfolioUrls.portfolio;
      var finalParams = this.parseGenericParams(__spreadProps$4(__spreadValues$4({}, params), {
        modifier: "summary"
      }));
      return this._client.get({
        url,
        params: finalParams,
        cache: PORTFOLIO_CACHE_KEY.list
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, PortfoliosListSummaryResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getPortfoliosAsFilter",
    value: function getPortfoliosAsFilter(filter3) {
      return this.getAsGenericFilter(PortfolioUrls.portfolio, PORTFOLIO_CACHE_KEY.filter, PortfoliosListEssentialResponseEntity, __spreadValues$4({
        not_empty: "true"
      }, filter3));
    }
  }]);
  return PorfoliosDm2;
}(DmLeonardo);
function usePortfolioDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new PorfoliosDm(config);
  }, [config]);
  return {
    getPortfoliosList: useCallback(function(params) {
      return Api.getPortfoliosList(params);
    }, [Api]),
    getPortfoliosAsFilter: useCallback(function(filter3) {
      return Api.getPortfoliosAsFilter(filter3);
    }, [Api])
  };
}
function _createSuper$d(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$d();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$d() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = function __decorateClass26(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$f(target, key, result);
  return result;
};
var PropertiesListEssentialResultEntity = /* @__PURE__ */ _createClass(function PropertiesListEssentialResultEntity2() {
  _classCallCheck(this, PropertiesListEssentialResultEntity2);
  this.id = 0;
  this.name = "";
  this.pms_platform = 0;
  this.account = 0;
  this.portfolio = 0;
  this.time_zone = "";
});
__decorateClass$c([JsonProperty("id", Number)], PropertiesListEssentialResultEntity.prototype, "id", 2);
__decorateClass$c([JsonProperty("name", String)], PropertiesListEssentialResultEntity.prototype, "name", 2);
__decorateClass$c([JsonProperty("pms_platform", Number)], PropertiesListEssentialResultEntity.prototype, "pms_platform", 2);
__decorateClass$c([JsonProperty("account", Number)], PropertiesListEssentialResultEntity.prototype, "account", 2);
__decorateClass$c([JsonProperty("portfolio", Number)], PropertiesListEssentialResultEntity.prototype, "portfolio", 2);
__decorateClass$c([JsonProperty("time_zone", String, true)], PropertiesListEssentialResultEntity.prototype, "time_zone", 2);
PropertiesListEssentialResultEntity = __decorateClass$c([JsonObject("PropertiesListEssentialResultEntity")], PropertiesListEssentialResultEntity);
var PropertiesListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(PropertiesListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$d(PropertiesListEssentialResponseEntity2);
  function PropertiesListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, PropertiesListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(PropertiesListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$c([JsonProperty("results", [PropertiesListEssentialResultEntity])], PropertiesListEssentialResponseEntity.prototype, "results", 2);
PropertiesListEssentialResponseEntity = __decorateClass$c([JsonObject("PropertiesListEssentialResponseEntity")], PropertiesListEssentialResponseEntity);
function _createSuper$c(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$c();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$c() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = function __decorateClass27(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$e(target, key, result);
  return result;
};
var PropertiesListSummaryResultEntity = /* @__PURE__ */ _createClass(function PropertiesListSummaryResultEntity2() {
  _classCallCheck(this, PropertiesListSummaryResultEntity2);
  this.id = 0;
  this.property_name = "";
  this.account = "";
  this.units = 0;
  this.unmatched_units = 0;
});
__decorateClass$b([JsonProperty("id", Number)], PropertiesListSummaryResultEntity.prototype, "id", 2);
__decorateClass$b([JsonProperty("property_name", String)], PropertiesListSummaryResultEntity.prototype, "property_name", 2);
__decorateClass$b([JsonProperty("account", String)], PropertiesListSummaryResultEntity.prototype, "account", 2);
__decorateClass$b([JsonProperty("units", Number)], PropertiesListSummaryResultEntity.prototype, "units", 2);
__decorateClass$b([JsonProperty("unmatched_units", Number)], PropertiesListSummaryResultEntity.prototype, "unmatched_units", 2);
PropertiesListSummaryResultEntity = __decorateClass$b([JsonObject("PropertiesListSummaryResultEntity")], PropertiesListSummaryResultEntity);
var PropertiesListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(PropertiesListSummaryResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$c(PropertiesListSummaryResponseEntity2);
  function PropertiesListSummaryResponseEntity2() {
    var _this;
    _classCallCheck(this, PropertiesListSummaryResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(PropertiesListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$b([JsonProperty("results", [PropertiesListSummaryResultEntity])], PropertiesListSummaryResponseEntity.prototype, "results", 2);
PropertiesListSummaryResponseEntity = __decorateClass$b([JsonObject("PropertiesListSummaryResponseEntity")], PropertiesListSummaryResponseEntity);
function _createSuper$b(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$b();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$b() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = function __decorateClass28(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$d(target, key, result);
  return result;
};
var DuplicatePropertyAccountEntity = /* @__PURE__ */ _createClass(function DuplicatePropertyAccountEntity2() {
  _classCallCheck(this, DuplicatePropertyAccountEntity2);
  this.id = 0;
  this.name = "";
  this.white_label = 0;
});
__decorateClass$a([JsonProperty("id", Number)], DuplicatePropertyAccountEntity.prototype, "id", 2);
__decorateClass$a([JsonProperty("name", String)], DuplicatePropertyAccountEntity.prototype, "name", 2);
__decorateClass$a([JsonProperty("white_label", Number, true)], DuplicatePropertyAccountEntity.prototype, "white_label", 2);
DuplicatePropertyAccountEntity = __decorateClass$a([JsonObject("")], DuplicatePropertyAccountEntity);
var DuplicatePropertiesEssentialResultEntity = /* @__PURE__ */ _createClass(function DuplicatePropertiesEssentialResultEntity2() {
  _classCallCheck(this, DuplicatePropertiesEssentialResultEntity2);
  this.id = 0;
  this.name = "";
  this.pms_platform = 0;
  this.account = new DuplicatePropertyAccountEntity();
  this.total_units = 0;
  this.unmatched_units = 0;
});
__decorateClass$a([JsonProperty("id", Number)], DuplicatePropertiesEssentialResultEntity.prototype, "id", 2);
__decorateClass$a([JsonProperty("name", String)], DuplicatePropertiesEssentialResultEntity.prototype, "name", 2);
__decorateClass$a([JsonProperty("pms_platform", Number)], DuplicatePropertiesEssentialResultEntity.prototype, "pms_platform", 2);
__decorateClass$a([JsonProperty("account", DuplicatePropertyAccountEntity)], DuplicatePropertiesEssentialResultEntity.prototype, "account", 2);
__decorateClass$a([JsonProperty("total_units", Number)], DuplicatePropertiesEssentialResultEntity.prototype, "total_units", 2);
__decorateClass$a([JsonProperty("unmatched_units", Number)], DuplicatePropertiesEssentialResultEntity.prototype, "unmatched_units", 2);
DuplicatePropertiesEssentialResultEntity = __decorateClass$a([JsonObject("")], DuplicatePropertiesEssentialResultEntity);
var DuplicatePropertiesEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(DuplicatePropertiesEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$b(DuplicatePropertiesEssentialResponseEntity2);
  function DuplicatePropertiesEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, DuplicatePropertiesEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(DuplicatePropertiesEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$a([JsonProperty("results", [DuplicatePropertiesEssentialResultEntity])], DuplicatePropertiesEssentialResponseEntity.prototype, "results", 2);
DuplicatePropertiesEssentialResponseEntity = __decorateClass$a([JsonObject("DuplicatePropertiesEssentialResponseEntity")], DuplicatePropertiesEssentialResponseEntity);
var PropertyUrls = {
  property: "/api/2.0/properties/",
  propertyDuplicates: "/api/2.0/properties/duplicates/"
};
function _createSuper$a(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$a();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$a() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$c = Object.defineProperty;
var __defProps$3 = Object.defineProperties;
var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = function __defNormalProp13(obj, key, value) {
  return key in obj ? __defProp$c(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$3 = function __spreadValues13(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$3) {
    var _iterator = _createForOfIteratorHelper$3(__getOwnPropSymbols$3(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$3.call(b, prop))
          __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$3 = function __spreadProps10(a, b) {
  return __defProps$3(a, __getOwnPropDescs$3(b));
};
var PROPERTY_CACHE_KEYS = {
  list: "property",
  duplicateList: "duplicate-property",
  filter: "property-filter"
};
var PropertiesDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(PropertiesDm2, _DmLeonardo);
  var _super = _createSuper$a(PropertiesDm2);
  function PropertiesDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, PropertiesDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-property";
    return _this;
  }
  _createClass(PropertiesDm2, [{
    key: "getPropertiesList",
    value: function getPropertiesList(params) {
      var _this2 = this;
      var url = PropertyUrls.property;
      var finalParams = this.parseGenericParams(__spreadProps$3(__spreadValues$3({}, params), {
        modifier: "essential"
      }));
      return this._client.get({
        url,
        params: finalParams,
        cache: PROPERTY_CACHE_KEYS.list
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, PropertiesListEssentialResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getPropertiesAsFilter",
    value: function getPropertiesAsFilter(filter3) {
      return this.getAsGenericFilter(PropertyUrls.property, PROPERTY_CACHE_KEYS.filter, PropertiesListEssentialResponseEntity, filter3);
    }
  }, {
    key: "getPropertyMergeList",
    value: function getPropertyMergeList(params, filter3) {
      var _this3 = this;
      var url = PropertyUrls.propertyDuplicates;
      var finalParams = this.parseGenericParams(__spreadValues$3({}, params));
      var filterParams = this.parseFilterParams(filter3);
      return this._client.get({
        url,
        params: __spreadValues$3(__spreadValues$3({}, finalParams), filterParams),
        cache: PROPERTY_CACHE_KEYS.duplicateList
      }).then(function(_ref2) {
        var data2 = _ref2.data;
        return _this3._jsonConvert.deserializeObject(data2, DuplicatePropertiesEssentialResponseEntity);
      }).catch(function(e) {
        _this3.logger.error(e);
        throw e;
      });
    }
  }]);
  return PropertiesDm2;
}(DmLeonardo);
function usePropertyDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new PropertiesDm(config);
  }, [config]);
  return {
    getPropertiesList: useCallback(function(params) {
      return Api.getPropertiesList(params);
    }, [Api]),
    getPropertiesAsFilter: useCallback(function(filter3) {
      return Api.getPropertiesAsFilter(filter3);
    }, [Api]),
    getDuplicatedPropertiesList: useCallback(function(params, filter3) {
      return Api.getPropertyMergeList(params, filter3);
    }, [Api])
  };
}
var $$2 = _export;
var global$g = global$17;
var fails$9 = fails$D;
var isArray2 = isArray$4;
var isObject$3 = isObject$n;
var toObject$4 = toObject$c;
var lengthOfArrayLike$7 = lengthOfArrayLike$e;
var createProperty = createProperty$6;
var arraySpeciesCreate = arraySpeciesCreate$2;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$4;
var wellKnownSymbol$3 = wellKnownSymbol$r;
var V8_VERSION = engineV8Version;
var IS_CONCAT_SPREADABLE = wellKnownSymbol$3("isConcatSpreadable");
var MAX_SAFE_INTEGER = 9007199254740991;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
var TypeError$4 = global$g.TypeError;
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$9(function() {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});
var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");
var isConcatSpreadable = function(O) {
  if (!isObject$3(O))
    return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== void 0 ? !!spreadable : isArray2(O);
};
var FORCED$3 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
$$2({
  target: "Array",
  proto: true,
  forced: FORCED$3
}, {
  concat: function concat2(arg) {
    var O = toObject$4(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike$7(E);
        if (n + len > MAX_SAFE_INTEGER)
          throw TypeError$4(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++)
          if (k in E)
            createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER)
          throw TypeError$4(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});
function _createForOfIteratorHelper$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$b = Object.defineProperty;
var __defProps$2 = Object.defineProperties;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = function __defNormalProp14(obj, key, value) {
  return key in obj ? __defProp$b(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$2 = function __spreadValues14(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$2) {
    var _iterator = _createForOfIteratorHelper$2(__getOwnPropSymbols$2(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$2.call(b, prop))
          __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$2 = function __spreadProps11(a, b) {
  return __defProps$2(a, __getOwnPropDescs$2(b));
};
var __decorateClass$9 = function __decorateClass29(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
var PermissionsConverter = /* @__PURE__ */ function() {
  function PermissionsConverter2() {
    _classCallCheck(this, PermissionsConverter2);
  }
  _createClass(PermissionsConverter2, [{
    key: "serialize",
    value: function serialize(data2) {
      return Object.entries(data2).reduce(function(a, _ref) {
        var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        if (_typeof(value) === "object") {
          var options = Object.entries(value).reduce(function(va, _ref3) {
            var _ref4 = _slicedToArray(_ref3, 2), vkey = _ref4[0], vvalue = _ref4[1];
            return __spreadProps$2(__spreadValues$2({}, va), _defineProperty({}, "permission_".concat(vkey, "_").concat(key), vvalue));
          }, {});
          return __spreadValues$2(__spreadValues$2({}, a), options);
        }
        return __spreadProps$2(__spreadValues$2({}, a), _defineProperty({}, key, value));
      }, {});
    }
  }, {
    key: "deserialize",
    value: function deserialize(data2) {
      var _this = this;
      if (data2 && _typeof(data2) === "object") {
        var others = {
          id: 0,
          created: "",
          modified: ""
        };
        var regex = new RegExp(/^permission_([a-z]+)_(.*)/, "i");
        var result = Object.entries(data2).map(function(_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2), key = _ref6[0], value = _ref6[1];
          var _ref7 = _this.parsedKey(key, regex) || [], _ref8 = _slicedToArray(_ref7, 3), action = _ref8[1], group = _ref8[2];
          var parsed = action && group ? {
            action,
            group
          } : void 0;
          return {
            parsed,
            key,
            value
          };
        }).filter(function(_ref9) {
          var parsed = _ref9.parsed, key = _ref9.key, value = _ref9.value;
          if (!parsed) {
            others = __spreadProps$2(__spreadValues$2({}, others), _defineProperty({}, key, value));
          }
          return !!parsed;
        }).reduce(function(a, _ref10) {
          var _ref10$parsed = _ref10.parsed;
          _ref10$parsed = _ref10$parsed === void 0 ? {} : _ref10$parsed;
          var group = _ref10$parsed.group, action = _ref10$parsed.action, value = _ref10.value;
          return group && action ? __spreadProps$2(__spreadValues$2({}, a), _defineProperty({}, group, __spreadProps$2(__spreadValues$2({}, a[group.toString()]), _defineProperty({}, action, value)))) : {};
        }, {});
        return __spreadValues$2(__spreadValues$2({}, others), result);
      }
      return {};
    }
  }, {
    key: "parsedKey",
    value: function parsedKey(key, regex) {
      switch (key) {
        case "permission_assign_users_to_template":
          return [key, "assign_users_to", "template"];
        case "permission_define_property_charge_codes":
          return [key, "define_property", "charge_codes"];
        default:
          return regex.exec(key);
      }
    }
  }]);
  return PermissionsConverter2;
}();
PermissionsConverter = __decorateClass$9([JsonConverter], PermissionsConverter);
function _createSuper$9(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$9();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = function __decorateClass30(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
var RolesListEssentialResultEntity = /* @__PURE__ */ _createClass(function RolesListEssentialResultEntity2() {
  _classCallCheck(this, RolesListEssentialResultEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$8([JsonProperty("id", Number)], RolesListEssentialResultEntity.prototype, "id", 2);
__decorateClass$8([JsonProperty("name", String)], RolesListEssentialResultEntity.prototype, "name", 2);
RolesListEssentialResultEntity = __decorateClass$8([JsonObject("RolesListEssentialResultEntity")], RolesListEssentialResultEntity);
var RolesListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(RolesListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$9(RolesListEssentialResponseEntity2);
  function RolesListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, RolesListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(RolesListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$8([JsonProperty("results", [RolesListEssentialResultEntity])], RolesListEssentialResponseEntity.prototype, "results", 2);
RolesListEssentialResponseEntity = __decorateClass$8([JsonObject("RolesListEssentialResponseEntity")], RolesListEssentialResponseEntity);
function _createSuper$8(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$8();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$8() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = function __decorateClass31(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
var VisibleRoleEntity = /* @__PURE__ */ _createClass(function VisibleRoleEntity2() {
  _classCallCheck(this, VisibleRoleEntity2);
  this.id = 0;
  this.name = "";
  this.parent_base_type = 0;
  this.permissions = 0;
});
__decorateClass$7([JsonProperty("id", Number)], VisibleRoleEntity.prototype, "id", 2);
__decorateClass$7([JsonProperty("name", String)], VisibleRoleEntity.prototype, "name", 2);
__decorateClass$7([JsonProperty("parent_base_type", Number, true)], VisibleRoleEntity.prototype, "parent_base_type", 2);
__decorateClass$7([JsonProperty("permissions", Number)], VisibleRoleEntity.prototype, "permissions", 2);
VisibleRoleEntity = __decorateClass$7([JsonObject("VisibleRoleEntity")], VisibleRoleEntity);
var EditableRoleEntity = /* @__PURE__ */ _createClass(function EditableRoleEntity2() {
  _classCallCheck(this, EditableRoleEntity2);
  this.id = 0;
  this.name = "";
  this.parent_base_type = 0;
  this.permissions = 0;
});
__decorateClass$7([JsonProperty("id", Number)], EditableRoleEntity.prototype, "id", 2);
__decorateClass$7([JsonProperty("name", String)], EditableRoleEntity.prototype, "name", 2);
__decorateClass$7([JsonProperty("parent_base_type", Number, true)], EditableRoleEntity.prototype, "parent_base_type", 2);
__decorateClass$7([JsonProperty("permissions", Number)], EditableRoleEntity.prototype, "permissions", 2);
EditableRoleEntity = __decorateClass$7([JsonObject("EditableRoleEntity")], EditableRoleEntity);
var WhiteLabelRoleEntity = /* @__PURE__ */ _createClass(function WhiteLabelRoleEntity2() {
  _classCallCheck(this, WhiteLabelRoleEntity2);
  this.id = 0;
  this.name = "";
});
__decorateClass$7([JsonProperty("id", Number)], WhiteLabelRoleEntity.prototype, "id", 2);
__decorateClass$7([JsonProperty("name", String)], WhiteLabelRoleEntity.prototype, "name", 2);
WhiteLabelRoleEntity = __decorateClass$7([JsonObject("WhiteLabelRoleEntity")], WhiteLabelRoleEntity);
var RolesListSummaryResultEntity = /* @__PURE__ */ function(_RolesListEssentialRe) {
  _inherits(RolesListSummaryResultEntity2, _RolesListEssentialRe);
  var _super = _createSuper$8(RolesListSummaryResultEntity2);
  function RolesListSummaryResultEntity2() {
    var _this;
    _classCallCheck(this, RolesListSummaryResultEntity2);
    _this = _super.apply(this, arguments);
    _this.parent_base_type = 0;
    _this.sector = 0;
    _this.account = 0;
    _this.visible_roles = [];
    _this.editable_roles = [];
    _this.white_label = 0;
    return _this;
  }
  return _createClass(RolesListSummaryResultEntity2);
}(RolesListEssentialResultEntity);
__decorateClass$7([JsonProperty("parent_base_type", Number, true)], RolesListSummaryResultEntity.prototype, "parent_base_type", 2);
__decorateClass$7([JsonProperty("sector", Number, true)], RolesListSummaryResultEntity.prototype, "sector", 2);
__decorateClass$7([JsonProperty("account", Number, true)], RolesListSummaryResultEntity.prototype, "account", 2);
__decorateClass$7([JsonProperty("visible_roles", [VisibleRoleEntity])], RolesListSummaryResultEntity.prototype, "visible_roles", 2);
__decorateClass$7([JsonProperty("editable_roles", [EditableRoleEntity])], RolesListSummaryResultEntity.prototype, "editable_roles", 2);
__decorateClass$7([JsonProperty("white_label", Number, true)], RolesListSummaryResultEntity.prototype, "white_label", 2);
RolesListSummaryResultEntity = __decorateClass$7([JsonObject("RolesListSummaryResultEntity")], RolesListSummaryResultEntity);
var RolesListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(RolesListSummaryResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$8(RolesListSummaryResponseEntity2);
  function RolesListSummaryResponseEntity2() {
    var _this2;
    _classCallCheck(this, RolesListSummaryResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(RolesListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$7([JsonProperty("results", [RolesListSummaryResultEntity])], RolesListSummaryResponseEntity.prototype, "results", 2);
RolesListSummaryResponseEntity = __decorateClass$7([JsonObject("RolesListSummaryResponseEntity")], RolesListSummaryResponseEntity);
function _createSuper$7(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$7();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$7() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = function __decorateClass32(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
var CategoryEntity = /* @__PURE__ */ _createClass(function CategoryEntity2() {
  _classCallCheck(this, CategoryEntity2);
  this.id = 0;
  this.name = "";
  this.sector = [0];
});
__decorateClass$6([JsonProperty("id", Number)], CategoryEntity.prototype, "id", 2);
__decorateClass$6([JsonProperty("name", String)], CategoryEntity.prototype, "name", 2);
__decorateClass$6([JsonProperty("sector", [Number])], CategoryEntity.prototype, "sector", 2);
CategoryEntity = __decorateClass$6([JsonObject("CategoryEntity")], CategoryEntity);
var RolesListCompleteResultEntity = /* @__PURE__ */ function(_RolesListSummaryResu) {
  _inherits(RolesListCompleteResultEntity2, _RolesListSummaryResu);
  var _super = _createSuper$7(RolesListCompleteResultEntity2);
  function RolesListCompleteResultEntity2() {
    var _this;
    _classCallCheck(this, RolesListCompleteResultEntity2);
    _this = _super.apply(this, arguments);
    _this.permissions = void 0;
    _this.parent = 0;
    _this.categories = [];
    return _this;
  }
  return _createClass(RolesListCompleteResultEntity2);
}(RolesListSummaryResultEntity);
__decorateClass$6([JsonProperty("permissions", PermissionsConverter)], RolesListCompleteResultEntity.prototype, "permissions", 2);
__decorateClass$6([JsonProperty("parent", Number, true)], RolesListCompleteResultEntity.prototype, "parent", 2);
__decorateClass$6([JsonProperty("categories", [CategoryEntity])], RolesListCompleteResultEntity.prototype, "categories", 2);
RolesListCompleteResultEntity = __decorateClass$6([JsonObject("RolesListCompleteResultEntity")], RolesListCompleteResultEntity);
var RolesListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(RolesListCompleteResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$7(RolesListCompleteResponseEntity2);
  function RolesListCompleteResponseEntity2() {
    var _this2;
    _classCallCheck(this, RolesListCompleteResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(RolesListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$6([JsonProperty("results", [RolesListCompleteResultEntity])], RolesListCompleteResponseEntity.prototype, "results", 2);
RolesListCompleteResponseEntity = __decorateClass$6([JsonObject("RolesListCompleteResponseEntity")], RolesListCompleteResponseEntity);
var RolesUrls = {
  roles: "/api/2.0/account-users-roles/"
};
function _createSuper$6(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$6();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$6() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$7 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp15(obj, key, value) {
  return key in obj ? __defProp$7(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues15(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    var _iterator = _createForOfIteratorHelper$1(__getOwnPropSymbols$1(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$1.call(b, prop))
          __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps12(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var ROLES_CACHE_KEYS = {
  list: "roles",
  filter: "role-filter"
};
var RolesList = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(RolesList2, _DmLeonardo);
  var _super = _createSuper$6(RolesList2);
  function RolesList2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, RolesList2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-roles";
    return _this;
  }
  _createClass(RolesList2, [{
    key: "getRolesList",
    value: function getRolesList(params, filter3) {
      var _this2 = this;
      var url = RolesUrls.roles;
      var genericParams = this.parseGenericParams(__spreadProps$1(__spreadValues$1({}, params), {
        modifier: "complete"
      }));
      var filterParams = this.parseFilterParams(filter3);
      return this._client.get({
        url,
        params: __spreadValues$1(__spreadValues$1({}, genericParams), filterParams),
        cache: ROLES_CACHE_KEYS.list
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, RolesListCompleteResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getRolesAsFilter",
    value: function getRolesAsFilter() {
      return this.getAsGenericFilter(RolesUrls.roles, GROUP_CACHE_KEYS.filter, RolesListEssentialResponseEntity, {
        system: "true"
      });
    }
  }]);
  return RolesList2;
}(DmLeonardo);
function useRolesListDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new RolesList(config);
  }, [config]);
  return {
    getRolesList: useCallback(function(params, filter3) {
      return Api.getRolesList(params, filter3);
    }, [Api]),
    getRolesAsFilter: useCallback(function() {
      return Api.getRolesAsFilter();
    }, [Api])
  };
}
function useSectorDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new SectorDm(config);
  }, [config]);
  return {
    getSectorsList: useCallback(function(params) {
      var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      return Api.getSectorsList(params, force);
    }, [Api])
  };
}
function _createSuper$5(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$5();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$5() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = function __decorateClass33(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
var StringifyConverter = /* @__PURE__ */ function() {
  function StringifyConverter2() {
    _classCallCheck(this, StringifyConverter2);
  }
  _createClass(StringifyConverter2, [{
    key: "serialize",
    value: function serialize(data2) {
      return typeof data2 === "string" ? data2 : JSON.stringify(data2);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data2) {
      return data2;
    }
  }]);
  return StringifyConverter2;
}();
var StringifyStringConverter = /* @__PURE__ */ function(_StringifyConverter) {
  _inherits(StringifyStringConverter2, _StringifyConverter);
  var _super = _createSuper$5(StringifyStringConverter2);
  function StringifyStringConverter2() {
    _classCallCheck(this, StringifyStringConverter2);
    return _super.apply(this, arguments);
  }
  return _createClass(StringifyStringConverter2);
}(StringifyConverter);
StringifyStringConverter = __decorateClass$5([JsonConverter], StringifyStringConverter);
var StringifyThemeConfigConverter = /* @__PURE__ */ function(_StringifyConverter2) {
  _inherits(StringifyThemeConfigConverter2, _StringifyConverter2);
  var _super2 = _createSuper$5(StringifyThemeConfigConverter2);
  function StringifyThemeConfigConverter2() {
    _classCallCheck(this, StringifyThemeConfigConverter2);
    return _super2.apply(this, arguments);
  }
  return _createClass(StringifyThemeConfigConverter2);
}(StringifyConverter);
StringifyThemeConfigConverter = __decorateClass$5([JsonConverter], StringifyThemeConfigConverter);
var StringifyUrlConfigConverter = /* @__PURE__ */ function(_StringifyConverter3) {
  _inherits(StringifyUrlConfigConverter2, _StringifyConverter3);
  var _super3 = _createSuper$5(StringifyUrlConfigConverter2);
  function StringifyUrlConfigConverter2() {
    _classCallCheck(this, StringifyUrlConfigConverter2);
    return _super3.apply(this, arguments);
  }
  return _createClass(StringifyUrlConfigConverter2);
}(StringifyConverter);
StringifyUrlConfigConverter = __decorateClass$5([JsonConverter], StringifyUrlConfigConverter);
var StringifyAdminPermissionsConverter = /* @__PURE__ */ function(_StringifyConverter4) {
  _inherits(StringifyAdminPermissionsConverter2, _StringifyConverter4);
  var _super4 = _createSuper$5(StringifyAdminPermissionsConverter2);
  function StringifyAdminPermissionsConverter2() {
    _classCallCheck(this, StringifyAdminPermissionsConverter2);
    return _super4.apply(this, arguments);
  }
  return _createClass(StringifyAdminPermissionsConverter2);
}(StringifyConverter);
StringifyAdminPermissionsConverter = __decorateClass$5([JsonConverter], StringifyAdminPermissionsConverter);
var StringifyDefaultAccountPermissionsConverter = /* @__PURE__ */ function(_StringifyConverter5) {
  _inherits(StringifyDefaultAccountPermissionsConverter2, _StringifyConverter5);
  var _super5 = _createSuper$5(StringifyDefaultAccountPermissionsConverter2);
  function StringifyDefaultAccountPermissionsConverter2() {
    _classCallCheck(this, StringifyDefaultAccountPermissionsConverter2);
    return _super5.apply(this, arguments);
  }
  return _createClass(StringifyDefaultAccountPermissionsConverter2);
}(StringifyConverter);
StringifyDefaultAccountPermissionsConverter = __decorateClass$5([JsonConverter], StringifyDefaultAccountPermissionsConverter);
var global$f = global$17;
var isRegExp$1 = isRegexp;
var TypeError$3 = global$f.TypeError;
var notARegexp = function(it) {
  if (isRegExp$1(it)) {
    throw TypeError$3("The method doesn't accept regular expressions");
  }
  return it;
};
var wellKnownSymbol$2 = wellKnownSymbol$r;
var MATCH = wellKnownSymbol$2("match");
var correctIsRegexpLogic = function(METHOD_NAME) {
  var regexp = /./;
  try {
    "/./"[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return "/./"[METHOD_NAME](regexp);
    } catch (error2) {
    }
  }
  return false;
};
var $$1 = _export;
var uncurryThis$7 = functionUncurryThis;
var getOwnPropertyDescriptor4 = objectGetOwnPropertyDescriptor.f;
var toLength$5 = toLength$8;
var toString$1 = toString$a;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$8;
var correctIsRegExpLogic = correctIsRegexpLogic;
var un$StartsWith = uncurryThis$7("".startsWith);
var stringSlice$1 = uncurryThis$7("".slice);
var min$3 = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic("startsWith");
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function() {
  var descriptor = getOwnPropertyDescriptor4(String.prototype, "startsWith");
  return descriptor && !descriptor.writable;
}();
$$1({
  target: "String",
  proto: true,
  forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
  startsWith: function startsWith(searchString) {
    var that = toString$1(requireObjectCoercible$1(this));
    notARegExp(searchString);
    var index = toLength$5(min$3(arguments.length > 1 ? arguments[1] : void 0, that.length));
    var search = toString$1(searchString);
    return un$StartsWith ? un$StartsWith(that, search, index) : stringSlice$1(that, index, index + search.length) === search;
  }
});
var apply$3 = functionApply;
var call$4 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var isRegExp = isRegexp;
var anObject = anObject$k;
var requireObjectCoercible = requireObjectCoercible$8;
var speciesConstructor$1 = speciesConstructor$3;
var advanceStringIndex = advanceStringIndex$2;
var toLength$4 = toLength$8;
var toString3 = toString$a;
var getMethod = getMethod$6;
var arraySlice$4 = arraySliceSimple;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers = regexpStickyHelpers;
var fails$8 = fails$D;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 4294967295;
var min$2 = Math.min;
var $push = [].push;
var exec = uncurryThis$6(/./.exec);
var push = uncurryThis$6($push);
var stringSlice = uncurryThis$6("".slice);
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$8(function() {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function() {
    return originalExec.apply(this, arguments);
  };
  var result = "ab".split(re);
  return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if ("abbc".split(/(b)*/)[1] == "c" || "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length) {
    internalSplit = function(separator, limit) {
      var string = toString3(requireObjectCoercible(this));
      var lim = limit === void 0 ? MAX_UINT32 : limit >>> 0;
      if (lim === 0)
        return [];
      if (separator === void 0)
        return [string];
      if (!isRegExp(separator)) {
        return call$4(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
      var lastLastIndex = 0;
      var separatorCopy = new RegExp(separator.source, flags + "g");
      var match2, lastIndex, lastLength;
      while (match2 = call$4(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match2.index));
          if (match2.length > 1 && match2.index < string.length)
            apply$3($push, output, arraySlice$4(match2, 1));
          lastLength = match2[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim)
            break;
        }
        if (separatorCopy.lastIndex === match2.index)
          separatorCopy.lastIndex++;
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, ""))
          push(output, "");
      } else
        push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice$4(output, 0, lim) : output;
    };
  } else if ("0".split(void 0, 0).length) {
    internalSplit = function(separator, limit) {
      return separator === void 0 && limit === 0 ? [] : call$4(nativeSplit, this, separator, limit);
    };
  } else
    internalSplit = nativeSplit;
  return [
    function split2(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == void 0 ? void 0 : getMethod(separator, SPLIT);
      return splitter ? call$4(splitter, separator, O, limit) : call$4(internalSplit, toString3(O), separator, limit);
    },
    function(string, limit) {
      var rx = anObject(this);
      var S = toString3(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
      if (res.done)
        return res.value;
      var C = speciesConstructor$1(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + (UNSUPPORTED_Y ? "g" : "y");
      var splitter = new C(UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
      var lim = limit === void 0 ? MAX_UINT32 : limit >>> 0;
      if (lim === 0)
        return [];
      if (S.length === 0)
        return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (z === null || (e = min$2(toLength$4(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim)
            return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim)
              return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
var typedArrayConstructor = {
  exports: {}
};
var arrayBufferNative = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
var NATIVE_ARRAY_BUFFER$1 = arrayBufferNative;
var DESCRIPTORS$2 = descriptors;
var global$e = global$17;
var isCallable = isCallable$o;
var isObject$2 = isObject$n;
var hasOwn$1 = hasOwnProperty_1;
var classof$1 = classof$b;
var tryToString = tryToString$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$b;
var redefine = redefine$d.exports;
var defineProperty$1 = objectDefineProperty.f;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var wellKnownSymbol$1 = wellKnownSymbol$r;
var uid = uid$5;
var Int8Array$4 = global$e.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$4 && Int8Array$4.prototype;
var Uint8ClampedArray$1 = global$e.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray$1 = Int8Array$4 && getPrototypeOf$1(Int8Array$4);
var TypedArrayPrototype$2 = Int8ArrayPrototype$1 && getPrototypeOf$1(Int8ArrayPrototype$1);
var ObjectPrototype$1 = Object.prototype;
var TypeError$2 = global$e.TypeError;
var TO_STRING_TAG = wellKnownSymbol$1("toStringTag");
var TYPED_ARRAY_TAG$1 = uid("TYPED_ARRAY_TAG");
var TYPED_ARRAY_CONSTRUCTOR$2 = uid("TYPED_ARRAY_CONSTRUCTOR");
var NATIVE_ARRAY_BUFFER_VIEWS$2 = NATIVE_ARRAY_BUFFER$1 && !!setPrototypeOf$2 && classof$1(global$e.opera) !== "Opera";
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;
var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};
var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};
var isView = function isView2(it) {
  if (!isObject$2(it))
    return false;
  var klass = classof$1(it);
  return klass === "DataView" || hasOwn$1(TypedArrayConstructorsList, klass) || hasOwn$1(BigIntArrayConstructorsList, klass);
};
var isTypedArray$1 = function(it) {
  if (!isObject$2(it))
    return false;
  var klass = classof$1(it);
  return hasOwn$1(TypedArrayConstructorsList, klass) || hasOwn$1(BigIntArrayConstructorsList, klass);
};
var aTypedArray$m = function(it) {
  if (isTypedArray$1(it))
    return it;
  throw TypeError$2("Target is not a typed array");
};
var aTypedArrayConstructor$3 = function(C) {
  if (isCallable(C) && (!setPrototypeOf$2 || isPrototypeOf$1(TypedArray$1, C)))
    return C;
  throw TypeError$2(tryToString(C) + " is not a typed array constructor");
};
var exportTypedArrayMethod$n = function(KEY, property, forced, options) {
  if (!DESCRIPTORS$2)
    return;
  if (forced)
    for (var ARRAY in TypedArrayConstructorsList) {
      var TypedArrayConstructor = global$e[ARRAY];
      if (TypedArrayConstructor && hasOwn$1(TypedArrayConstructor.prototype, KEY))
        try {
          delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
          try {
            TypedArrayConstructor.prototype[KEY] = property;
          } catch (error2) {
          }
        }
    }
  if (!TypedArrayPrototype$2[KEY] || forced) {
    redefine(TypedArrayPrototype$2, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};
var exportTypedArrayStaticMethod = function(KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS$2)
    return;
  if (setPrototypeOf$2) {
    if (forced)
      for (ARRAY in TypedArrayConstructorsList) {
        TypedArrayConstructor = global$e[ARRAY];
        if (TypedArrayConstructor && hasOwn$1(TypedArrayConstructor, KEY))
          try {
            delete TypedArrayConstructor[KEY];
          } catch (error) {
          }
      }
    if (!TypedArray$1[KEY] || forced) {
      try {
        return redefine(TypedArray$1, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$2 && TypedArray$1[KEY] || property);
      } catch (error) {
      }
    } else
      return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$e[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      redefine(TypedArrayConstructor, KEY, property);
    }
  }
};
for (NAME in TypedArrayConstructorsList) {
  Constructor = global$e[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype)
    createNonEnumerableProperty$2(Prototype, TYPED_ARRAY_CONSTRUCTOR$2, Constructor);
  else
    NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}
for (NAME in BigIntArrayConstructorsList) {
  Constructor = global$e[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype)
    createNonEnumerableProperty$2(Prototype, TYPED_ARRAY_CONSTRUCTOR$2, Constructor);
}
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !isCallable(TypedArray$1) || TypedArray$1 === Function.prototype) {
  TypedArray$1 = function TypedArray2() {
    throw TypeError$2("Incorrect invocation");
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$2)
    for (NAME in TypedArrayConstructorsList) {
      if (global$e[NAME])
        setPrototypeOf$2(global$e[NAME], TypedArray$1);
    }
}
if (!NATIVE_ARRAY_BUFFER_VIEWS$2 || !TypedArrayPrototype$2 || TypedArrayPrototype$2 === ObjectPrototype$1) {
  TypedArrayPrototype$2 = TypedArray$1.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$2)
    for (NAME in TypedArrayConstructorsList) {
      if (global$e[NAME])
        setPrototypeOf$2(global$e[NAME].prototype, TypedArrayPrototype$2);
    }
}
if (NATIVE_ARRAY_BUFFER_VIEWS$2 && getPrototypeOf$1(Uint8ClampedArrayPrototype) !== TypedArrayPrototype$2) {
  setPrototypeOf$2(Uint8ClampedArrayPrototype, TypedArrayPrototype$2);
}
if (DESCRIPTORS$2 && !hasOwn$1(TypedArrayPrototype$2, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineProperty$1(TypedArrayPrototype$2, TO_STRING_TAG, {
    get: function() {
      return isObject$2(this) ? this[TYPED_ARRAY_TAG$1] : void 0;
    }
  });
  for (NAME in TypedArrayConstructorsList)
    if (global$e[NAME]) {
      createNonEnumerableProperty$2(global$e[NAME], TYPED_ARRAY_TAG$1, NAME);
    }
}
var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$2,
  TYPED_ARRAY_CONSTRUCTOR: TYPED_ARRAY_CONSTRUCTOR$2,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG$1,
  aTypedArray: aTypedArray$m,
  aTypedArrayConstructor: aTypedArrayConstructor$3,
  exportTypedArrayMethod: exportTypedArrayMethod$n,
  exportTypedArrayStaticMethod,
  isView,
  isTypedArray: isTypedArray$1,
  TypedArray: TypedArray$1,
  TypedArrayPrototype: TypedArrayPrototype$2
};
var global$d = global$17;
var fails$7 = fails$D;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$4;
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var ArrayBuffer$2 = global$d.ArrayBuffer;
var Int8Array$3 = global$d.Int8Array;
var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS$1 || !fails$7(function() {
  Int8Array$3(1);
}) || !fails$7(function() {
  new Int8Array$3(-1);
}) || !checkCorrectnessOfIteration(function(iterable) {
  new Int8Array$3();
  new Int8Array$3(null);
  new Int8Array$3(1.5);
  new Int8Array$3(iterable);
}, true) || fails$7(function() {
  return new Int8Array$3(new ArrayBuffer$2(2), 1, void 0).length !== 1;
});
var global$c = global$17;
var toIntegerOrInfinity$3 = toIntegerOrInfinity$8;
var toLength$3 = toLength$8;
var RangeError$5 = global$c.RangeError;
var toIndex$2 = function(it) {
  if (it === void 0)
    return 0;
  var number = toIntegerOrInfinity$3(it);
  var length = toLength$3(number);
  if (number !== length)
    throw RangeError$5("Wrong length or index");
  return length;
};
var global$b = global$17;
var Array$3 = global$b.Array;
var abs = Math.abs;
var pow = Math.pow;
var floor$3 = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var pack = function(number, mantissaLength, bytes) {
  var buffer = Array$3(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  if (number != number || number === Infinity) {
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$3(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};
var unpack = function(buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  }
  return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};
var ieee754 = {
  pack,
  unpack
};
var toObject$3 = toObject$c;
var toAbsoluteIndex$2 = toAbsoluteIndex$6;
var lengthOfArrayLike$6 = lengthOfArrayLike$e;
var arrayFill$1 = function fill(value) {
  var O = toObject$3(this);
  var length = lengthOfArrayLike$6(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex$2(argumentsLength > 1 ? arguments[1] : void 0, length);
  var end = argumentsLength > 2 ? arguments[2] : void 0;
  var endPos = end === void 0 ? length : toAbsoluteIndex$2(end, length);
  while (endPos > index)
    O[index++] = value;
  return O;
};
var global$a = global$17;
var uncurryThis$5 = functionUncurryThis;
var DESCRIPTORS$1 = descriptors;
var NATIVE_ARRAY_BUFFER = arrayBufferNative;
var FunctionName = functionName;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$b;
var redefineAll = redefineAll$5;
var fails$6 = fails$D;
var anInstance$1 = anInstance$6;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$8;
var toLength$2 = toLength$8;
var toIndex$1 = toIndex$2;
var IEEE754 = ieee754;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var defineProperty4 = objectDefineProperty.f;
var arrayFill = arrayFill$1;
var arraySlice$3 = arraySliceSimple;
var setToStringTag = setToStringTag$6;
var InternalStateModule$1 = internalState;
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var getInternalState$1 = InternalStateModule$1.get;
var setInternalState$1 = InternalStateModule$1.set;
var ARRAY_BUFFER = "ArrayBuffer";
var DATA_VIEW = "DataView";
var PROTOTYPE = "prototype";
var WRONG_LENGTH$1 = "Wrong length";
var WRONG_INDEX = "Wrong index";
var NativeArrayBuffer = global$a[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype$1 = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$a[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array$2 = global$a.Array;
var RangeError$4 = global$a.RangeError;
var fill2 = uncurryThis$5(arrayFill);
var reverse = uncurryThis$5([].reverse);
var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;
var packInt8 = function(number) {
  return [number & 255];
};
var packInt16 = function(number) {
  return [number & 255, number >> 8 & 255];
};
var packInt32 = function(number) {
  return [number & 255, number >> 8 & 255, number >> 16 & 255, number >> 24 & 255];
};
var unpackInt32 = function(buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var packFloat32 = function(number) {
  return packIEEE754(number, 23, 4);
};
var packFloat64 = function(number) {
  return packIEEE754(number, 52, 8);
};
var addGetter$1 = function(Constructor2, key) {
  defineProperty4(Constructor2[PROTOTYPE], key, {
    get: function() {
      return getInternalState$1(this)[key];
    }
  });
};
var get4 = function(view, count, index, isLittleEndian) {
  var intIndex = toIndex$1(index);
  var store = getInternalState$1(view);
  if (intIndex + count > store.byteLength)
    throw RangeError$4(WRONG_INDEX);
  var bytes = getInternalState$1(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack2 = arraySlice$3(bytes, start, start + count);
  return isLittleEndian ? pack2 : reverse(pack2);
};
var set = function(view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex$1(index);
  var store = getInternalState$1(view);
  if (intIndex + count > store.byteLength)
    throw RangeError$4(WRONG_INDEX);
  var bytes = getInternalState$1(store.buffer).bytes;
  var start = intIndex + store.byteOffset;
  var pack2 = conversion(+value);
  for (var i = 0; i < count; i++)
    bytes[start + i] = pack2[isLittleEndian ? i : count - i - 1];
};
if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer2(length) {
    anInstance$1(this, ArrayBufferPrototype$1);
    var byteLength = toIndex$1(length);
    setInternalState$1(this, {
      bytes: fill2(Array$2(byteLength), 0),
      byteLength
    });
    if (!DESCRIPTORS$1)
      this.byteLength = byteLength;
  };
  ArrayBufferPrototype$1 = $ArrayBuffer[PROTOTYPE];
  $DataView = function DataView2(buffer, byteOffset, byteLength) {
    anInstance$1(this, DataViewPrototype);
    anInstance$1(buffer, ArrayBufferPrototype$1);
    var bufferLength = getInternalState$1(buffer).byteLength;
    var offset = toIntegerOrInfinity$2(byteOffset);
    if (offset < 0 || offset > bufferLength)
      throw RangeError$4("Wrong offset");
    byteLength = byteLength === void 0 ? bufferLength - offset : toLength$2(byteLength);
    if (offset + byteLength > bufferLength)
      throw RangeError$4(WRONG_LENGTH$1);
    setInternalState$1(this, {
      buffer,
      byteLength,
      byteOffset: offset
    });
    if (!DESCRIPTORS$1) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };
  DataViewPrototype = $DataView[PROTOTYPE];
  if (DESCRIPTORS$1) {
    addGetter$1($ArrayBuffer, "byteLength");
    addGetter$1($DataView, "buffer");
    addGetter$1($DataView, "byteLength");
    addGetter$1($DataView, "byteOffset");
  }
  redefineAll(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get4(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get4(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset) {
      var bytes = get4(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : void 0);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset) {
      var bytes = get4(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : void 0);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset) {
      return unpackInt32(get4(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : void 0));
    },
    getUint32: function getUint32(byteOffset) {
      return unpackInt32(get4(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset) {
      return unpackIEEE754(get4(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : void 0), 23);
    },
    getFloat64: function getFloat64(byteOffset) {
      return unpackIEEE754(get4(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : void 0), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : void 0);
    },
    setUint16: function setUint16(byteOffset, value) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : void 0);
    },
    setInt32: function setInt32(byteOffset, value) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : void 0);
    },
    setUint32: function setUint32(byteOffset, value) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : void 0);
    },
    setFloat32: function setFloat32(byteOffset, value) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : void 0);
    },
    setFloat64: function setFloat64(byteOffset, value) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : void 0);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  if (!fails$6(function() {
    NativeArrayBuffer(1);
  }) || !fails$6(function() {
    new NativeArrayBuffer(-1);
  }) || fails$6(function() {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    $ArrayBuffer = function ArrayBuffer2(length) {
      anInstance$1(this, ArrayBufferPrototype$1);
      return new NativeArrayBuffer(toIndex$1(length));
    };
    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype$1;
    for (var keys4 = getOwnPropertyNames$1(NativeArrayBuffer), j = 0, key; keys4.length > j; ) {
      if (!((key = keys4[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty$1($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }
    ArrayBufferPrototype$1.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty$1(NativeArrayBuffer, "name", ARRAY_BUFFER);
  }
  if (setPrototypeOf$1 && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf$1(DataViewPrototype, ObjectPrototype);
  }
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis$5(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1))
    redefineAll(DataViewPrototype, {
      setInt8: function setInt8(byteOffset, value) {
        $setInt8(this, byteOffset, value << 24 >> 24);
      },
      setUint8: function setUint8(byteOffset, value) {
        $setInt8(this, byteOffset, value << 24 >> 24);
      }
    }, {
      unsafe: true
    });
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};
var isObject$1 = isObject$n;
var floor$2 = Math.floor;
var isIntegralNumber$1 = Number.isInteger || function isInteger(it) {
  return !isObject$1(it) && isFinite(it) && floor$2(it) === it;
};
var global$9 = global$17;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$8;
var RangeError$3 = global$9.RangeError;
var toPositiveInteger$1 = function(it) {
  var result = toIntegerOrInfinity$1(it);
  if (result < 0)
    throw RangeError$3("The argument can't be less than 0");
  return result;
};
var global$8 = global$17;
var toPositiveInteger = toPositiveInteger$1;
var RangeError$2 = global$8.RangeError;
var toOffset$2 = function(it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES)
    throw RangeError$2("Wrong offset");
  return offset;
};
var bind2 = functionBindContext;
var call$3 = functionCall;
var aConstructor = aConstructor$3;
var toObject$2 = toObject$c;
var lengthOfArrayLike$5 = lengthOfArrayLike$e;
var getIterator = getIterator$3;
var getIteratorMethod = getIteratorMethod$4;
var isArrayIteratorMethod = isArrayIteratorMethod$3;
var aTypedArrayConstructor$2 = arrayBufferViewCore.aTypedArrayConstructor;
var typedArrayFrom$1 = function from3(source) {
  var C = aConstructor(this);
  var O = toObject$2(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
  var mapping = mapfn !== void 0;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, step, iterator, next2;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next2 = iterator.next;
    O = [];
    while (!(step = call$3(next2, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind2(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike$5(O);
  result = new (aTypedArrayConstructor$2(C))(length);
  for (i = 0; length > i; i++) {
    result[i] = mapping ? mapfn(O[i], i) : O[i];
  }
  return result;
};
var $ = _export;
var global$7 = global$17;
var call$2 = functionCall;
var DESCRIPTORS = descriptors;
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = typedArrayConstructorsRequireWrappers;
var ArrayBufferViewCore$n = arrayBufferViewCore;
var ArrayBufferModule = arrayBuffer;
var anInstance = anInstance$6;
var createPropertyDescriptor = createPropertyDescriptor$6;
var createNonEnumerableProperty = createNonEnumerableProperty$b;
var isIntegralNumber = isIntegralNumber$1;
var toLength$1 = toLength$8;
var toIndex = toIndex$2;
var toOffset$1 = toOffset$2;
var toPropertyKey = toPropertyKey$5;
var hasOwn2 = hasOwnProperty_1;
var classof = classof$b;
var isObject = isObject$n;
var isSymbol = isSymbol$5;
var create3 = objectCreate;
var isPrototypeOf = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var getOwnPropertyNames4 = objectGetOwnPropertyNames.f;
var typedArrayFrom = typedArrayFrom$1;
var forEach2 = arrayIteration.forEach;
var setSpecies = setSpecies$4;
var definePropertyModule = objectDefineProperty;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var InternalStateModule = internalState;
var inheritIfRequired = inheritIfRequired$4;
var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError$1 = global$7.RangeError;
var ArrayBuffer$1 = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer$1.prototype;
var DataView$1 = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore$n.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_CONSTRUCTOR$1 = ArrayBufferViewCore$n.TYPED_ARRAY_CONSTRUCTOR;
var TYPED_ARRAY_TAG = ArrayBufferViewCore$n.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore$n.TypedArray;
var TypedArrayPrototype$1 = ArrayBufferViewCore$n.TypedArrayPrototype;
var aTypedArrayConstructor$1 = ArrayBufferViewCore$n.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore$n.isTypedArray;
var BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
var WRONG_LENGTH = "Wrong length";
var fromList = function(C, list) {
  aTypedArrayConstructor$1(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index)
    result[index] = list[index++];
  return result;
};
var addGetter = function(it, key) {
  nativeDefineProperty(it, key, {
    get: function() {
      return getInternalState(this)[key];
    }
  });
};
var isArrayBuffer = function(it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == "ArrayBuffer" || klass == "SharedArrayBuffer";
};
var isTypedArrayIndex = function(target, key) {
  return isTypedArray(target) && !isSymbol(key) && key in target && isIntegralNumber(+key) && key >= 0;
};
var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor5(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key) ? createPropertyDescriptor(2, target[key]) : nativeGetOwnPropertyDescriptor(target, key);
};
var wrappedDefineProperty = function defineProperty5(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key) && isObject(descriptor) && hasOwn2(descriptor, "value") && !hasOwn2(descriptor, "get") && !hasOwn2(descriptor, "set") && !descriptor.configurable && (!hasOwn2(descriptor, "writable") || descriptor.writable) && (!hasOwn2(descriptor, "enumerable") || descriptor.enumerable)) {
    target[key] = descriptor.value;
    return target;
  }
  return nativeDefineProperty(target, key, descriptor);
};
if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype$1, "buffer");
    addGetter(TypedArrayPrototype$1, "byteOffset");
    addGetter(TypedArrayPrototype$1, "byteLength");
    addGetter(TypedArrayPrototype$1, "length");
  }
  $({
    target: "Object",
    stat: true,
    forced: !NATIVE_ARRAY_BUFFER_VIEWS
  }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });
  typedArrayConstructor.exports = function(TYPE, wrapper2, CLAMPED) {
    var BYTES = TYPE.match(/\d+$/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
    var GETTER = "get" + TYPE;
    var SETTER = "set" + TYPE;
    var NativeTypedArrayConstructor = global$7[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};
    var getter = function(that, index) {
      var data2 = getInternalState(that);
      return data2.view[GETTER](index * BYTES + data2.byteOffset, true);
    };
    var setter = function(that, index, value) {
      var data2 = getInternalState(that);
      if (CLAMPED)
        value = (value = round(value)) < 0 ? 0 : value > 255 ? 255 : value & 255;
      data2.view[SETTER](index * BYTES + data2.byteOffset, value, true);
    };
    var addElement = function(that, index) {
      nativeDefineProperty(that, index, {
        get: function() {
          return getter(this, index);
        },
        set: function(value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper2(function(that, data2, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data2)) {
          length = toIndex(data2);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer$1(byteLength);
        } else if (isArrayBuffer(data2)) {
          buffer = data2;
          byteOffset = toOffset$1(offset, BYTES);
          var $len = data2.byteLength;
          if ($length === void 0) {
            if ($len % BYTES)
              throw RangeError$1(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0)
              throw RangeError$1(WRONG_LENGTH);
          } else {
            byteLength = toLength$1($length) * BYTES;
            if (byteLength + byteOffset > $len)
              throw RangeError$1(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data2)) {
          return fromList(TypedArrayConstructor, data2);
        } else {
          return call$2(typedArrayFrom, TypedArrayConstructor, data2);
        }
        setInternalState(that, {
          buffer,
          byteOffset,
          byteLength,
          length,
          view: new DataView$1(buffer)
        });
        while (index < length)
          addElement(that, index++);
      });
      if (setPrototypeOf)
        setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create3(TypedArrayPrototype$1);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper2(function(dummy, data2, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function() {
          if (!isObject(data2))
            return new NativeTypedArrayConstructor(toIndex(data2));
          if (isArrayBuffer(data2))
            return $length !== void 0 ? new NativeTypedArrayConstructor(data2, toOffset$1(typedArrayOffset, BYTES), $length) : typedArrayOffset !== void 0 ? new NativeTypedArrayConstructor(data2, toOffset$1(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data2);
          if (isTypedArray(data2))
            return fromList(TypedArrayConstructor, data2);
          return call$2(typedArrayFrom, TypedArrayConstructor, data2);
        }(), dummy, TypedArrayConstructor);
      });
      if (setPrototypeOf)
        setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach2(getOwnPropertyNames4(NativeTypedArrayConstructor), function(key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }
    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
    }
    createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_CONSTRUCTOR$1, TypedArrayConstructor);
    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }
    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
    $({
      global: true,
      forced: TypedArrayConstructor != NativeTypedArrayConstructor,
      sham: !NATIVE_ARRAY_BUFFER_VIEWS
    }, exported);
    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }
    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }
    setSpecies(CONSTRUCTOR_NAME);
  };
} else
  typedArrayConstructor.exports = function() {
  };
var createTypedArrayConstructor = typedArrayConstructor.exports;
createTypedArrayConstructor("Uint8", function(init) {
  return function Uint8Array2(data2, byteOffset, length) {
    return init(this, data2, byteOffset, length);
  };
});
var toObject$1 = toObject$c;
var toAbsoluteIndex$1 = toAbsoluteIndex$6;
var lengthOfArrayLike$4 = lengthOfArrayLike$e;
var min$1 = Math.min;
var arrayCopyWithin = [].copyWithin || function copyWithin(target, start) {
  var O = toObject$1(this);
  var len = lengthOfArrayLike$4(O);
  var to = toAbsoluteIndex$1(target, len);
  var from4 = toAbsoluteIndex$1(start, len);
  var end = arguments.length > 2 ? arguments[2] : void 0;
  var count = min$1((end === void 0 ? len : toAbsoluteIndex$1(end, len)) - from4, len - to);
  var inc = 1;
  if (from4 < to && to < from4 + count) {
    inc = -1;
    from4 += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from4 in O)
      O[to] = O[from4];
    else
      delete O[to];
    to += inc;
    from4 += inc;
  }
  return O;
};
var uncurryThis$4 = functionUncurryThis;
var ArrayBufferViewCore$m = arrayBufferViewCore;
var $ArrayCopyWithin = arrayCopyWithin;
var u$ArrayCopyWithin = uncurryThis$4($ArrayCopyWithin);
var aTypedArray$l = ArrayBufferViewCore$m.aTypedArray;
var exportTypedArrayMethod$m = ArrayBufferViewCore$m.exportTypedArrayMethod;
exportTypedArrayMethod$m("copyWithin", function copyWithin2(target, start) {
  return u$ArrayCopyWithin(aTypedArray$l(this), target, start, arguments.length > 2 ? arguments[2] : void 0);
});
var ArrayBufferViewCore$l = arrayBufferViewCore;
var $every = arrayIteration.every;
var aTypedArray$k = ArrayBufferViewCore$l.aTypedArray;
var exportTypedArrayMethod$l = ArrayBufferViewCore$l.exportTypedArrayMethod;
exportTypedArrayMethod$l("every", function every(callbackfn) {
  return $every(aTypedArray$k(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$k = arrayBufferViewCore;
var call$1 = functionCall;
var $fill = arrayFill$1;
var aTypedArray$j = ArrayBufferViewCore$k.aTypedArray;
var exportTypedArrayMethod$k = ArrayBufferViewCore$k.exportTypedArrayMethod;
exportTypedArrayMethod$k("fill", function fill3(value) {
  var length = arguments.length;
  return call$1($fill, aTypedArray$j(this), value, length > 1 ? arguments[1] : void 0, length > 2 ? arguments[2] : void 0);
});
var lengthOfArrayLike$3 = lengthOfArrayLike$e;
var arrayFromConstructorAndList$1 = function(Constructor2, list) {
  var index = 0;
  var length = lengthOfArrayLike$3(list);
  var result = new Constructor2(length);
  while (length > index)
    result[index] = list[index++];
  return result;
};
var ArrayBufferViewCore$j = arrayBufferViewCore;
var speciesConstructor = speciesConstructor$3;
var TYPED_ARRAY_CONSTRUCTOR = ArrayBufferViewCore$j.TYPED_ARRAY_CONSTRUCTOR;
var aTypedArrayConstructor = ArrayBufferViewCore$j.aTypedArrayConstructor;
var typedArraySpeciesConstructor$4 = function(originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, originalArray[TYPED_ARRAY_CONSTRUCTOR]));
};
var arrayFromConstructorAndList = arrayFromConstructorAndList$1;
var typedArraySpeciesConstructor$3 = typedArraySpeciesConstructor$4;
var typedArrayFromSpeciesAndList = function(instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor$3(instance), list);
};
var ArrayBufferViewCore$i = arrayBufferViewCore;
var $filter = arrayIteration.filter;
var fromSpeciesAndList = typedArrayFromSpeciesAndList;
var aTypedArray$i = ArrayBufferViewCore$i.aTypedArray;
var exportTypedArrayMethod$j = ArrayBufferViewCore$i.exportTypedArrayMethod;
exportTypedArrayMethod$j("filter", function filter2(callbackfn) {
  var list = $filter(aTypedArray$i(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
  return fromSpeciesAndList(this, list);
});
var ArrayBufferViewCore$h = arrayBufferViewCore;
var $find = arrayIteration.find;
var aTypedArray$h = ArrayBufferViewCore$h.aTypedArray;
var exportTypedArrayMethod$i = ArrayBufferViewCore$h.exportTypedArrayMethod;
exportTypedArrayMethod$i("find", function find3(predicate) {
  return $find(aTypedArray$h(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$g = arrayBufferViewCore;
var $findIndex = arrayIteration.findIndex;
var aTypedArray$g = ArrayBufferViewCore$g.aTypedArray;
var exportTypedArrayMethod$h = ArrayBufferViewCore$g.exportTypedArrayMethod;
exportTypedArrayMethod$h("findIndex", function findIndex2(predicate) {
  return $findIndex(aTypedArray$g(this), predicate, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$f = arrayBufferViewCore;
var $forEach = arrayIteration.forEach;
var aTypedArray$f = ArrayBufferViewCore$f.aTypedArray;
var exportTypedArrayMethod$g = ArrayBufferViewCore$f.exportTypedArrayMethod;
exportTypedArrayMethod$g("forEach", function forEach3(callbackfn) {
  $forEach(aTypedArray$f(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$e = arrayBufferViewCore;
var $includes = arrayIncludes.includes;
var aTypedArray$e = ArrayBufferViewCore$e.aTypedArray;
var exportTypedArrayMethod$f = ArrayBufferViewCore$e.exportTypedArrayMethod;
exportTypedArrayMethod$f("includes", function includes2(searchElement) {
  return $includes(aTypedArray$e(this), searchElement, arguments.length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$d = arrayBufferViewCore;
var $indexOf = arrayIncludes.indexOf;
var aTypedArray$d = ArrayBufferViewCore$d.aTypedArray;
var exportTypedArrayMethod$e = ArrayBufferViewCore$d.exportTypedArrayMethod;
exportTypedArrayMethod$e("indexOf", function indexOf2(searchElement) {
  return $indexOf(aTypedArray$d(this), searchElement, arguments.length > 1 ? arguments[1] : void 0);
});
var global$6 = global$17;
var fails$5 = fails$D;
var uncurryThis$3 = functionUncurryThis;
var ArrayBufferViewCore$c = arrayBufferViewCore;
var ArrayIterators = es_array_iterator;
var wellKnownSymbol = wellKnownSymbol$r;
var ITERATOR = wellKnownSymbol("iterator");
var Uint8Array$2 = global$6.Uint8Array;
var arrayValues = uncurryThis$3(ArrayIterators.values);
var arrayKeys = uncurryThis$3(ArrayIterators.keys);
var arrayEntries = uncurryThis$3(ArrayIterators.entries);
var aTypedArray$c = ArrayBufferViewCore$c.aTypedArray;
var exportTypedArrayMethod$d = ArrayBufferViewCore$c.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array$2 && Uint8Array$2.prototype;
var GENERIC = !fails$5(function() {
  TypedArrayPrototype[ITERATOR].call([1]);
});
var ITERATOR_IS_VALUES = !!TypedArrayPrototype && TypedArrayPrototype.values && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values && TypedArrayPrototype.values.name === "values";
var typedArrayValues = function values2() {
  return arrayValues(aTypedArray$c(this));
};
exportTypedArrayMethod$d("entries", function entries2() {
  return arrayEntries(aTypedArray$c(this));
}, GENERIC);
exportTypedArrayMethod$d("keys", function keys3() {
  return arrayKeys(aTypedArray$c(this));
}, GENERIC);
exportTypedArrayMethod$d("values", typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
  name: "values"
});
exportTypedArrayMethod$d(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, {
  name: "values"
});
var ArrayBufferViewCore$b = arrayBufferViewCore;
var uncurryThis$2 = functionUncurryThis;
var aTypedArray$b = ArrayBufferViewCore$b.aTypedArray;
var exportTypedArrayMethod$c = ArrayBufferViewCore$b.exportTypedArrayMethod;
var $join = uncurryThis$2([].join);
exportTypedArrayMethod$c("join", function join2(separator) {
  return $join(aTypedArray$b(this), separator);
});
var apply$2 = functionApply;
var toIndexedObject$1 = toIndexedObject$e;
var toIntegerOrInfinity = toIntegerOrInfinity$8;
var lengthOfArrayLike$2 = lengthOfArrayLike$e;
var arrayMethodIsStrict = arrayMethodIsStrict$3;
var min = Math.min;
var $lastIndexOf$1 = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf$1 && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict("lastIndexOf");
var FORCED$2 = NEGATIVE_ZERO || !STRICT_METHOD;
var arrayLastIndexOf = FORCED$2 ? function lastIndexOf(searchElement) {
  if (NEGATIVE_ZERO)
    return apply$2($lastIndexOf$1, this, arguments) || 0;
  var O = toIndexedObject$1(this);
  var length = lengthOfArrayLike$2(O);
  var index = length - 1;
  if (arguments.length > 1)
    index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0)
    index = length + index;
  for (; index >= 0; index--)
    if (index in O && O[index] === searchElement)
      return index || 0;
  return -1;
} : $lastIndexOf$1;
var ArrayBufferViewCore$a = arrayBufferViewCore;
var apply$1 = functionApply;
var $lastIndexOf = arrayLastIndexOf;
var aTypedArray$a = ArrayBufferViewCore$a.aTypedArray;
var exportTypedArrayMethod$b = ArrayBufferViewCore$a.exportTypedArrayMethod;
exportTypedArrayMethod$b("lastIndexOf", function lastIndexOf2(searchElement) {
  var length = arguments.length;
  return apply$1($lastIndexOf, aTypedArray$a(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});
var ArrayBufferViewCore$9 = arrayBufferViewCore;
var $map = arrayIteration.map;
var typedArraySpeciesConstructor$2 = typedArraySpeciesConstructor$4;
var aTypedArray$9 = ArrayBufferViewCore$9.aTypedArray;
var exportTypedArrayMethod$a = ArrayBufferViewCore$9.exportTypedArrayMethod;
exportTypedArrayMethod$a("map", function map2(mapfn) {
  return $map(aTypedArray$9(this), mapfn, arguments.length > 1 ? arguments[1] : void 0, function(O, length) {
    return new (typedArraySpeciesConstructor$2(O))(length);
  });
});
var global$5 = global$17;
var aCallable$1 = aCallable$8;
var toObject = toObject$c;
var IndexedObject = indexedObject;
var lengthOfArrayLike$1 = lengthOfArrayLike$e;
var TypeError$1 = global$5.TypeError;
var createMethod = function(IS_RIGHT) {
  return function(that, callbackfn, argumentsLength, memo) {
    aCallable$1(callbackfn);
    var O = toObject(that);
    var self2 = IndexedObject(O);
    var length = lengthOfArrayLike$1(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2)
      while (true) {
        if (index in self2) {
          memo = self2[index];
          index += i;
          break;
        }
        index += i;
        if (IS_RIGHT ? index < 0 : length <= index) {
          throw TypeError$1("Reduce of empty array with no initial value");
        }
      }
    for (; IS_RIGHT ? index >= 0 : length > index; index += i)
      if (index in self2) {
        memo = callbackfn(memo, self2[index], index, O);
      }
    return memo;
  };
};
var arrayReduce = {
  left: createMethod(false),
  right: createMethod(true)
};
var ArrayBufferViewCore$8 = arrayBufferViewCore;
var $reduce = arrayReduce.left;
var aTypedArray$8 = ArrayBufferViewCore$8.aTypedArray;
var exportTypedArrayMethod$9 = ArrayBufferViewCore$8.exportTypedArrayMethod;
exportTypedArrayMethod$9("reduce", function reduce(callbackfn) {
  var length = arguments.length;
  return $reduce(aTypedArray$8(this), callbackfn, length, length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$7 = arrayBufferViewCore;
var $reduceRight = arrayReduce.right;
var aTypedArray$7 = ArrayBufferViewCore$7.aTypedArray;
var exportTypedArrayMethod$8 = ArrayBufferViewCore$7.exportTypedArrayMethod;
exportTypedArrayMethod$8("reduceRight", function reduceRight(callbackfn) {
  var length = arguments.length;
  return $reduceRight(aTypedArray$7(this), callbackfn, length, length > 1 ? arguments[1] : void 0);
});
var ArrayBufferViewCore$6 = arrayBufferViewCore;
var aTypedArray$6 = ArrayBufferViewCore$6.aTypedArray;
var exportTypedArrayMethod$7 = ArrayBufferViewCore$6.exportTypedArrayMethod;
var floor$1 = Math.floor;
exportTypedArrayMethod$7("reverse", function reverse2() {
  var that = this;
  var length = aTypedArray$6(that).length;
  var middle = floor$1(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  }
  return that;
});
var global$4 = global$17;
var call = functionCall;
var ArrayBufferViewCore$5 = arrayBufferViewCore;
var lengthOfArrayLike = lengthOfArrayLike$e;
var toOffset = toOffset$2;
var toIndexedObject = toObject$c;
var fails$4 = fails$D;
var RangeError = global$4.RangeError;
var Int8Array$2 = global$4.Int8Array;
var Int8ArrayPrototype = Int8Array$2 && Int8Array$2.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$5 = ArrayBufferViewCore$5.aTypedArray;
var exportTypedArrayMethod$6 = ArrayBufferViewCore$5.exportTypedArrayMethod;
var WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !fails$4(function() {
  var array = new Uint8ClampedArray(2);
  call($set, array, {
    length: 1,
    0: 3
  }, 1);
  return array[1] !== 3;
});
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore$5.NATIVE_ARRAY_BUFFER_VIEWS && fails$4(function() {
  var array = new Int8Array$2(2);
  array.set(1);
  array.set("2", 1);
  return array[0] !== 0 || array[1] !== 2;
});
exportTypedArrayMethod$6("set", function set2(arrayLike) {
  aTypedArray$5(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : void 0, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS)
    return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length)
    throw RangeError("Wrong length");
  while (index < len)
    this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);
var ArrayBufferViewCore$4 = arrayBufferViewCore;
var typedArraySpeciesConstructor$1 = typedArraySpeciesConstructor$4;
var fails$3 = fails$D;
var arraySlice$2 = arraySlice$a;
var aTypedArray$4 = ArrayBufferViewCore$4.aTypedArray;
var exportTypedArrayMethod$5 = ArrayBufferViewCore$4.exportTypedArrayMethod;
var FORCED$1 = fails$3(function() {
  new Int8Array(1).slice();
});
exportTypedArrayMethod$5("slice", function slice2(start, end) {
  var list = arraySlice$2(aTypedArray$4(this), start, end);
  var C = typedArraySpeciesConstructor$1(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index)
    result[index] = list[index++];
  return result;
}, FORCED$1);
var ArrayBufferViewCore$3 = arrayBufferViewCore;
var $some = arrayIteration.some;
var aTypedArray$3 = ArrayBufferViewCore$3.aTypedArray;
var exportTypedArrayMethod$4 = ArrayBufferViewCore$3.exportTypedArrayMethod;
exportTypedArrayMethod$4("some", function some(callbackfn) {
  return $some(aTypedArray$3(this), callbackfn, arguments.length > 1 ? arguments[1] : void 0);
});
var arraySlice$1 = arraySliceSimple;
var floor = Math.floor;
var mergeSort = function(array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(array, mergeSort(arraySlice$1(array, 0, middle), comparefn), mergeSort(arraySlice$1(array, middle), comparefn), comparefn);
};
var insertionSort = function(array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;
  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++)
      array[j] = element;
  }
  return array;
};
var merge = function(array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
  }
  return array;
};
var arraySort = mergeSort;
var userAgent$1 = engineUserAgent;
var firefox = userAgent$1.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];
var UA = engineUserAgent;
var engineIsIeOrEdge = /MSIE|Trident/.test(UA);
var userAgent = engineUserAgent;
var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
var engineWebkitVersion = !!webkit && +webkit[1];
var global$3 = global$17;
var uncurryThis$1 = functionUncurryThis;
var fails$2 = fails$D;
var aCallable = aCallable$8;
var internalSort = arraySort;
var ArrayBufferViewCore$2 = arrayBufferViewCore;
var FF = engineFfVersion;
var IE_OR_EDGE = engineIsIeOrEdge;
var V8 = engineV8Version;
var WEBKIT = engineWebkitVersion;
var Array$1 = global$3.Array;
var aTypedArray$2 = ArrayBufferViewCore$2.aTypedArray;
var exportTypedArrayMethod$3 = ArrayBufferViewCore$2.exportTypedArrayMethod;
var Uint16Array = global$3.Uint16Array;
var un$Sort = Uint16Array && uncurryThis$1(Uint16Array.prototype.sort);
var ACCEPT_INCORRECT_ARGUMENTS = !!un$Sort && !(fails$2(function() {
  un$Sort(new Uint16Array(2), null);
}) && fails$2(function() {
  un$Sort(new Uint16Array(2), {});
}));
var STABLE_SORT = !!un$Sort && !fails$2(function() {
  if (V8)
    return V8 < 74;
  if (FF)
    return FF < 67;
  if (IE_OR_EDGE)
    return true;
  if (WEBKIT)
    return WEBKIT < 602;
  var array = new Uint16Array(516);
  var expected = Array$1(516);
  var index, mod;
  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }
  un$Sort(array, function(a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });
  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index])
      return true;
  }
});
var getSortCompare = function(comparefn) {
  return function(x, y) {
    if (comparefn !== void 0)
      return +comparefn(x, y) || 0;
    if (y !== y)
      return -1;
    if (x !== x)
      return 1;
    if (x === 0 && y === 0)
      return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};
exportTypedArrayMethod$3("sort", function sort(comparefn) {
  if (comparefn !== void 0)
    aCallable(comparefn);
  if (STABLE_SORT)
    return un$Sort(this, comparefn);
  return internalSort(aTypedArray$2(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);
var ArrayBufferViewCore$1 = arrayBufferViewCore;
var toLength = toLength$8;
var toAbsoluteIndex = toAbsoluteIndex$6;
var typedArraySpeciesConstructor = typedArraySpeciesConstructor$4;
var aTypedArray$1 = ArrayBufferViewCore$1.aTypedArray;
var exportTypedArrayMethod$2 = ArrayBufferViewCore$1.exportTypedArrayMethod;
exportTypedArrayMethod$2("subarray", function subarray(begin, end) {
  var O = aTypedArray$1(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(O.buffer, O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT, toLength((end === void 0 ? length : toAbsoluteIndex(end, length)) - beginIndex));
});
var global$2 = global$17;
var apply = functionApply;
var ArrayBufferViewCore = arrayBufferViewCore;
var fails$1 = fails$D;
var arraySlice = arraySlice$a;
var Int8Array$1 = global$2.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;
var TO_LOCALE_STRING_BUG = !!Int8Array$1 && fails$1(function() {
  $toLocaleString.call(new Int8Array$1(1));
});
var FORCED = fails$1(function() {
  return [1, 2].toLocaleString() != new Int8Array$1([1, 2]).toLocaleString();
}) || !fails$1(function() {
  Int8Array$1.prototype.toLocaleString.call([1, 2]);
});
exportTypedArrayMethod$1("toLocaleString", function toLocaleString() {
  return apply($toLocaleString, TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this), arraySlice(arguments));
}, FORCED);
var exportTypedArrayMethod = arrayBufferViewCore.exportTypedArrayMethod;
var fails = fails$D;
var global$1 = global$17;
var uncurryThis = functionUncurryThis;
var Uint8Array$1 = global$1.Uint8Array;
var Uint8ArrayPrototype = Uint8Array$1 && Uint8Array$1.prototype || {};
var arrayToString = [].toString;
var join3 = uncurryThis([].join);
if (fails(function() {
  arrayToString.call({});
})) {
  arrayToString = function toString4() {
    return join3(this);
  };
}
var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;
exportTypedArrayMethod("toString", arrayToString, IS_NOT_ARRAY_METHOD);
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = function __decorateClass34(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
var BlobConverter = /* @__PURE__ */ function() {
  function BlobConverter2() {
    _classCallCheck(this, BlobConverter2);
  }
  _createClass(BlobConverter2, [{
    key: "serialize",
    value: function serialize(data2) {
      if (data2.startsWith("data:") || data2.startsWith("filename:")) {
        var result = /filename:(.*):data/i.exec(data2);
        var fileName;
        if (result && result.length > 1) {
          fileName = result[1];
        }
        var dataParts = data2.split(";base64,");
        var b64Str = dataParts[1];
        var type = dataParts[0].split("data:")[1];
        var blob = this.b64ToBlob(b64Str, type);
        if (fileName) {
          return new File([blob], fileName, {
            type,
            lastModified: +new Date()
          });
        }
        return blob;
      }
      return "";
    }
  }, {
    key: "deserialize",
    value: function deserialize(data2) {
      return data2;
    }
  }, {
    key: "b64ToBlob",
    value: function b64ToBlob(data2, type) {
      var byteCharacters = atob(data2);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[+i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], {
        type
      });
    }
  }]);
  return BlobConverter2;
}();
BlobConverter = __decorateClass$4([JsonConverter], BlobConverter);
function _createSuper$4(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$4();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$4() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = function __decorateClass35(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
var WhiteLabelListSummaryResultEntity = /* @__PURE__ */ _createClass(function WhiteLabelListSummaryResultEntity2() {
  _classCallCheck(this, WhiteLabelListSummaryResultEntity2);
  this.company_help_email = null;
  this.default_from_email = "";
  this.id = 0;
  this.logo1 = null;
  this.logo2 = null;
  this.logo3 = null;
  this.name = "";
});
__decorateClass$3([JsonProperty("company_help_email", StringifyStringConverter, true)], WhiteLabelListSummaryResultEntity.prototype, "company_help_email", 2);
__decorateClass$3([JsonProperty("default_from_email", StringifyStringConverter)], WhiteLabelListSummaryResultEntity.prototype, "default_from_email", 2);
__decorateClass$3([JsonProperty("id", Number, true)], WhiteLabelListSummaryResultEntity.prototype, "id", 2);
__decorateClass$3([JsonProperty("logo1", BlobConverter, true)], WhiteLabelListSummaryResultEntity.prototype, "logo1", 2);
__decorateClass$3([JsonProperty("logo2", BlobConverter, true)], WhiteLabelListSummaryResultEntity.prototype, "logo2", 2);
__decorateClass$3([JsonProperty("logo3", BlobConverter, true)], WhiteLabelListSummaryResultEntity.prototype, "logo3", 2);
__decorateClass$3([JsonProperty("name", String)], WhiteLabelListSummaryResultEntity.prototype, "name", 2);
WhiteLabelListSummaryResultEntity = __decorateClass$3([JsonObject("WhiteLabelListSummaryResultEntity")], WhiteLabelListSummaryResultEntity);
var WhiteLabelListSummaryResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(WhiteLabelListSummaryResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$4(WhiteLabelListSummaryResponseEntity2);
  function WhiteLabelListSummaryResponseEntity2() {
    var _this;
    _classCallCheck(this, WhiteLabelListSummaryResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(WhiteLabelListSummaryResponseEntity2);
}(GenericResponseEntity);
__decorateClass$3([JsonProperty("results", [WhiteLabelListSummaryResultEntity])], WhiteLabelListSummaryResponseEntity.prototype, "results", 2);
WhiteLabelListSummaryResponseEntity = __decorateClass$3([JsonObject("WhiteLabelListSummaryResponseEntity")], WhiteLabelListSummaryResponseEntity);
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = function __decorateClass36(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
var ThemeConfigEntity = /* @__PURE__ */ _createClass(function ThemeConfigEntity2() {
  _classCallCheck(this, ThemeConfigEntity2);
  this.auxColor = "";
  this.errorColor = "";
  this.primaryColor = "";
  this.secondaryColor = "";
  this.successColor = "";
  this.tertiaryColor = "";
  this.warningColor = "";
});
__decorateClass$2([JsonProperty("auxColor", String)], ThemeConfigEntity.prototype, "auxColor", 2);
__decorateClass$2([JsonProperty("errorColor", String)], ThemeConfigEntity.prototype, "errorColor", 2);
__decorateClass$2([JsonProperty("primaryColor", String)], ThemeConfigEntity.prototype, "primaryColor", 2);
__decorateClass$2([JsonProperty("secondaryColor", String)], ThemeConfigEntity.prototype, "secondaryColor", 2);
__decorateClass$2([JsonProperty("successColor", String)], ThemeConfigEntity.prototype, "successColor", 2);
__decorateClass$2([JsonProperty("tertiaryColor", String)], ThemeConfigEntity.prototype, "tertiaryColor", 2);
__decorateClass$2([JsonProperty("warningColor", String)], ThemeConfigEntity.prototype, "warningColor", 2);
ThemeConfigEntity = __decorateClass$2([JsonObject("ThemeConfigEntity")], ThemeConfigEntity);
var UrlConfigEntity = /* @__PURE__ */ _createClass(function UrlConfigEntity2() {
  _classCallCheck(this, UrlConfigEntity2);
  this.api_url = "";
  this.media_url = "";
  this.web_url = "";
});
__decorateClass$2([JsonProperty("api_url", String, true)], UrlConfigEntity.prototype, "api_url", 2);
__decorateClass$2([JsonProperty("media_url", String, true)], UrlConfigEntity.prototype, "media_url", 2);
__decorateClass$2([JsonProperty("web_url", String, true)], UrlConfigEntity.prototype, "web_url", 2);
UrlConfigEntity = __decorateClass$2([JsonObject("UrlConfigEntity")], UrlConfigEntity);
var AdminPermissionsEntity = /* @__PURE__ */ _createClass(function AdminPermissionsEntity2() {
  _classCallCheck(this, AdminPermissionsEntity2);
  this.id = 0;
  this.permission_live_chat = false;
  this.permission_view_dynamic_forms = false;
  this.permission_view_on_demand_instructions = false;
  this.permission_view_reports = false;
  this.permission_view_templates = false;
  this.permission_view_utilities = false;
  this.permission_view_work_orders = false;
  this.white_label = 0;
});
__decorateClass$2([JsonProperty("id", Number, true)], AdminPermissionsEntity.prototype, "id", 2);
__decorateClass$2([JsonProperty("permission_live_chat", Boolean)], AdminPermissionsEntity.prototype, "permission_live_chat", 2);
__decorateClass$2([JsonProperty("permission_view_dynamic_forms", Boolean)], AdminPermissionsEntity.prototype, "permission_view_dynamic_forms", 2);
__decorateClass$2([JsonProperty("permission_view_on_demand_instructions", Boolean)], AdminPermissionsEntity.prototype, "permission_view_on_demand_instructions", 2);
__decorateClass$2([JsonProperty("permission_view_reports", Boolean)], AdminPermissionsEntity.prototype, "permission_view_reports", 2);
__decorateClass$2([JsonProperty("permission_view_templates", Boolean)], AdminPermissionsEntity.prototype, "permission_view_templates", 2);
__decorateClass$2([JsonProperty("permission_view_utilities", Boolean)], AdminPermissionsEntity.prototype, "permission_view_utilities", 2);
__decorateClass$2([JsonProperty("permission_view_work_orders", Boolean)], AdminPermissionsEntity.prototype, "permission_view_work_orders", 2);
__decorateClass$2([JsonProperty("white_label", Number, true)], AdminPermissionsEntity.prototype, "white_label", 2);
AdminPermissionsEntity = __decorateClass$2([JsonObject("AdminPermissionsEntity")], AdminPermissionsEntity);
var WhiteLabelListCompleteResultEntity = /* @__PURE__ */ function(_WhiteLabelListSummar) {
  _inherits(WhiteLabelListCompleteResultEntity2, _WhiteLabelListSummar);
  var _super = _createSuper$3(WhiteLabelListCompleteResultEntity2);
  function WhiteLabelListCompleteResultEntity2() {
    var _this;
    _classCallCheck(this, WhiteLabelListCompleteResultEntity2);
    _this = _super.apply(this, arguments);
    _this.theme_config = new ThemeConfigEntity();
    _this.url_config = new UrlConfigEntity();
    _this.admin_permissions = new AdminPermissionsEntity();
    _this.default_account_permissions = new AccountPermissionsEntity();
    return _this;
  }
  return _createClass(WhiteLabelListCompleteResultEntity2);
}(WhiteLabelListSummaryResultEntity);
__decorateClass$2([JsonProperty("theme_config", StringifyThemeConfigConverter)], WhiteLabelListCompleteResultEntity.prototype, "theme_config", 2);
__decorateClass$2([JsonProperty("url_config", StringifyUrlConfigConverter, true)], WhiteLabelListCompleteResultEntity.prototype, "url_config", 2);
__decorateClass$2([JsonProperty("admin_permissions", StringifyAdminPermissionsConverter)], WhiteLabelListCompleteResultEntity.prototype, "admin_permissions", 2);
__decorateClass$2([JsonProperty("default_account_permissions", StringifyDefaultAccountPermissionsConverter)], WhiteLabelListCompleteResultEntity.prototype, "default_account_permissions", 2);
WhiteLabelListCompleteResultEntity = __decorateClass$2([JsonObject("WhiteLabelListCompleteResultEntity")], WhiteLabelListCompleteResultEntity);
var WhiteLabelListCompleteResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(WhiteLabelListCompleteResponseEntity2, _GenericResponseEntit);
  var _super2 = _createSuper$3(WhiteLabelListCompleteResponseEntity2);
  function WhiteLabelListCompleteResponseEntity2() {
    var _this2;
    _classCallCheck(this, WhiteLabelListCompleteResponseEntity2);
    _this2 = _super2.apply(this, arguments);
    _this2.results = [];
    return _this2;
  }
  return _createClass(WhiteLabelListCompleteResponseEntity2);
}(GenericResponseEntity);
__decorateClass$2([JsonProperty("results", [WhiteLabelListCompleteResultEntity])], WhiteLabelListCompleteResponseEntity.prototype, "results", 2);
WhiteLabelListCompleteResponseEntity = __decorateClass$2([JsonObject("WhiteLabelListCompleteResponseEntity")], WhiteLabelListCompleteResponseEntity);
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = function __decorateClass37(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
var WhiteLabelListEssentialResultEntity = /* @__PURE__ */ _createClass(function WhiteLabelListEssentialResultEntity2() {
  _classCallCheck(this, WhiteLabelListEssentialResultEntity2);
  this.admin_permissions = 0;
  this.default_account_permissions = 0;
  this.id = 0;
  this.name = "";
});
__decorateClass$1([JsonProperty("admin_permissions", Number, true)], WhiteLabelListEssentialResultEntity.prototype, "admin_permissions", 2);
__decorateClass$1([JsonProperty("default_account_permissions", Number, true)], WhiteLabelListEssentialResultEntity.prototype, "default_account_permissions", 2);
__decorateClass$1([JsonProperty("id", Number)], WhiteLabelListEssentialResultEntity.prototype, "id", 2);
__decorateClass$1([JsonProperty("name", String)], WhiteLabelListEssentialResultEntity.prototype, "name", 2);
WhiteLabelListEssentialResultEntity = __decorateClass$1([JsonObject("WhiteLabelListEssentialResultEntity")], WhiteLabelListEssentialResultEntity);
var WhiteLabelListEssentialResponseEntity = /* @__PURE__ */ function(_GenericResponseEntit) {
  _inherits(WhiteLabelListEssentialResponseEntity2, _GenericResponseEntit);
  var _super = _createSuper$2(WhiteLabelListEssentialResponseEntity2);
  function WhiteLabelListEssentialResponseEntity2() {
    var _this;
    _classCallCheck(this, WhiteLabelListEssentialResponseEntity2);
    _this = _super.apply(this, arguments);
    _this.results = [];
    return _this;
  }
  return _createClass(WhiteLabelListEssentialResponseEntity2);
}(GenericResponseEntity);
__decorateClass$1([JsonProperty("results", [WhiteLabelListEssentialResultEntity])], WhiteLabelListEssentialResponseEntity.prototype, "results", 2);
WhiteLabelListEssentialResponseEntity = __decorateClass$1([JsonObject("WhiteLabelListEssentialResponseEntity")], WhiteLabelListEssentialResponseEntity);
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass38 = function __decorateClass39(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
var WhiteLabelGetResponseEntity = /* @__PURE__ */ function(_WhiteLabelListComple) {
  _inherits(WhiteLabelGetResponseEntity2, _WhiteLabelListComple);
  var _super = _createSuper$1(WhiteLabelGetResponseEntity2);
  function WhiteLabelGetResponseEntity2() {
    _classCallCheck(this, WhiteLabelGetResponseEntity2);
    return _super.apply(this, arguments);
  }
  return _createClass(WhiteLabelGetResponseEntity2);
}(WhiteLabelListCompleteResultEntity);
WhiteLabelGetResponseEntity = __decorateClass38([JsonObject("WhiteLabelGetResponseEntity")], WhiteLabelGetResponseEntity);
var WhiteLabelUrls = {
  whiteLabels: "/api/2.0/whitelabels/",
  whiteLabelId: "/api/2.0/whitelabels/{id}/"
};
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp16 = function __defNormalProp17(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues16 = function __spreadValues17(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop))
      __defNormalProp16(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop))
          __defNormalProp16(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps13 = function __spreadProps14(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var WHITE_LABEL_CACHE_KEYS = {
  list: "white-label",
  filter: "white-label-filter",
  get: function get5(id2) {
    return "white-label__".concat(id2);
  }
};
var WhiteLabelDm = /* @__PURE__ */ function(_DmLeonardo) {
  _inherits(WhiteLabelDm2, _DmLeonardo);
  var _super = _createSuper(WhiteLabelDm2);
  function WhiteLabelDm2() {
    var _this;
    var setup = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _classCallCheck(this, WhiteLabelDm2);
    _this = _super.call(this, setup);
    _this.logger.label = "dm-white-label";
    return _this;
  }
  _createClass(WhiteLabelDm2, [{
    key: "getWhiteLabelsList",
    value: function getWhiteLabelsList(params) {
      var _this2 = this;
      var url = WhiteLabelUrls.whiteLabels;
      var finalParams = this.parseGenericParams(__spreadProps13(__spreadValues16({}, params), {
        modifier: "complete"
      }));
      return this._client.get({
        url,
        params: finalParams,
        cache: WHITE_LABEL_CACHE_KEYS.list
      }).then(function(_ref) {
        var data2 = _ref.data;
        return _this2._jsonConvert.deserializeObject(data2, WhiteLabelListCompleteResponseEntity);
      }).catch(function(e) {
        _this2.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "getWhiteLabelsAsFilter",
    value: function getWhiteLabelsAsFilter() {
      return this.getAsGenericFilter(WhiteLabelUrls.whiteLabels, WHITE_LABEL_CACHE_KEYS.filter, WhiteLabelListEssentialResponseEntity);
    }
  }, {
    key: "getWhiteLabel",
    value: function getWhiteLabel(id2) {
      var _this3 = this;
      var url = WhiteLabelUrls.whiteLabelId;
      return this._client.get({
        url,
        path: {
          id: id2
        },
        cache: WHITE_LABEL_CACHE_KEYS.get(id2)
      }).then(function(_ref2) {
        var data2 = _ref2.data;
        return _this3._jsonConvert.deserializeObject(data2, WhiteLabelGetResponseEntity);
      }).catch(function(e) {
        _this3.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "deleteWhiteLabel",
    value: function deleteWhiteLabel(id2) {
      var _this4 = this;
      var url = WhiteLabelUrls.whiteLabelId;
      return this._client.delete({
        url,
        path: {
          id: id2
        },
        cacheReset: new RegExp("^".concat(WHITE_LABEL_CACHE_KEYS.list, ".*"))
      }).then(function(_ref3) {
        var data2 = _ref3.data;
        return data2;
      }).catch(function(e) {
        _this4.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "createWhiteLabel",
    value: function createWhiteLabel(content) {
      var _this5 = this;
      var postData = this.parseContent(content);
      var url = WhiteLabelUrls.whiteLabels;
      return this._client.post({
        url,
        cacheReset: WHITE_LABEL_CACHE_KEYS.list
      }, postData, {
        "Content-Type": "multipart/form-data"
      }).then(function(_ref4) {
        var data2 = _ref4.data;
        return _this5._jsonConvert.deserializeObject(data2, WhiteLabelGetResponseEntity);
      }).catch(function(e) {
        _this5.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "updateWhiteLabel",
    value: function updateWhiteLabel(id2, content) {
      var _this6 = this;
      var postData = this.parseContent(content);
      var url = WhiteLabelUrls.whiteLabelId;
      return this._client.put({
        url,
        path: {
          id: id2
        },
        cacheReset: WHITE_LABEL_CACHE_KEYS.get(id2)
      }, postData, {
        "Content-Type": "multipart/form-data"
      }).then(function(_ref5) {
        var data2 = _ref5.data;
        return _this6._jsonConvert.deserializeObject(data2, WhiteLabelGetResponseEntity);
      }).catch(function(e) {
        _this6.logger.error(e);
        throw e;
      });
    }
  }, {
    key: "parseContent",
    value: function parseContent(content) {
      var entity = this._jsonConvert.serializeObject(content, WhiteLabelListCompleteResultEntity);
      delete entity.id;
      return toFormData(entity);
    }
  }]);
  return WhiteLabelDm2;
}(DmLeonardo);
function useWhiteLabelDm(jwt) {
  var config = useMemo(function() {
    return {
      headers: generateAuthHeader(jwt)
    };
  }, [jwt]);
  var Api = useMemo(function() {
    return new WhiteLabelDm(config);
  }, [config]);
  return {
    getWhiteLabelsList: useCallback(function(params) {
      return Api.getWhiteLabelsList(params);
    }, [Api]),
    getWhiteLabelsAsFilter: useCallback(function() {
      return Api.getWhiteLabelsAsFilter();
    }, [Api]),
    getWhiteLabel: useCallback(function(id2) {
      return Api.getWhiteLabel(id2);
    }, [Api]),
    createWhiteLabel: useCallback(function(params) {
      return Api.createWhiteLabel(params);
    }, [Api]),
    updateWhiteLabel: useCallback(function(id2, params) {
      return Api.updateWhiteLabel(id2, params);
    }, [Api]),
    deleteWhiteLabel: useCallback(function(id2) {
      return Api.deleteWhiteLabel(id2);
    }, [Api])
  };
}
export {AccountEssentialWhiteLabelEntity, AccountGetResponseEntity, AccountListCompleteResponseEntity, AccountListCompleteResultEntity, AccountListEssentialResponseEntity, AccountListEssentialResultEntity, AccountListSummaryResponseEntity, AccountListSummaryResultEntity, AccountPermissionsEntity, AccountSummaryWhiteLabelEntity, AccountUserEntity, AccountUsersEntity, AdminPermissionsEntity, CategoryEntity, CountryEntity, CountryResponseEntity, CountryResultEntity, DuplicatePropertiesEssentialResponseEntity, DuplicatePropertiesEssentialResultEntity, DuplicatePropertyAccountEntity, EditableRoleEntity, GenericResponseEntity, GroupCompletePortfolioEntity, GroupCompletePropertyEntity, GroupEntity, GroupSummaryPortfolioEntity, GroupSummaryPropertyEntity, GroupsListCompleteResponseEntity, GroupsListCompleteResultEntity, GroupsListEssentialResponseEntity, GroupsListEssentialResultEntity, GroupsListSummaryResponseEntity, GroupsListSummaryResultEntity, ManagedByMeEntity, ManagedToMeEntity, MergeUnisDuplicatesGetResponseEntity, MergeUnitsDuplicatesEssentialResponseEntity, MergeUnitsDuplicatesEssentialResultEntity, MergeUnitsHistoryResponseEntity, MergeUnitsHistoryResultEntity, MergeUnitsHistoryUnitEntity, MergeUnitsHistoryUnitTypeEntity, OwnerEntity, PartialUserEntity, PortfolioEntity, PortfolioGroupEntity, PortfolioSummaryGroupEntity, PortfoliosListCompleteResponseEntity, PortfoliosListCompleteResultEntity, PortfoliosListEssentialResponseEntity, PortfoliosListEssentialResultEntity, PortfoliosListSummaryResponseEntity, PortfoliosListSummaryResultEntity, PropertiesListEssentialResponseEntity, PropertiesListEssentialResultEntity, PropertiesListSummaryResponseEntity, PropertiesListSummaryResultEntity, PropertyEntity, RoleEntity, RolesListCompleteResponseEntity, RolesListCompleteResultEntity, RolesListEssentialResponseEntity, RolesListEssentialResultEntity, RolesListSummaryResponseEntity, RolesListSummaryResultEntity, SectorResponseEntity, SectorResultEntity, SummaryAccountUsersEntity, SummaryRoleEntity, ThemeConfigEntity, UnitEssentialResponseEntity, UnitEssentialResultEntity, UnitListCompleteResponseEntity, UnitListCompleteResultEntity, UnitListSummaryResponseEntity, UnitListSummaryResultEntity, UnitTypeCompleteEntity, UnitTypeSummaryEntity, UrlConfigEntity, UserEntity, UserPortfolioEntity, UserPropertyEntity, UsersListCompleteResponseEntity, UsersListCompleteResultEntity, UsersListEssentialResponseEntity, UsersListEssentialResultEntity, UsersListSummaryResponseEntity, UsersListSummaryResultEntity, VisibleRoleEntity, WhiteLabelEntity, WhiteLabelGetResponseEntity, WhiteLabelListCompleteResponseEntity, WhiteLabelListCompleteResultEntity, WhiteLabelListEssentialResponseEntity, WhiteLabelListEssentialResultEntity, WhiteLabelListSummaryResponseEntity, WhiteLabelListSummaryResultEntity, WhiteLabelRoleEntity, useAccountDm, useCountryDm, useGroupListDm, useMergeUnitsDm, usePortfolioDm, usePropertyDm, useRolesListDm, useSectorDm, useUnitDm, useUserListDm, useWhiteLabelDm};
